/* ============================================================
   wup.js  -  /pages/userprofile
   All behaviour for the returning-customer hub. Config and copy arrive from
   the section as JSON in #wup-boot, the same pattern as wofp-boot.

   THE PROFILE MODEL
     wyn_dogs        the roster this page owns {v, primaryId, activeId, list[]}
     wyn_dog(_x)     the single-dog bus every OTHER surface reads, unchanged
     wyn_dog_pic_ID  RETIRED 2026-08-12, purged on load; stickers replaced it
                     every surface wholesale-rewrites that object
   The ACTIVE dog is mirrored into the bus via wynProfile.set(), which merges,
   so portion and anything else this page does not own survives untouched.
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('wup');
  if (!root) return;

  var BOOT = {};
  try { var tg = document.getElementById('wup-boot'); if (tg) BOOT = JSON.parse(tg.textContent || '{}'); }
  catch (e) { BOOT = {}; }
  var C = BOOT.c || {}, ORDER_AT = BOOT.orderAt || '';
  var cartCents = 0;
  /* what the Reorder button last SENT, as vid:qty pairs. While the box still
     matches it the button stays down and reads "Added", so a second tap
     cannot double the order. Any quantity change re-arms it. */
  var sentSnap = '';
  /* and PER VARIANT, what has already gone to the cart from this page, so a
     second press after a change sends only the DIFFERENCE (2026-10-31). Before,
     bumping 3 to 4 after "Added" re-sent the whole box and the cart held 7. */
  var sentQ = {};
  function sentFor(vid) { return parseInt(sentQ[String(vid)], 10) || 0; }
  var FREE = BOOT.free || 0, FLAT = BOOT.flat || 0;
  /* FIRST BOX: a customer with no orders gets wup-first.liquid instead of a
     last box. Its words arrive in #wup-first-boot; no element, no first-box mode. */
  var FIRST = null;
  try { var fb = document.getElementById('wup-first-boot'); if (fb && root.querySelector('[data-wup-first]')) FIRST = JSON.parse(fb.textContent || '{}'); }
  catch (e) { FIRST = null; }
  if (FIRST) root.classList.add('is-first');
  /* BIRTHDAYS (2026-11-01): the words and the field live in wup-bday.liquid,
     because the section has no room left. No element, no birthday field: the
     dog keeps its old age answer and nothing else changes. */
  var BD = null;
  try { var bdb = document.getElementById('wup-bday-boot'); if (bdb) BD = JSON.parse(bdb.textContent || '{}'); }
  catch (e) { BD = null; }
  var BDC = (BD && BD.c) || {};
  var LS_ROSTER = 'wyn_dogs', LS_PIC = 'wyn_dog_pic_', ROSTER_V = 1;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }
  /* THE ACCOUNT HAS FIVE DOG SLOTS (2026-08-15). The section publishes the
     number; a boot without it (signed out, old section) still stops at 5. */
  function maxDogs() { var n = parseInt(BOOT.maxDogs, 10); return (n >= 1 && n <= 10) ? n : 5; }
  function lines() { return Array.prototype.slice.call(root.querySelectorAll('[data-wup-line]')); }
  function boxSnap() {
    return lines().map(function (li) {
      return li.dataset.vid + ':' + (parseInt(li.dataset.qty, 10) || 0);
    }).join(',');
  }
  /* One reader of /cart.js for everyone: boot, after a reorder lands, and on
     a bfcache return from checkout. Unlike the old boot-only fetch this
     accepts a total of ZERO, because an emptied cart is exactly the signal
     that the last send was checked out - the guard re-arms. */
  function syncCart() {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          adoptCartDog(j);
          var t = j && parseInt(j.total_price, 10);
          if (isFinite(t) && t >= 0) {
            cartCents = t;
            if (t === 0) { sentSnap = ''; sentQ = {}; }
            paint();
          }
        })
        .catch(function () {});
    } catch (e) {}
  }
  /* FIRST BOX: the slideout cart asks for the dog's name and weight and keeps
     them on the CART (attributes "Dog Name" / "Dog Weight"), not in this
     browser's dog profile. A customer with no dog on the account gets that
     dog here, into the one unnamed roster dog only - never over a named one. */
  var cartDogName = '';
  function adoptCartDog(j) {
    if (!FIRST || !R || !j || !j.attributes) return;
    var nm = String(j.attributes['Dog Name'] || '').trim().slice(0, 40);
    if (/^(none|n\/a|na|null|-|undefined)$/i.test(nm)) nm = '';
    var wt = num(j.attributes['Dog Weight']);
    cartDogName = nm;
    var d = active();
    if (!d || d.slot || d.status === 'memorial') return;
    var moved = false;
    if (nm && !String(d.name || '').trim()) { d.name = nm; moved = true; }
    if (wt !== null && wt > 0 && d.weight_lb == null) { d.weight_lb = Math.min(250, Math.max(2, wt)); moved = true; }
    if (moved) { saveRoster(); mirror(); if (typeof loadForm === 'function' && dogBox) loadForm(); paint(); }
  }

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

  /* ---- contrast: pillInk() lifted from the #wof Our Food block ----
     Three-way, not a threshold. A threshold flips beef and cardiac to cream. */
  function relLum(h) {
    var v = [1, 3, 5].map(function (i) {
      var c = parseInt(h.substr(i, 2), 16) / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
  }
  function contrast(a, b) {
    var l1 = relLum(a), l2 = relLum(b), t;
    if (l2 > l1) { t = l1; l1 = l2; l2 = t; }
    return (l1 + 0.05) / (l2 + 0.05);
  }
  function pillInk(h) {
    if (!/^#[0-9a-f]{6}$/i.test(h || '')) return null;
    if (contrast(h, '#2E2E2E') >= 4.5) return '#2E2E2E';
    var d = contrast(h, '#1A1A1A');
    return (d >= 3 || d >= contrast(h, '#FDFAE4')) ? '#1A1A1A' : '#FDFAE4';
  }
  function paintInk(scope) {
    Array.prototype.forEach.call((scope || root).querySelectorAll('[style*="--c"]'), function (el) {
      var pi = pillInk((el.style.getPropertyValue('--c') || '').trim());
      if (pi) el.style.setProperty('--pi', pi);
    });
  }

  /* ============================================================ ROSTER */
  var R = null, mirroring = false;

  function newId() { return 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function blankDog(n) {
    return { id: newId(), name: n || '', colour: '', icon: '', weight_lb: null,
             age: null, ageMonths: null, activity: null, neuter: null, status: 'active', since: '',
             slot: null, likes: [], sync: '', bday: '' };
  }
  function normDog(d) {
    var b = blankDog();
    if (!d || typeof d !== 'object') return b;
    if (typeof d.id === 'string' && d.id) b.id = d.id;
    b.name = d.name == null ? '' : String(d.name).slice(0, 40);
    b.colour = /^#[0-9a-f]{6}$/i.test(d.colour || '') ? d.colour : '';
    b.icon = d.icon == null ? '' : String(d.icon).slice(0, 40);
    b.weight_lb = num(d.weight_lb);
    if (b.weight_lb !== null) b.weight_lb = Math.min(250, Math.max(2, b.weight_lb));
    b.age = num(d.age);
    b.activity = num(d.activity);
    b.neuter = (d.neuter === 'intact' || d.neuter === 'neutered') ? d.neuter : null;
    b.status = d.status === 'memorial' ? 'memorial' : 'active';
    b.since = typeof d.since === 'string' ? d.since.slice(0, 20) : '';
    b.likes = [];
    if (Object.prototype.toString.call(d.likes) === '[object Array]') {
      d.likes.forEach(function (h) {
        h = String(h || '').trim().toLowerCase();
        if (h && b.likes.indexOf(h) === -1) b.likes.push(h);
      });
    }
    var sl = num(d.slot);
    b.slot = (sl !== null && sl >= 1 && sl <= maxDogs()) ? sl : null;
    b.ageMonths = num(d.ageMonths);
    b.bday = bdClean(d.bday);
    /* SYNC STATE (2026-10-22). '' = the account holds this dog as shown;
       'pending' = a change made here has not reached the account yet.
       A roster saved before this field existed is 'legacy': adoptAccount
       decides once whether it differs from the account and needs sending. */
    b.sync = d.sync === 'pending' ? 'pending' : (d.sync === undefined ? 'legacy' : '');
    return b;
  }
  function byId(r, id) {
    for (var i = 0; i < r.list.length; i++) if (r.list[i].id === id) return r.list[i];
    return null;
  }
  /* Every invariant lives here so no caller has to remember them: a primary and
     an active always exist, NEITHER IS EVER A MEMORIAL DOG, roster never empty. */
  /* primary prefers a dog the account actually knows */
  function bestPrimary(list) {
    var slotted = list.filter(function (d) { return d.status !== 'memorial' && d.slot; });
    if (slotted.length) return slotted[0].id;
    var namedd = list.filter(function (d) { return d.status !== 'memorial' && String(d.name || '').trim(); });
    if (namedd.length) return namedd[0].id;
    var live = list.filter(function (d) { return d.status !== 'memorial'; });
    return live.length ? live[0].id : '';
  }

  function fix(r) {
    var live = r.list.filter(function (d) { return d.status !== 'memorial'; });
    if (!live.length && r.list.length) { r.list[0].status = 'active'; live = [r.list[0]]; }
    var p = byId(r, r.primaryId);
    if (!p || p.status === 'memorial') r.primaryId = bestPrimary(r.list);
    var a = byId(r, r.activeId);
    if (!a || a.status === 'memorial') r.activeId = r.primaryId;
    return r;
  }
  function active() { return R ? byId(R, R.activeId) : null; }
  function living() { return R ? R.list.filter(function (d) { return d.status !== 'memorial'; }) : []; }
  function memorials() { return R ? R.list.filter(function (d) { return d.status === 'memorial'; }) : []; }

  function loadRoster() {
    var o = null;
    try { var raw = lsGet(LS_ROSTER); o = raw ? JSON.parse(raw) : null; } catch (e) { o = null; }
    if (!o || !o.list || !o.list.length) return null;
    var gone = [];
    if (Object.prototype.toString.call(o.gone) === '[object Array]') {
      o.gone.forEach(function (g) {
        var sl2 = g && num(g.slot);
        if (sl2 && g.name) gone.push({ slot: sl2, name: String(g.name).slice(0, 40) });
      });
    }
    return fix({ v: ROSTER_V, list: o.list.map(normDog), gone: gone,
                 primaryId: o.primaryId || '', activeId: o.activeId || '',
                 owner: typeof o.owner === 'string' ? o.owner : '' });
  }
  function saveRoster() {
    if (!R) return;
    fix(R);
    lsSet(LS_ROSTER, JSON.stringify({ v: ROSTER_V, primaryId: R.primaryId,
                                      activeId: R.activeId, list: R.list, gone: R.gone || [],
                                      owner: R.owner || '' }));
    /* anything drawn from the roster outside the dog tab (the Fresh Rx
       request's dog chips) listens for this rather than going stale */
    try { root.dispatchEvent(new CustomEvent('wup:roster')); } catch (e) {}
  }
  /* ---- the account's own vocabulary, converted to ours ---- */
  function actFactor(word) {
    var CFG = window.wynFeed && window.wynFeed.CFG;
    if (!CFG || !CFG.ACTIVITY || !word) return null;
    var k = String(word).trim().toLowerCase();
    return CFG.ACTIVITY[k] != null ? CFG.ACTIVITY[k] : null;
  }
  /* lb (2026-11-02): pass the weight ONLY for a dog with a birthday. Once
     wynfeed.js switches stages by size on, those dogs are fed by size; a dog
     without a birthday always keeps the old bands. */
  function ageFromMonths(m, lb) {
    var CFG = window.wynFeed && window.wynFeed.CFG;
    m = num(m);
    if (m == null || !CFG || !CFG.AGE_BUCKETS) return null;
    if (lb != null && CFG.SIZE_STAGES_ON && typeof window.wynFeed.sizeStageFactor === 'function') {
      var sf = window.wynFeed.sizeStageFactor(m, num(lb));
      if (sf != null) return sf;
    }
    for (var i = 0; i < CFG.AGE_BUCKETS.length; i++) {
      var b = CFG.AGE_BUCKETS[i];
      /* UNDER the max, the same rule as wynFeed.ageFactorFromMonths (2026-11-01).
         It was "at or under", so a dog of exactly 12 months was a puppy here and
         an adult in the feeding library. */
      if (b.max == null || m < b.max) return b.factor;
    }
    return null;
  }
  /* ============================================================ BIRTHDAYS
     2026-11-01. A dog's age is a BIRTHDAY, saved once and counted forward
     every day, instead of a Puppy / Adult / Senior answer that went stale the
     day after it was tapped. One field per dog, custom.dog_N_birthday:
       2020-03-03  the exact day
       2020-03     month and year
       ~2020-03    an estimate WE made (the fill-in, 2026-11-01)
       ~~2020-03   an estimate the OWNER chose ("Not sure?") or kept ("Keep the
                   estimate"). Same age, same food; the second mark only means
                   "never ask this owner for the real date" (2026-11-01).
     Neither estimate ever carries a day.
     PHASE 1 KEEPS THE FEEDING RULES AS THEY ARE: the birthday only supplies the
     months, and the months go through the same bands (ageFromMonths, which
     reads wynFeed.CFG.AGE_BUCKETS). Size-based stages wait for Dr. Laura.
     A dog with no birthday keeps its old answer untouched.
     THE OLD quiz.dog_N_age_in_months IS NEVER WRITTEN FOR A DOG WITH A BIRTHDAY,
     so the account keeps what each dog was before the switch. */
  var BD_RE = /^(~{1,2})?(\d{4})-(\d{2})(?:-(\d{2}))?$/;
  var MO_MS = 30.4375 * 86400000;
  function escH(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function bdDays(y, m) { return new Date(y, m, 0).getDate(); }
  function bdParts(b) {
    var m = BD_RE.exec(String(b == null ? '' : b).trim());
    return m ? { est: !!m[1], own: m[1] === '~~', y: +m[2], m: +m[3], d: m[4] ? +m[4] : 0 } : null;
  }
  function bdClean(v) {
    var p = bdParts(v);
    if (!p || p.m < 1 || p.m > 12 || p.y < 1980) return '';
    if (p.est && p.d) return '';
    if (p.d && (p.d < 1 || p.d > bdDays(p.y, p.m))) return '';
    return (p.own ? '~~' : p.est ? '~' : '') + p.y + '-' + (p.m < 10 ? '0' : '') + p.m + (p.d ? '-' + (p.d < 10 ? '0' : '') + p.d : '');
  }
  /* feeding months are counted from the day; a month-only birthday from the
     15th (the middle of the month); an ESTIMATE from the 1st, because the owner
     gave whole months - "6 months" must feed as 6 months, not 5 and a half */
  function bdMonths(b, now) {
    var p = bdParts(b);
    if (!p) return null;
    return Math.max(0, ((now || new Date()) - new Date(p.y, p.m - 1, p.d || (p.est ? 1 : 15))) / MO_MS);
  }
  /* whole months for the words: an exact day turns on that day, a month-only
     or estimated birthday turns on the 1st of its month */
  function bdWhole(b, now) {
    var p = bdParts(b);
    if (!p) return null;
    now = now || new Date();
    var n = (now.getFullYear() - p.y) * 12 + (now.getMonth() + 1 - p.m);
    if (p.d && now.getDate() < p.d) n--;
    return Math.max(0, n);
  }
  function bdFuture(b, now) {
    var p = bdParts(b);
    if (!p) return false;
    now = now || new Date();
    var ym = now.getFullYear() * 12 + now.getMonth() + 1, bym = p.y * 12 + p.m;
    if (bym !== ym) return bym > ym;
    return !!p.d && p.d > now.getDate();
  }
  function bdTooOld(b) { var w = bdWhole(b); return w != null && w > 300; }
  function applyBday(d) {
    if (!d || !d.bday) return false;
    var m = bdMonths(d.bday);
    if (m == null) return false;
    m = Math.round(m * 10) / 10;
    var f = ageFromMonths(m, d.weight_lb);
    var moved = d.ageMonths !== m || (f != null && d.age !== f);
    d.ageMonths = m;
    if (f != null) d.age = f;
    return moved;
  }
  function bdSay(t, vals) {
    return String(t || '').replace(/\[(\w+)\]/g, function (all, k) { return vals[k] != null ? vals[k] : all; });
  }
  function bdAgeText(b) {
    var p = bdParts(b), w = bdWhole(b);
    if (!p || w == null) return '';
    if (w < 1) return BDC.newborn || 'Brand new';
    if (w < 12) return bdSay(p.est ? (w === 1 ? BDC.aboutMonthOne : BDC.aboutMonths) : (w === 1 ? BDC.monthOne : BDC.months), { n: w });
    var y = Math.floor(w / 12);
    return bdSay(p.est ? (y === 1 ? BDC.aboutYearOne : BDC.aboutYears) : (y === 1 ? BDC.yearOne : BDC.years), { n: y });
  }
  /* the next birthday; estimates show nothing, since that date is invented */
  function bdBadge(b, name) {
    var p = bdParts(b);
    if (!p || p.est) return '';
    var now = new Date(), y = now.getFullYear(), mNow = now.getMonth() + 1, dNow = now.getDate();
    var names = BDC.monthNames || [];
    var mon = names[p.m - 1] || String(p.m);
    if (p.d) {
      if (p.m === mNow && p.d === dNow) return bdSay(BDC.badgeToday, { name: name, n: y - p.y });
      var past = (p.m < mNow) || (p.m === mNow && p.d < dNow);
      var ty = past ? y + 1 : y;
      return bdSay(BDC.badgeDay, { n: ty - p.y, Month: mon, day: p.d });
    }
    var ty2 = p.m < mNow ? y + 1 : y;
    return bdSay(BDC.badgeMonth, { n: ty2 - p.y, Month: mon });
  }

  /* ---- the field, built here so the form and the ask box share it ---- */
  function bdOpts(list, chosen) {
    return list.map(function (o) {
      return '<option value="' + o[0] + '"' + (String(o[0]) === String(chosen) ? ' selected' : '') + '>' + escH(o[1]) + '</option>';
    }).join('');
  }
  function bdFieldHtml(key, withDay) {
    var now = new Date(), y0 = now.getFullYear(), names = BDC.monthNames || [];
    var mo = [['', BDC.month || 'Month']], yr = [['', BDC.year || 'Year']], dy = [['', BDC.day || 'Day']];
    for (var i = 1; i <= 12; i++) mo.push([i, names[i - 1] || String(i)]);
    for (var j = y0; j >= y0 - 26; j--) yr.push([j, String(j)]);
    for (var k = 1; k <= 31; k++) dy.push([k, String(k)]);
    return '<div class="wup-bd__date" data-wup-bd-date>' +
      '<div class="wup-bd__row">' +
      '<select class="wup-bd__sel" id="' + key + '-m" data-wup-bd-in="m" aria-label="' + escH(BDC.month || 'Month') + '">' + bdOpts(mo, '') + '</select>' +
      '<select class="wup-bd__sel wup-bd__sel--y" id="' + key + '-y" data-wup-bd-in="y" aria-label="' + escH(BDC.year || 'Year') + '">' + bdOpts(yr, '') + '</select>' +
      (withDay ? '<select class="wup-bd__sel wup-bd__sel--d" id="' + key + '-d" data-wup-bd-in="d" aria-label="' + escH(BDC.day || 'Day') + '">' + bdOpts(dy, '') + '</select>' : '') +
      '</div></div>' +
      '<div class="wup-bd__est" data-wup-bd-est hidden><div class="wup-bd__row">' +
      '<label class="wup-bd__num"><input type="number" id="' + key + '-ey" min="0" max="25" step="1" inputmode="numeric" data-wup-bd-in="ey"><span>' + escH(BDC.yearsLabel || 'Years') + '</span></label>' +
      '<label class="wup-bd__num"><input type="number" id="' + key + '-em" min="0" max="11" step="1" inputmode="numeric" data-wup-bd-in="em"><span>' + escH(BDC.monthsLabel || 'Months') + '</span></label>' +
      '</div></div>';
  }
  function bdIn(box, k) { var e = box.querySelector('[data-wup-bd-in="' + k + '"]'); return e ? e : { value: '' }; }
  function bdSetMode(box, est) {
    box.dataset.mode = est ? 'est' : 'date';
    var dt = box.querySelector('[data-wup-bd-date]'), es = box.querySelector('[data-wup-bd-est]');
    if (dt) dt.hidden = !!est;
    if (es) es.hidden = !est;
    Array.prototype.forEach.call(box.querySelectorAll('[data-wup-bd-show]'), function (x) {
      x.hidden = (x.dataset.wupBdShow === 'est') !== !!est;
    });
  }
  /* put a stored birthday into a field */
  function bdFill(box, b) {
    var p = bdParts(b);
    bdSetMode(box, !!(p && p.est));
    ['m', 'y', 'd', 'ey', 'em'].forEach(function (k) { bdIn(box, k).value = ''; });
    if (!p) return;
    if (p.est) {
      var w = bdWhole(b);
      bdIn(box, 'ey').value = Math.floor(w / 12);
      bdIn(box, 'em').value = w % 12;
      return;
    }
    bdIn(box, 'm').value = p.m;
    bdIn(box, 'y').value = p.y;
    if (p.d) bdIn(box, 'd').value = p.d;
  }
  /* read a field: { bday, err } where err is '', 'need', 'future' or 'old' */
  function bdRead(box) {
    if (box.dataset.mode === 'est') {
      var ey = bdIn(box, 'ey').value, em = bdIn(box, 'em').value;
      if (String(ey).trim() === '' && String(em).trim() === '') return { bday: '', err: '' };
      var yy = Math.max(0, parseInt(ey, 10) || 0), mm = Math.max(0, parseInt(em, 10) || 0);
      var tot = yy * 12 + mm;
      if (tot > 300) return { bday: '', err: 'old' };
      var now = new Date(), bd = new Date(now.getFullYear(), now.getMonth() - tot, 1);
      return { bday: bdClean('~~' + bd.getFullYear() + '-' + (bd.getMonth() + 1 < 10 ? '0' : '') + (bd.getMonth() + 1)), err: '' };
    }
    var m = parseInt(bdIn(box, 'm').value, 10), y = parseInt(bdIn(box, 'y').value, 10), d = parseInt(bdIn(box, 'd').value, 10);
    if (!m && !y && !d) return { bday: '', err: '' };
    if (!m || !y) return { bday: '', err: 'need' };
    if (d && d > bdDays(y, m)) d = 0;
    var b = bdClean(y + '-' + (m < 10 ? '0' : '') + m + (d ? '-' + (d < 10 ? '0' : '') + d : ''));
    if (!b) return { bday: '', err: 'need' };
    if (bdFuture(b)) return { bday: '', err: 'future' };
    if (bdTooOld(b)) return { bday: '', err: 'old' };
    return { bday: b, err: '' };
  }
  function bdErrText(err, name) {
    if (err === 'future') return BDC.errFuture || '';
    if (err === 'old') return bdSay(BDC.errOld, { name: String(name || '').trim() || C.unnamed || '' });
    if (err === 'need') return BDC.errNeed || '';
    return '';
  }

  function neuFromYesNo(v) {
    var t = String(v == null ? '' : v).trim().toLowerCase();
    if (t === 'yes' || t === 'neutered' || t === 'spayed' || t === 'true') return 'neutered';
    if (t === 'no' || t === 'intact' || t === 'false') return 'intact';
    return null;
  }

  /* `<colour>|<icon>`, and since 2026-10-22 optionally
     `<colour>;passed:<year>|<icon>`. The memorial mark rides in the COLOUR half
     on purpose: the header reads the icon with `split: '|' | last`, so the
     icon half must stay exactly as it was. */
  function parseLook(raw) {
    var out = { colour: '', icon: '', passed: '' };
    var t = String(raw == null ? '' : raw).trim();
    if (!t || /^(none|null|n\/a|-)$/i.test(t)) return out;
    var bits = t.split('|');
    var head = String(bits[0] || '').split(';');
    if (/^#[0-9a-f]{6}$/i.test(String(head[0]).trim())) out.colour = String(head[0]).trim();
    for (var i = 1; i < head.length; i++) {
      var m = /^passed:?(.*)$/i.exec(String(head[i]).trim());
      if (m) out.passed = (m[1] || '').trim() || 'yes';
    }
    var ic = String(bits[1] || '').trim();
    if (ic && ic.toLowerCase() !== 'none') out.icon = ic.slice(0, 40);
    return out;
  }
  function lookWrite(dog) {
    var c = dog.colour || '';
    if (dog.status === 'memorial') c += ';passed:' + (dog.since || String(new Date().getFullYear()));
    return c + '|' + (dog.icon || '');
  }

  /* Build a roster dog from one account slot. */
  function dogFromSlot(s) {
    var d = blankDog(String(s.name || '').trim());
    d.slot = s.n;
    d.weight_lb = num(s.w);
    var mo = num(s.am);
    /* the store reports an unset age as "0"; that is unknown, not a newborn */
    if (mo != null && mo > 0) { d.ageMonths = mo; d.age = ageFromMonths(mo); }
    d.activity = actFactor(s.act);
    d.neuter = neuFromYesNo(s.neu);
    adoptLook(d, s.look);
    var lk = parseLook(s.look);
    if (lk.passed) { d.status = 'memorial'; d.since = lk.passed === 'yes' ? '' : lk.passed; }
    d.likes = tasteParse(s.taste);
    d.bday = bdClean(s.bd);
    applyBday(d);
    return d;
  }

  /* ---- SEEDING A FRESH DEVICE ----
     THE ACCOUNT COMES FIRST. A customer opening a new browser has an empty bus,
     so seeding from the bus alone gave them ONE BLANK DOG and silently lost the
     rest of their pack. Every named slot becomes a roster dog, already claimed
     to its slot, with its colour and sticker. The bus is only a fallback for a
     customer whose dogs were never written to the account. */
  function seedRoster(noBus) {
    var slots = (BOOT.slots || []).filter(function (s) { return String(s.name || '').trim(); });
    if (slots.length) {
      var list = slots.map(dogFromSlot);
      return fix({ v: ROSTER_V, list: list, primaryId: list[0].id, activeId: list[0].id });
    }
    /* after a change of account the bus still holds the LAST person's dog */
    if (noBus) { var nd = blankDog(''); return fix({ v: ROSTER_V, list: [nd], primaryId: nd.id, activeId: nd.id }); }
    /* the quiz app writes the literal "None" into an unset dog_1_name; that is
       no name at all, or every quiz account with no dog meets a dog called None */
    var bn = String(BOOT.dogName || '').trim();
    if (/^(none|n\/a|na|null|-|undefined)$/i.test(bn)) bn = '';
    var d = blankDog(bn);
    try {
      var p = window.wynProfile && window.wynProfile.get();
      if (p) {
        if (p.name) d.name = String(p.name);
        d.weight_lb = num(p.weight_lb);
        d.age = num(p.age);
        d.activity = num(p.activity);
        if (p.neuter === 'intact' || p.neuter === 'neutered') d.neuter = p.neuter;
      }
    } catch (e) {}
    return fix({ v: ROSTER_V, list: [d], primaryId: d.id, activeId: d.id });
  }

  /* ---- GHOSTS ----
     The shared bus holds ONE dog and often has a weight with no name, from the
     calculator or a product page. Seeding from it is right when the account has
     nobody; once the account's real dogs arrive that leftover becomes a phantom
     "Your dog" sitting alongside them, and because it was created first it also
     held PRIMARY.

     Its VALUES are not worthless - a weight typed on the calculator is real - so
     they are merged into the first account dog wherever that dog is blank, and
     only then is the ghost dropped. Nothing a customer entered is thrown away. */
  function pruneGhosts() {
    if (!R) return;
    var named = R.list.filter(function (d) {
      return String(d.name || '').trim() || d.slot;
    });
    if (!named.length) return;
    var ghosts = R.list.filter(function (d) {
      return !String(d.name || '').trim() && !d.slot && d.status !== 'memorial';
    });
    if (!ghosts.length) return;
    var host = named[0];
    ghosts.forEach(function (g) {
      ['weight_lb', 'age', 'ageMonths', 'activity', 'neuter', 'colour', 'icon', 'bday'].forEach(function (k) {
        if ((host[k] === null || host[k] === undefined || host[k] === '') &&
            g[k] !== null && g[k] !== undefined && g[k] !== '') host[k] = g[k];
      });
    });
    var kill = ghosts.map(function (g) { return g.id; });
    R.list = R.list.filter(function (d) { return kill.indexOf(d.id) === -1; });
    if (kill.indexOf(R.primaryId) > -1) R.primaryId = host.id;
    if (kill.indexOf(R.activeId) > -1) R.activeId = host.id;
    saveRoster();
  }

  /* ---- STRAYS (2026-11-01) ----
     A NAMED dog that has no account slot, was never saved and has nothing
     waiting to send. It came from the shared bus (often another account's dog
     on the same computer, or a name typed on another page) before this
     customer had dogs on the account, and nothing ever saved it or removed
     it: found live as a "Ripley" sitting beside a test account's real dogs,
     on that one browser only. Once the account holds a living dog, a stray is
     dropped. Never a memorial, never a dog with a change waiting ('pending'),
     never a dog whose name matches an account slot (claimAll and
     adoptAccount give those their slot first). Returns true when the ACTIVE
     dog was the stray, so the caller can switch the rest of the site over. */
  function pruneStrays() {
    if (!R || !BOOT.ravenOn) return false;
    var hasReal = R.list.some(function (d) { return d.slot && d.status !== 'memorial'; });
    if (!hasReal) return false;
    var strays = R.list.filter(function (d) {
      return !d.slot && d.status !== 'memorial' && d.sync === '' && String(d.name || '').trim();
    });
    if (!strays.length) return false;
    var kill = strays.map(function (d) { return d.id; });
    var wasActive = kill.indexOf(R.activeId) > -1;
    R.list = R.list.filter(function (d) { return kill.indexOf(d.id) === -1; });
    if (kill.indexOf(R.primaryId) > -1) R.primaryId = '';
    if (wasActive) R.activeId = '';
    saveRoster();
    return wasActive;
  }

  function nameKey(v) { return String(v || '').trim().toLowerCase(); }
  function slotRec(n) {
    var all = BOOT.slots || [];
    for (var i = 0; i < all.length; i++) if (all[i].n === n) return all[i];
    return null;
  }

  /* THE ACCOUNT IS THE SOURCE OF TRUTH (2026-10-22). Until now an existing
     roster only filled its BLANKS from the account, so whatever this browser
     held won forever: a change made on a phone never reached the laptop, and
     a laptop that missed a save showed its own version as if it were real.
     Now a dog with nothing waiting to send takes the account's values
     outright. A dog with a change still waiting ('pending') keeps it and
     resends it - that is the only case where this browser knows better. */
  function takeAccount(d, s) {
    var moved = false;
    if (String(s.name || '').trim() && nameKey(s.name) !== nameKey(d.name)) { d.name = String(s.name).trim().slice(0, 40); moved = true; }
    var w = num(s.w);
    if (w !== null && w > 0 && w !== d.weight_lb) { d.weight_lb = Math.min(250, Math.max(2, w)); moved = true; }
    var a = actFactor(s.act);
    if (a !== null && a !== d.activity) { d.activity = a; moved = true; }
    var nu = neuFromYesNo(s.neu);
    if (nu && nu !== d.neuter) { d.neuter = nu; moved = true; }
    var m = num(s.am);
    if (m !== null && m > 0 && m !== d.ageMonths && !d.bday && !bdClean(s.bd)) {
      d.ageMonths = m;
      var af = ageFromMonths(m);
      if (af !== null) d.age = af;
      moved = true;
    }
    if (String(s.look || '').trim()) {
      var lk = parseLook(s.look);
      if (lk.colour !== d.colour) { d.colour = lk.colour; moved = true; }
      if (lk.icon !== d.icon) { d.icon = lk.icon; moved = true; }
      if (lk.passed && d.status !== 'memorial') {
        d.status = 'memorial'; d.since = lk.passed === 'yes' ? (d.since || '') : lk.passed; moved = true;
      } else if (!lk.passed && d.status === 'memorial') { d.status = 'active'; moved = true; }
    }
    var t = tasteParse(s.taste);
    if (t.join(',') !== likes(d).join(',')) { d.likes = t; moved = true; }
    var bd = bdClean(s.bd);
    if (bd && bd !== d.bday) { d.bday = bd; moved = true; }
    return moved;
  }
  /* A browser holding data from BEFORE this version cannot be trusted over the
     account: another device may have saved something newer since (this
     happened on his own record during testing, 2026-10-22). So on any value
     both sides have, the ACCOUNT wins. Only a value the account has never had
     at all - set here during the outage - is sent up. */
  function localOnly(d, s) {
    if (d.status === 'memorial' && !parseLook(s.look).passed) return true;
    var w0 = num(s.w);
    if (d.weight_lb != null && !(w0 > 0)) return true;
    if (d.activity != null && actFactor(s.act) === null) return true;
    if (d.neuter && !neuFromYesNo(s.neu)) return true;
    if (d.age != null && !(num(s.am) > 0)) return true;
    if ((d.colour || d.icon) && !String(s.look || '').trim()) return true;
    if (likes(d).length && !tasteParse(s.taste).length) return true;
    if (d.bday && !bdClean(s.bd)) return true;
    return false;
  }
  function isGone(s) {
    return (R.gone || []).some(function (g) { return g.slot === s.n && nameKey(g.name) === nameKey(s.name); });
  }

  /* Merge the account into an existing roster. */
  function adoptAccount() {
    if (!R) return;
    var moved = false;
    /* a removal is remembered until the account shows that slot empty (or
       holding a different dog), so a failed write cannot resurrect the dog */
    var before = (R.gone || []).length;
    R.gone = (R.gone || []).filter(function (g) {
      var s0 = slotRec(g.slot);
      return s0 && nameKey(s0.name) === nameKey(g.name);
    });
    if (R.gone.length !== before) moved = true;
    var slots = (BOOT.slots || []).filter(function (s) { return String(s.name || '').trim() && !isGone(s); });

    /* a slotted dog whose slot is now EMPTY on the account was removed on
       another device - unless this browser still has a change waiting for it */
    R.list.slice().forEach(function (d) {
      if (!d.slot || d.sync === 'pending' || d.sync === 'legacy') return;
      var s1 = slotRec(d.slot);
      if (!s1 || String(s1.name || '').trim()) return;
      if (R.list.length > 1) { R.list = R.list.filter(function (x) { return x.id !== d.id; }); }
      else { d.slot = null; d.sync = 'pending'; }
      moved = true;
    });

    slots.forEach(function (s) {
      var d = null, i;
      for (i = 0; i < R.list.length; i++) {
        if (R.list[i].slot === s.n) { d = R.list[i]; break; }
      }
      if (!d) {
        var want = String(s.name).trim().toLowerCase();
        for (i = 0; i < R.list.length; i++) {
          if (!R.list[i].slot && String(R.list[i].name || '').trim().toLowerCase() === want) {
            d = R.list[i]; d.slot = s.n; moved = true; break;
          }
        }
      }
      if (!d) { R.list.push(dogFromSlot(s)); moved = true; return; }
      if (d.sync === 'legacy') {
        var keep = localOnly(d, s);
        var wasMemorial = d.status === 'memorial';
        takeAccount(d, s);   /* skips blanks, so local-only values survive it */
        if (wasMemorial && !parseLook(s.look).passed) d.status = 'memorial';
        d.sync = keep ? 'pending' : '';
        moved = true;
        return;
      }
      if (d.sync !== 'pending') { if (takeAccount(d, s)) moved = true; return; }
      if (adoptLook(d, s.look)) moved = true;
      if (!likes(d).length) {
        var t = tasteParse(s.taste);
        if (t.length) { d.likes = t; moved = true; }
      }
      if (d.weight_lb == null && num(s.w) != null) { d.weight_lb = num(s.w); moved = true; }
      if (d.activity == null && actFactor(s.act) != null) { d.activity = actFactor(s.act); moved = true; }
      if (d.neuter == null && neuFromYesNo(s.neu)) { d.neuter = neuFromYesNo(s.neu); moved = true; }
      if (!d.bday && bdClean(s.bd)) { d.bday = bdClean(s.bd); moved = true; }
      if (d.age == null && num(s.am) > 0 && ageFromMonths(s.am) != null) {
        d.age = ageFromMonths(s.am);
        if (num(s.am) != null) d.ageMonths = num(s.am);
        moved = true;
      }
    });
    /* legacy dogs the account has never heard of (a first save that failed) */
    R.list.forEach(function (d) {
      if (d.sync === 'legacy') { d.sync = String(d.name || '').trim() ? 'pending' : ''; moved = true; }
    });
    /* a birthday decides the age, every visit, whatever the account's months say */
    R.list.forEach(function (d) { if (applyBday(d)) moved = true; });
    if (moved) saveRoster();
  }

  /* Before the first mirror, adopt anything the BUS knows that this dog does
     NOT. Without it, a roster seeded before the customer answered neuter on the
     calculator would mirror null straight over their answer and lose it.
     PER FIELD, never all-or-nothing: a value the dog already has is never
     touched, a field it has blank is filled. Same rule as the seed. */
  /* `<colour>|<icon>` off the account, filling only what this dog lacks. */
  function adoptLook(dog, raw) {
    if (!dog || !raw) return false;
    var lk = parseLook(raw);
    var moved = false;
    if (!dog.colour && lk.colour) { dog.colour = lk.colour; moved = true; }
    if (!dog.icon && lk.icon) { dog.icon = lk.icon; moved = true; }
    return moved;
  }

  function reconcile() {
    var d = active();
    if (!d || !window.wynProfile) return;
    var p;
    try { p = window.wynProfile.get(); } catch (e) { return; }
    if (!p) return;
    var moved = false;
    if (!d.name && p.name) { d.name = String(p.name).slice(0, 40); moved = true; }
    if (d.weight_lb == null && num(p.weight_lb) !== null) { d.weight_lb = num(p.weight_lb); moved = true; }
    if (d.age == null && !d.bday && num(p.age) !== null) { d.age = num(p.age); moved = true; }
    if (d.activity == null && num(p.activity) !== null) { d.activity = num(p.activity); moved = true; }
    if (d.neuter == null && (p.neuter === 'intact' || p.neuter === 'neutered')) { d.neuter = p.neuter; moved = true; }
    if (moved) saveRoster();
  }

  /* The ONE place the roster touches the rest of the site. */
  /* clear=true sends the whole dog INCLUDING nulls, which is right when the
     ACTIVE DOG CHANGES: dog B must not inherit dog A's age. clear=false omits
     what this dog does not know, which is right at BOOT: a null there would
     wipe a value another surface legitimately holds. */
  function mirror(clear) {
    var d = active();
    if (!d || !window.wynProfile) return;
    var patch = {};
    if (clear || d.name) patch.name = d.name ? d.name : null;
    if (clear || d.weight_lb != null) patch.weight_lb = d.weight_lb;
    if (clear || d.age != null) patch.age = d.age;
    if (clear || d.activity != null) patch.activity = d.activity;
    if (clear || d.neuter) patch.neuter = d.neuter;
    /* BIRTHDAY (2026-11-01): wynprofile.js derives the age from it on every
       page, so the cart and product pages keep up as the dog grows. A switch to
       a dog without one sends null, or dog B would inherit dog A's birthday. */
    if (clear || d.bday) patch.bday = d.bday || null;
    if (!Object.keys(patch).length) return;
    mirroring = true;
    try { window.wynProfile.set(patch); } catch (e) {}
    mirroring = false;
  }
  /* Records WHY a figure is missing. Without this the UI showed "add a weight"
     to someone who had already entered one, which blames the customer for a
     missing asset or a bad library call. */
  /* ---- the feeding figure ----
     CONFIRMED 2026-08-12 from wynFeed.plan's own source:

         function plan(profile, diet, opts)

     THREE POSITIONAL ARGUMENTS, NOT ONE OBJECT. Passing a single object left
     `diet` defaulted to {}, so kcal computed fine and grams/oz/cups all came
     back 0. Exports are CFG, ageFactorFromMonths, maintenanceKcal, dietFactor,
     plan, fmtOz, fmtCups, roundTo.

     The diet's calorie density is a NUTRITION CONSTANT and is never hardcoded
     here. We load the same diets file the calculator page uses and pass the
     matched entry through OPAQUELY, so its internal field names do not matter
     and there is only ever one source of truth for those numbers. */
  var planWhy = '', planShape = '';
  var DIETS = null, dietsWhy = 'not-loaded', DIET = null, dietsPending = true;
  var dietsFrom = '', dietsTried = [];

  /* Matching the customer's product to a diets.json entry.
     The file's own key is NOT guaranteed to equal the Shopify product handle,
     so this walks nested shapes, compares every plausible label, and falls back
     to a LONGEST-WINS containment test. Longest matters: "renal" is a substring
     of the low-fat renal product handle, and taking the short one would price a
     dog's food against the wrong diet. Anything matched loosely is reported. */
  var dietLabels = [], dietFuzzy = '';

  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  function entryLabels(entry, key) {
    var out = [];
    if (key) out.push(key);
    if (entry && typeof entry === 'object') {
      ['handle', 'id', 'key', 'slug', 'name', 'title', 'diet', 'product_handle'].forEach(function (f) {
        if (entry[f] && typeof entry[f] !== 'object') out.push(entry[f]);
      });
    }
    return out;
  }

  /* diets.json may be an array, an object keyed by handle, or a wrapper with the
     list one level down. Flatten all three into {entry, labels} rows. */
  function flatten(src, key, depth, out) {
    if (!src || depth > 2) return out;
    if (Object.prototype.toString.call(src) === '[object Array]') {
      src.forEach(function (x) { flatten(x, null, depth + 1, out); });
      return out;
    }
    if (typeof src !== 'object') return out;
    var labels = entryLabels(src, key);
    var looksLikeEntry = labels.length > 0 && (src.kcal_per_kg || src.kcalKg || src.kcal_per_cup ||
                          src.kcalCup || src.per_1000kcal || src.type);
    if (looksLikeEntry) { out.push({ entry: src, labels: labels }); return out; }
    var k;
    for (k in src) {
      if (src[k] && typeof src[k] === 'object') flatten(src[k], k, depth + 1, out);
    }
    if (!out.length && labels.length) out.push({ entry: src, labels: labels });
    return out;
  }

  function findDiet() {
    dietFuzzy = '';
    if (!DIETS) return null;
    var rows = flatten(DIETS, null, 0, []);
    dietLabels = [];
    rows.forEach(function (r) { r.labels.forEach(function (l) { dietLabels.push(String(l)); }); });

    var want = [];
    if (BOOT.dietHandle) want.push(norm(BOOT.dietHandle));
    if (BOOT.dietTitle) {
      want.push(norm(BOOT.dietTitle));
      /* "Fresh Rx(R): Digestive" -> "Digestive" */
      want.push(norm(String(BOOT.dietTitle).split(':').pop()));
    }
    want = want.filter(function (w) { return !!w; });
    if (!want.length || !rows.length) return null;

    var i, j, k;
    /* 1. exact, normalised */
    for (i = 0; i < rows.length; i++) {
      for (j = 0; j < rows[i].labels.length; j++) {
        if (want.indexOf(norm(rows[i].labels[j])) > -1) return rows[i].entry;
      }
    }
    /* 2. containment, LONGEST label wins */
    var best = null, bestLen = 0, bestLabel = '';
    for (i = 0; i < rows.length; i++) {
      for (j = 0; j < rows[i].labels.length; j++) {
        var L = norm(rows[i].labels[j]);
        if (L.length < 4) continue;
        for (k = 0; k < want.length; k++) {
          if (want[k].indexOf(L) > -1 || L.indexOf(want[k]) > -1) {
            if (L.length > bestLen) { best = rows[i].entry; bestLen = L.length; bestLabel = rows[i].labels[j]; }
          }
        }
      }
    }
    if (best) dietFuzzy = bestLabel;
    return best;
  }

  function adopt(j, from) {
    DIETS = j;
    dietsPending = false;
    dietsFrom = from;
    try { if (j && !window.wynDiets) window.wynDiets = j; } catch (e) {}
    DIET = findDiet();
    dietsWhy = DIET ? ''
      : ('no-match-for:' + (BOOT.dietHandle || BOOT.dietTitle || '(none)') +
         ' | file has: ' + dietLabels.slice(0, 14).join(', ') +
         (dietLabels.length > 14 ? ' ...' : '') +
         (dietLabels.length ? '' : ' (NO LABELS FOUND - unexpected file shape)'));
    return j;
  }

  function loadDiets() {
    /* If anything on the page already holds the diets, take them synchronously.
       Avoids a network trip and a frame with no figure. */
    if (window.wynDiets) return Promise.resolve(adopt(window.wynDiets, 'window.wynDiets'));

    /* asset_url and file_url resolve DIFFERENT systems (Edit code > Assets vs
       Content > Files) and there is no way to know from Liquid which one holds
       the file. The section emits both for every candidate name; we walk them
       until one returns JSON, then remember which won. */
    var urls = String(BOOT.dietsUrls || '').split(',').filter(function (u) { return !!u; });
    if (!urls.length) { dietsWhy = 'no-url'; dietsPending = false; return Promise.resolve(null); }

    var tried = [];
    function next(i) {
      if (i >= urls.length) {
        dietsPending = false;
        dietsWhy = 'not-found after ' + tried.length + ' urls';
        dietsTried = tried;
        return null;
      }
      return fetch(urls[i], { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (j) {
          if (!j) throw new Error('empty');
          dietsTried = tried;
          return adopt(j, urls[i]);
        })
        .catch(function (e) { tried.push(urls[i] + ' -> ' + e.message); return next(i + 1); });
    }
    return Promise.resolve(next(0));
  }

  function okPlan(p) { return !!(p && p.oz > 0); }

  /* Calories are a property of the DOG. Ounces depend on which diet, which is
     why the profile shows calories: the number does not move when they switch
     food. It also means this tab needs no diets.json at all - only wynfeed.js. */
  /* ---- the shape wynFeed expects ----
     CONFIRMED THE HARD WAY: `plan()` and `maintenanceKcal()` read `ageFactor`
     (or `ageMonths`), NOT `age`. Passing `age` was silently ignored, so every
     figure this page showed was computed as if every dog were an adult - a
     senior read 11% high and a puppy up to 100% high. `age` is sent as well
     because an unknown key costs nothing and a missing one costs correctness. */
  function libProfile(d) {
    if (!d) return null;
    var p = { weight_lb: d.weight_lb, activity: d.activity, neuter: d.neuter };
    if (d.age != null) { p.ageFactor = d.age; p.age = d.age; }
    if (d.ageMonths != null) p.ageMonths = d.ageMonths;
    /* a birthday dog: the factor from today's age and the weight being shown,
       so a weight typed into the form moves the figure across a size line */
    if (d.bday && typeof bdMonths === 'function') {
      var bm = bdMonths(d.bday), bf = bm == null ? null : ageFromMonths(Math.round(bm * 10) / 10, d.weight_lb);
      if (bf != null) { p.ageFactor = bf; p.age = bf; }
    }
    return p;
  }

  var kcalWhy = '';
  function kcalFor(d) {
    if (!d || d.weight_lb == null) { kcalWhy = 'no-weight'; return null; }
    if (!window.wynFeed || typeof window.wynFeed.maintenanceKcal !== 'function') {
      kcalWhy = 'no-wynfeed'; return null;
    }
    var v;
    try {
      v = window.wynFeed.maintenanceKcal(libProfile(d));
    } catch (e) { kcalWhy = 'threw: ' + e.message; return null; }
    if (!(v > 0)) { kcalWhy = 'returned ' + v; return null; }
    kcalWhy = '';
    return Math.round(v);
  }

  /* Never format a number this page does not own. fmtOz/fmtCups/roundTo are
     library exports and carry the house rounding and fraction rules. */
  function oz(v) {
    if (window.wynFeed && typeof window.wynFeed.fmtOz === 'function') {
      try { return window.wynFeed.fmtOz(v); } catch (e) {}
    }
    return String(Math.round(v * 4) / 4);
  }
  function cups(v) {
    if (window.wynFeed && typeof window.wynFeed.fmtCups === 'function') {
      try { return window.wynFeed.fmtCups(v); } catch (e) {}
    }
    return String(Math.round(v * 4) / 4);
  }
  function q4(v) {
    if (window.wynFeed && typeof window.wynFeed.roundTo === 'function') {
      try { return window.wynFeed.roundTo(v, 0.25); } catch (e) {}
    }
    return Math.round(v * 4) / 4;
  }

  function planFor(d) {
    if (!d || d.weight_lb == null) { planWhy = 'no-weight'; planShape = ''; return null; }
    if (!window.wynFeed) { planWhy = 'no-wynfeed'; planShape = ''; return null; }
    if (typeof window.wynFeed.plan !== 'function') { planWhy = 'no-plan-fn'; planShape = ''; return null; }

    var profile = libProfile(d);
    var p;
    try { p = window.wynFeed.plan(profile, DIET || undefined, {}); }
    catch (e) { planWhy = 'plan-threw: ' + e.message; planShape = ''; return null; }

    if (okPlan(p)) {
      planWhy = '';
      planShape = DIET ? ('diet "' + (dietFuzzy || BOOT.dietHandle) + '" from ' + dietsFrom
                          + (dietFuzzy ? ' [loose match]' : '')) : 'library default';
      return p;
    }

    /* NOT tried: passing the diet as a key string. Confirmed from source that
       dietFactor(dietKey) only reads CFG.DIET_FACTORS, a per-diet MER multiplier
       (only "weight + mobility" has one), NOT a calorie density. A key alone can
       never produce ounces, so the diets file is genuinely required. */
    if (!p) { planWhy = 'plan-returned-null'; planShape = ''; return null; }
    planWhy = dietsPending ? 'diets-loading'
      : 'no-oz (diets: ' + (dietsWhy || 'loaded and matched') + ') ' + JSON.stringify(p);
    planShape = '';
    return null;
  }

  /* Photos were removed 2026-08-12. Nothing can read these any more and each
     one is ~25 KB of a limited localStorage budget, so they are cleared once. */
  function purgePics() {
    try {
      var kill = [], i, k;
      for (i = 0; i < localStorage.length; i++) {
        k = localStorage.key(i);
        if (k && k.indexOf(LS_PIC) === 0) kill.push(k);
      }
      kill.forEach(function (x) { try { localStorage.removeItem(x); } catch (e) {} });
    } catch (e) {}
  }
  /* ============================================================ REORDER */
  function dirtyBox() {
    return lines().some(function (li) {
      return li.dataset.orig === undefined || String(li.dataset.qty) !== String(li.dataset.orig);
    });
  }
  function paint() {
    var cents = 0, oz = 0, n = 0, delta = 0;
    lines().forEach(function (li) {
      var q = parseInt(li.dataset.qty, 10) || 0;
      var p = parseInt(li.dataset.price, 10) || 0;
      cents += p * q; n += q;
      delta += p * (q - sentFor(li.dataset.vid));
      /* FOOD IN THE HOUSE is what SHIPPED, so the days strip counts the last
         order's own quantities, not the box being edited (2026-10-31) */
      if (li.dataset.orig !== undefined) oz += (parseFloat(li.dataset.oz) || 0) * (parseInt(li.dataset.orig, 10) || 0);
      li.classList.toggle('is-off', q === 0);
      var e1 = li.querySelector('[data-wup-line-price]');
      if (e1) e1.textContent = q > 0 ? money(p * q) : '';
      var e2 = li.querySelector('[data-wup-qty]');
      if (e2) e2.textContent = q;
    });
    /* THE FROZEN MINIMUM IS GONE. A returning customer's order clears it every
       time, so a bar tracking something that always happens is decoration.
       What remains is the free-shipping line, which is a real lever.

       AND IT COUNTS WHAT IS ALREADY IN THE CART. Summing only the lines on this
       page understated the total for anyone mid-shop, which is exactly the
       customer the nudge is aimed at. cartCents comes from /cart.js; the
       reorder lines are NOT in the cart until they press the button, so adding
       the two together is the checkout total, not a double count. */
    /* While the box matches what was already sent, those lines are IN the
       cart and counting them again would double the bar. */
    var sent = !!sentSnap && sentSnap === boxSnap();
    /* the cart already holds what was sent; only the difference is still to come */
    var whole = cartCents + delta;
    var fill = root.querySelector('[data-wup-min-fill]');
    var mt = root.querySelector('[data-wup-min-t]');
    if (fill) fill.style.width = Math.min(100, FREE ? (whole / FREE) * 100 : 100) + '%';
    if (mt) {
      if (FREE && whole < FREE) {
        mt.textContent = money(FREE - whole) + ' ' + C.minLeft
          + (FLAT ? ('  \u00b7  ' + money(FLAT) + ' ' + C.minFlat) : '');
      } else mt.textContent = C.minOk;
    }
    var bar = root.querySelector('[data-wup-min]');
    if (bar) bar.classList.toggle('is-free', !!(FREE && whole >= FREE));
    var go = root.querySelector('[data-wup-go]');
    if (go) {
      go.disabled = n === 0 || sent;
      var gt = go.querySelector('[data-wup-go-t]');
      if (gt && !busy) gt.textContent = sent ? (C.added || 'Added') : ((FIRST && FIRST.go) || C.reorderGo || gt.textContent);
    }
    var rb = root.querySelector('[data-wup-reset]');
    if (rb) rb.hidden = !dirtyBox();
    var fe = root.querySelector('[data-wup-fempty]');
    if (fe) fe.hidden = lines().length > 0;
    paintFirst();
    days(oz);
    paintBar(n, cents, sent);
  }

  /* THE FOLLOWING BAR (2026-10-31). Tapping a pill in "Add a diet" puts a line
     in the box card, which on a phone is two or three screens UP, and the only
     sign anything happened was the pill fading. This bar sits at the bottom of
     the screen while the Reorder tab is open and the box's own footer is off
     screen: it shows the count and the total, bumps when a pill is tapped, and
     its button is the Reorder button. It hides itself the moment the real
     footer scrolls into view, so there are never two. */
  var bar = null, barSumSeen = false, barIO = null;
  function barEl() {
    if (bar) return bar;
    if (!root.querySelector('[data-wup-go]')) return null;
    bar = document.createElement('div');
    bar.className = 'wup-bar';
    bar.setAttribute('data-wup-bar', '');
    bar.hidden = true;
    bar.innerHTML = '<span class="wup-bar__t"><b data-wup-bar-n></b><span data-wup-bar-p></span></span>' +
      '<button type="button" class="wup-btn wup-bar__go" data-wup-bar-go><span data-wup-bar-go-t></span></button>';
    root.appendChild(bar);
    bar.querySelector('[data-wup-bar-go]').addEventListener('click', function () {
      var go = root.querySelector('[data-wup-go]');
      if (go && !go.disabled) go.click();
    });
    try {
      var sum = root.querySelector('[data-wup-sum]');
      if (sum && 'IntersectionObserver' in window) {
        barIO = new IntersectionObserver(function (es) {
          es.forEach(function (e) { barSumSeen = e.isIntersecting; });
          paintBar();
        }, { threshold: 0.2 });
        barIO.observe(sum);
      }
    } catch (e) { barIO = null; }
    return bar;
  }
  var barN = 0, barCents = 0, barSent = false;
  /* SUBSCRIBERS (2026-10-31, his option 3). Their Reorder tab leads with the
     repeat delivery; the reorder box, the 60-day list and the add shelves wait
     behind one row, "Running low before the next box?", until it is tapped. */
  var topupClosed = false;
  var SUBW = {};
  try { var sbEl = document.getElementById('wup-subs-boot'); SUBW = sbEl ? JSON.parse(sbEl.textContent || '{}') : {}; } catch (e) { SUBW = {}; }
  function topupParts() { return [root.querySelector('.wup-box'), root.querySelector('.wup-cols')].filter(Boolean); }
  function topupOpen() {
    topupClosed = false;
    topupParts().forEach(function (p) { p.hidden = false; });
    var row = root.querySelector('[data-wup-topup]');
    if (row) row.remove();
    paintBar();
  }
  function setupTopup() {
    var sub = root.querySelector('.wup-card--sub');
    if (!sub || root.querySelector('[data-wup-topup]')) return;
    var words = SUBW;
    var parts = topupParts();
    if (!parts.length) return;
    topupClosed = true;
    parts.forEach(function (p) { p.hidden = true; });
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'wup-topup';
    row.setAttribute('data-wup-topup', '');
    row.innerHTML = '<span class="wup-topup__t"><b></b><i></i></span><span class="wup-topup__a" aria-hidden="true">\u2193</span>';
    row.querySelector('b').textContent = words.lowH || 'Running low before the next box?';
    row.querySelector('i').textContent = words.lowP || 'Order extra as a one-off';
    sub.insertAdjacentElement('afterend', row);
    row.addEventListener('click', function () {
      topupOpen();
      var first = parts[0];
      if (first && first.scrollIntoView) first.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }
  setupTopup();
  function paintBar(n, cents, sent) {
    if (n !== undefined) { barN = n; barCents = cents; barSent = !!sent; }
    var b = barEl();
    if (!b) return;
    var onOrder = root.getAttribute('data-wup-on') === 'order' || !root.getAttribute('data-wup-on');
    var go = root.querySelector('[data-wup-go]');
    var show = onOrder && barN > 0 && !barSent && !barSumSeen && !!barIO && !topupClosed;
    b.hidden = !show;
    if (!show) return;
    var nEl = b.querySelector('[data-wup-bar-n]'), pEl = b.querySelector('[data-wup-bar-p]');
    if (nEl) nEl.textContent = barN + ' ' + (barN === 1 ? (C.item || 'item') : (C.items || 'items'));
    if (pEl) pEl.textContent = money(barCents);
    var bg = b.querySelector('[data-wup-bar-go]'), bt = b.querySelector('[data-wup-bar-go-t]');
    var gt = go && go.querySelector('[data-wup-go-t]');
    if (bt) bt.textContent = gt ? gt.textContent : (C.reorderGo || 'Reorder');
    if (bg) bg.disabled = !go || go.disabled;
  }
  function bumpBar() {
    var b = barEl();
    if (!b || b.hidden) return;
    b.classList.remove('is-bump');
    void b.offsetWidth;
    b.classList.add('is-bump');
  }

  /* The dog line on the first-box card: whose box this is and what they eat.
     The account's dog if there is one, otherwise the one typed into the
     slideout cart (it reaches this page through the shared dog profile).
     Built with textContent: the name is customer-typed. */
  function paintFirst() {
    if (!FIRST) return;
    var el2 = root.querySelector('[data-wup-fdog]');
    if (!el2) return;
    var d = active();
    var nm = d && d.status !== 'memorial' ? String(d.name || '').trim() : '';
    el2.textContent = '';
    var a = document.createElement('a');
    a.href = '#dog';
    if (nm) {
      var tag = document.createElement('span');
      tag.className = 'wup-ftag';
      /* "From your cart" only when the name really came from the cart */
      var fromCart = !d.slot && cartDogName && nameKey(cartDogName) === nameKey(nm);
      tag.textContent = fromCart ? (FIRST.tagCart || '') : (FIRST.tagAcct || '');
      el2.appendChild(tag);
      var bits = [nm];
      if (d.weight_lb != null) bits.push(d.weight_lb + ' lb');
      var k = kcalFor(d);
      if (k && FIRST.kcal) bits.push(FIRST.kcal.replace('{n}', k));
      el2.appendChild(document.createTextNode(bits.join(' · ') + ' '));
      a.textContent = FIRST.change || '';
      el2.appendChild(a);
    } else {
      a.textContent = FIRST.none || '';
      el2.appendChild(a);
      el2.appendChild(document.createTextNode(' ' + (FIRST.noneTail || '')));
    }
    el2.hidden = false;
    syncH1Order();
  }
  /* Uses the ACTIVE dog, and a memorial dog can never be active, so this can
     never count down food for a dog who has died. */
  /* "12 days" makes the customer do the math; the date does it for them.
     A wup-note right under the strip, created here because the section has no
     hook for it. The words state a FACT about the food running out - nothing
     about shipping speed or timing, per the standing copy rule. The label is
     a dial the moment the section next ships (C.runsOut); until then the
     fallback matches it word for word. */
  function runoutNote(left) {
    var box = root.querySelector('[data-wup-days]');
    if (!box) return;
    var p = root.querySelector('[data-wup-runout]');
    if (!(left > 0) || box.hidden) { if (p) p.hidden = true; return; }
    if (!p) {
      p = document.createElement('p');
      p.className = 'wup-note';
      p.setAttribute('data-wup-runout', '');
      box.parentNode.insertBefore(p, box.nextSibling);
    }
    /* in the panel the note tucks into the strip's 22px bottom margin;
       docked beside the heading it just needs a small gap */
    p.style.margin = stripDocked() ? '8px 0 0' : '-14px 0 22px';
    var dt = new Date(Date.now() + left * 86400000);
    var ds = dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    p.hidden = false;
    p.textContent = (C.runsOut || 'Runs out around') + ' ' + ds;
  }
  /* When the strip turns red it becomes a button that jumps to Reorder -
     the nudge and the action belong one tap apart. Quiet yellow stays inert:
     role=button on an info strip would just be screen-reader noise. */
  function lowTap(box, low) {
    var tail = box.querySelector('[data-wup-days-go]');
    if (low && !box.dataset.wupTap) {
      box.dataset.wupTap = '1';
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.setAttribute('aria-label', C.reorderGo || 'Reorder');
      box.style.cursor = 'pointer';
      /* say it is a button: the strip used to be tappable with nothing to show for it */
      if (!tail) {
        tail = document.createElement('span');
        tail.className = 'wup-days__go';
        tail.setAttribute('data-wup-days-go', '');
        tail.setAttribute('aria-hidden', 'true');
        tail.textContent = (C.reorderGo || 'Reorder') + ' \u2193';
        box.appendChild(tail);
      }
    } else if (!low && box.dataset.wupTap) {
      delete box.dataset.wupTap;
      box.removeAttribute('role');
      box.removeAttribute('tabindex');
      box.removeAttribute('aria-label');
      box.style.cursor = '';
      if (tail) tail.parentNode.removeChild(tail);
    }
  }
  /* THE DAYS STRIP IS OFF (2026-10-31). [stated] "lets remove the red reorder
     box for now" - running-low nudges will come through the text-message system
     instead. The maths stays so it can be switched back on in one line. */
  var DAYS_ON = false;
  function days(totalOz) {
    var box = root.querySelector('[data-wup-days]');
    if (!box) return;
    if (!DAYS_ON) { box.hidden = true; lowTap(box, false); runoutNote(0); return; }
    /* The box feeds the HOUSEHOLD: sum the daily ounces of every living dog
       with a computable plan. One dog gives the old behaviour. A dog with no
       weight adds nothing, so with an incomplete roster the figure can only
       read HIGH - never a false "out of food". */
    var perDay = 0;
    living().forEach(function (d) {
      var p = planFor(d);
      if (p && p.oz > 0) perDay += p.oz;
    });
    if (!ORDER_AT || !totalOz || !(perDay > 0)) { box.hidden = true; runoutNote(0); return; }
    var placed = new Date(ORDER_AT);
    if (isNaN(placed)) { box.hidden = true; runoutNote(0); return; }
    var left = Math.round((totalOz / perDay) - Math.floor((Date.now() - placed.getTime()) / 86400000));
    box.hidden = false;
    box.classList.toggle('is-low', left <= 5);
    lowTap(box, left <= 5);
    var nEl = box.querySelector('[data-wup-days-n]');
    var lEl = box.querySelector('[data-wup-days-l]');
    if (left <= 0) { if (nEl) nEl.textContent = ''; if (lEl) lEl.textContent = C.daysOut; runoutNote(0); return; }
    if (nEl) nEl.textContent = left;
    if (lEl) lEl.textContent = left === 1 ? C.daysOne : C.daysMany;
    runoutNote(left);
  }
  /* STEP 7, OPTION C: at >=900px the strip and its note DOCK beside the big
     heading (the empty .wup-side the section renders). The NODE moves, so the
     tap listeners and the note ride along; below 900px it returns to its
     exact original slot and phones never change. No matchMedia = stay mobile,
     which is the safe shape. The CSS hides the docked strip off the Reorder
     tab via data-wup-on, which show() maintains. */
  var stripMq = null;
  function stripDocked() { return !!(stripMq && stripMq.matches); }
  (function () {
    var box = root.querySelector('[data-wup-days]');
    var side = root.querySelector('[data-wup-side]');
    if (!box || !side) return;
    var home = box.parentNode, homeNext = box.nextSibling;
    try { stripMq = window.matchMedia('(min-width:900px)'); } catch (e) { stripMq = null; return; }
    function place() {
      var p = root.querySelector('[data-wup-runout]');
      if (stripMq.matches) {
        side.appendChild(box);
        if (p) { side.appendChild(p); p.style.margin = '8px 0 0'; }
      } else {
        home.insertBefore(box, homeNext);
        if (p) { home.insertBefore(p, box.nextSibling); p.style.margin = '-14px 0 22px'; }
      }
    }
    place();
    try {
      if (stripMq.addEventListener) stripMq.addEventListener('change', place);
      else if (stripMq.addListener) stripMq.addListener(place);
    } catch (e) {}
  }());
  /* STEP 12: the shelf toggle. The section picks the default side (the one
     their last box came from) and renders both shelves; this only swaps which
     one shows. Hidden pills stay in the DOM so loved rings keep painting. */
  (function () {
    var btns = root.querySelectorAll('[data-wup-grp]');
    if (!btns.length) return;
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        var g = b.dataset.wupGrp;
        Array.prototype.forEach.call(btns, function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        Array.prototype.forEach.call(root.querySelectorAll('[data-wup-shelf]'), function (sh) {
          sh.hidden = sh.dataset.wupShelf !== g;
        });
      });
    });
  }());
  /* the red strip's tap and keyboard path; bound once, checks is-low itself */
  (function () {
    var box = root.querySelector('[data-wup-days]');
    if (!box) return;
    function goScroll() {
      if (!box.classList.contains('is-low')) return;
      var go = root.querySelector('[data-wup-go]');
      if (!go || typeof go.scrollIntoView !== 'function') return;
      var smooth = true;
      try { smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      go.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    }
    box.addEventListener('click', goScroll);
    box.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); goScroll(); }
    });
  }());

  root.addEventListener('click', function (ev) {
    var dec = ev.target.closest('[data-wup-dec]'), inc = ev.target.closest('[data-wup-inc]');
    if (!dec && !inc) return;
    var li = ev.target.closest('[data-wup-line]');
    if (!li) return;
    var q = parseInt(li.dataset.qty, 10) || 0;
    li.dataset.qty = inc ? Math.min(99, q + 1) : Math.max(0, q - 1);
    /* an ADDED line taken to zero leaves the box; a line from the last order
       stays at 0 so it can be brought back */
    if (li.dataset.orig === undefined && parseInt(li.dataset.qty, 10) === 0) { li.remove(); syncPills(); }
    paint();
  });

  root.addEventListener('click', function (ev) {
    var lv = ev.target.closest('[data-wup-love]');
    if (lv) { toggleLove(lv.dataset.wupLove); return; }
    var sz = ev.target.closest('[data-wup-size]');
    if (sz) { pickedSize = sz.dataset.wupSize; paintSizes(); return; }
    var b = ev.target.closest('[data-wup-add]');
    if (!b) return;
    /* A PILL IS A TOGGLE (2026-10-22). Tapping a lit pill takes back what it
       added; before, it only ever added another one and the only way out was
       the minus button, which left a dead line at 0 and the pill still lit. */
    /* the toggle decides WHICH variant this pill adds */
    var pv = variantFor(b);
    var mine = addedLines(b.dataset.handle);
    if (mine.length) {
      var same = mine.some(function (x) { return String(x.dataset.vid) === String(pv.id); });
      mine.forEach(function (x) { x.remove(); });
      /* same size = take it back; the other size = swap to the size now chosen */
      if (same) { syncPills(); paint(); return; }
    }
    var have = root.querySelector('[data-wup-line][data-vid="' + pv.id + '"]');
    if (have) { have.dataset.qty = (parseInt(have.dataset.qty, 10) || 0) + 1; paint(); return; }
    var ul = root.querySelector('[data-wup-lines]');
    if (!ul) return;
    var li = document.createElement('li');
    li.className = 'wup-line';
    li.setAttribute('data-wup-line', '');
    li.dataset.vid = pv.id;
    li.dataset.price = pv.price || '0';
    li.dataset.oz = '0';
    li.dataset.qty = '1';
    li.dataset.handle = b.dataset.handle || '';
    var col = (b.style.getPropertyValue('--c') || '').trim();
    if (col) li.style.setProperty('--c', col);
    li.innerHTML =
      '<span class="wup-line__dot" aria-hidden="true"></span>' +
      '<span class="wup-line__t"><span class="wup-line__n"></span></span>' +
      '<span class="wup-line__r"><span class="wup-line__p" data-wup-line-price></span>' +
      '<span class="wup-step">' +
      '<button class="wup-step__b" type="button" data-wup-dec aria-label="One fewer">\u2212</button>' +
      '<span class="wup-step__n" data-wup-qty aria-live="polite">1</span>' +
      '<button class="wup-step__b" type="button" data-wup-inc aria-label="One more">+</button>' +
      '</span></span>';
    li.querySelector('.wup-line__n').textContent = b.dataset.title || '';
    /* the size goes under the name like every other line, or a 64 oz pack
       looked identical to a 16 oz one in the box */
    if (pv.t && pv.multi && !/^default title$/i.test(pv.t)) {
      var sub = document.createElement('span');
      sub.className = 'wup-line__sub';
      sub.textContent = pv.t;
      li.querySelector('.wup-line__t').appendChild(sub);
    }
    var lbl = li.querySelectorAll('[data-wup-dec],[data-wup-inc]');
    if (lbl[0]) lbl[0].setAttribute('aria-label', 'One fewer ' + (b.dataset.title || ''));
    if (lbl[1]) lbl[1].setAttribute('aria-label', 'One more ' + (b.dataset.title || ''));
    li.classList.add('is-new');
    ul.appendChild(li);
    syncPills();
    paint();
    bumpBar();
  });

  /* lines THIS page added (no data-orig), for one product */
  function addedLines(handle) {
    if (!handle) return [];
    return lines().filter(function (li) {
      return li.dataset.orig === undefined && li.dataset.handle === handle;
    });
  }
  /* a pill is lit exactly while one of its added lines is in the box */
  function syncPills() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-wup-add]'), function (p) {
      var on = addedLines(p.dataset.handle).length > 0;
      p.classList.toggle('is-in', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  var resetBtn = root.querySelector('[data-wup-reset]');
  if (resetBtn) resetBtn.addEventListener('click', function () {
    lines().forEach(function (li) {
      if (li.dataset.orig === undefined) { li.remove(); return; }
      li.dataset.qty = li.dataset.orig;
    });
    syncPills();
    paint();
  });

  var busy = false;
  function openDrawer() {
    var tg2 = document.querySelector('.wofn-cart');
    if (tg2) tg2.click(); else window.location.href = '/cart';
  }
  root.addEventListener('click', function (ev) {
    var go = ev.target.closest('[data-wup-go]');
    if (!go || busy) return;
    /* ONLY THE DIFFERENCE goes. More of a line than was sent is added; less
       is taken back out of the cart by variant; the same is left alone. */
    var items = [], downs = [], after = {};
    lines().forEach(function (li) {
      var q = parseInt(li.dataset.qty, 10) || 0, vid = String(li.dataset.vid);
      var was = sentFor(vid);
      after[vid] = q;
      if (q > was) items.push({ id: parseInt(vid, 10), quantity: q - was,
                                properties: { _Source: (FIRST && FIRST.source) || 'Reorder' } });
      else if (q < was) downs.push({ vid: vid, less: was - q });
    });
    if (!items.length && !downs.length) { openDrawer(); return; }
    busy = true;
    var t = go.querySelector('[data-wup-go-t]');
    if (t) t.textContent = C.adding || '';
    paintBar();
    var step = items.length
      ? fetch('/cart/add.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      : Promise.resolve();
    if (downs.length) {
      step = step.then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        var have = {};
        ((cart && cart.items) || []).forEach(function (it) {
          have[String(it.variant_id)] = (have[String(it.variant_id)] || 0) + (parseInt(it.quantity, 10) || 0);
        });
        var updates = {};
        downs.forEach(function (d) { updates[d.vid] = Math.max(0, (have[d.vid] || 0) - d.less); });
        return fetch('/cart/update.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates }) })
          .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); });
      });
    }
    step
      .then(function () { return attrs(); })
      .then(function () {
        if (typeof window.wcCartRender === 'function') { try { window.wcCartRender('reorder'); } catch (e) {} }
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        Object.keys(after).forEach(function (k) { if (after[k] > 0) sentQ[k] = after[k]; else delete sentQ[k]; });
        sentSnap = boxSnap();
        busy = false;
        syncCart();
        paint();
        openDrawer();
      })
      .catch(function () {
        busy = false;
        if (t) t.textContent = C.reorderGo;
        window.location.href = '/cart';
      });
  });

  /* Empty values are dropped: an empty value on /cart/update.js DELETES the
     attribute, which would wipe one the vet form had already set. */
  function attrs() {
    var d = active();
    if (!d) return Promise.resolve();
    var a = {};
    if (d.name) a['Dog Name'] = d.name;
    if (d.weight_lb) a['Dog Weight'] = String(d.weight_lb);
    var plan = planFor(d);
    if (plan) {
      /* DATA, not display: plain quarter-rounded numbers. The order note does
         the formatting, and a fraction string here would break its arithmetic. */
      if (plan.oz > 0) a['Daily Ounces'] = String(q4(plan.oz));
      if (plan.cups > 0) a['Daily Cups'] = String(q4(plan.cups));
    }
    if (!Object.keys(a).length) return Promise.resolve();
    return fetch('/cart/update.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: a }) }).catch(function () {});
  }

  /* ============================================================ TABS */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wup-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-wup-panel]'));
  /* The heading follows the tab: one title above four different panels was
     wrong on three of them. Falls back to whatever is already there. */
  var h1El = root.querySelector('[data-wup-h1]');
  function paintH1(name) {
    if (!h1El) return;
    var t = h1El.getAttribute('data-h-' + name);
    /* textContent, not innerHTML: getAttribute already decoded the server's
       entities, and the order title carries a customer-typed dog name. */
    if (t) h1El.textContent = t;
  }
  /* The server renders the heading with SLOT 1's name, which is not always
     the primary dog. Rebuild it from the roster so a multi-dog household
     sees the right name; the words mirror the server template exactly. */
  function syncH1Order() {
    if (!h1El || !R) return;
    var p = byId(R, R.primaryId);
    var nm = p && p.status !== 'memorial' ? String(p.name || '').trim() : '';
    if (FIRST) {
      /* "Biscuit's first box", not "next box", until there is a first order */
      h1El.setAttribute('data-h-order', nm ? String(FIRST.h || '').replace('{dog}', nm) : (FIRST.hNone || ''));
      var on0 = root.querySelector('.wup-tab.is-on');
      if (!on0 || on0.dataset.wupTab === 'order') paintH1('order');
      return;
    }
    if (!nm) return;
    h1El.setAttribute('data-h-order', nm + '\u2019s next box');
    var on = root.querySelector('.wup-tab.is-on');
    if (!on || on.dataset.wupTab === 'order') paintH1('order');
  }

  function show(name, foc) {
    if (!tabs.some(function (t) { return t.dataset.wupTab === name; })) {
      name = tabs.length ? tabs[0].dataset.wupTab : null;
    }
    if (!name) return;
    paintH1(name);
    root.setAttribute('data-wup-on', name);
    tabs.forEach(function (t) {
      var on = t.dataset.wupTab === name;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && foc) t.focus();
    });
    panels.forEach(function (p) { p.hidden = p.dataset.wupPanel !== name; });
    if (typeof paintBar === 'function') paintBar();
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      show(t.dataset.wupTab, false);
      try { history.replaceState(null, '', '#' + t.dataset.wupTab); } catch (e) {}
    });
    t.addEventListener('keydown', function (ev) {
      var i = tabs.indexOf(t), n = null;
      if (ev.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      if (ev.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      if (ev.key === 'Home') n = tabs[0];
      if (ev.key === 'End') n = tabs[tabs.length - 1];
      if (!n) return;
      ev.preventDefault();
      show(n.dataset.wupTab, true);
    });
  });
  /* THE HASH IS A LIVE INPUT, NOT A ONE-OFF. Reading it only at boot means a
     link to #dog does nothing when the customer is ALREADY on this page - the
     browser changes the hash without reloading and nothing listens. The header
     links here from every page, so that is the common case, not the edge one. */
  function tabFromHash(foc) {
    if (!tabs.length) return;
    var want = (location.hash || '').replace('#', '');
    if (want && tabs.some(function (t) { return t.dataset.wupTab === want; })) show(want, !!foc);
  }
  tabFromHash(false);
  window.addEventListener('hashchange', function () { tabFromHash(true); });

  /* ============================================================ DOG TAB */
  var dogBox = root.querySelector('[data-wup-dog]');
  var form = null, base = null, editing = false, justSaved = false, justSavedT = 0;
  function el(s) { return dogBox ? dogBox.querySelector(s) : null; }
  function snapOf(d) {
    return d ? { name: d.name || '', weight_lb: d.weight_lb, age: d.age, activity: d.activity,
                 neuter: d.neuter, colour: d.colour || '', icon: d.icon || '',
                 bday: d.bday || '', ageMonths: d.ageMonths, bdErr: '' } : null;
  }
  function same(a, b) {
    if (!a || !b) return a === b;
    return a.name === b.name && a.weight_lb === b.weight_lb && a.age === b.age
      && a.activity === b.activity && a.neuter === b.neuter && a.colour === b.colour
      && a.icon === b.icon && (a.bday || '') === (b.bday || '') && (a.bdErr || '') === (b.bdErr || '');
  }
  function dirtyDog() { return !same(form, base); }
  /* what still stops a save: '' when nothing does */
  function missingFor(f) {
    var noName = !String(f.name || '').trim(), noWt = f.weight_lb == null;
    if (noName && noWt) return PHC.needBoth || 'Add a name and a weight to save.';
    if (noName) return PHC.needName || 'Add a name to save.';
    if (noWt) return PHC.needWt || 'Add a weight to save.';
    if (BD && f.bdErr) return bdErrText(f.bdErr, f.name);
    if (BD && bdRequired() && !f.bday) return bdErrText('need', f.name);
    return '';
  }
  /* a birthday is required for a NEW dog only; an existing dog without one is
     asked on its card instead, never blocked from saving (2026-11-01) */
  function bdRequired() { return !String((base && base.name) || '').trim(); }
  /* the FORM's field: the ask box on the card is a [data-wup-bd] too, and it
     comes first in the page, so this must look inside the form's slot */
  function bdFormBox() { return el('[data-wup-bd-slot] [data-wup-bd]'); }
  /* build the field into wup-bday.liquid's slot once */
  function bdMount() {
    var slot = el('[data-wup-bd-slot]');
    if (!BD || !slot || slot.dataset.built) return;
    slot.dataset.built = '1';
    slot.innerHTML = '<div class="wup-bd" data-wup-bd data-mode="date">' +
      '<p class="wup-lab" id="wup-bd-l"><span data-wup-bd-show="date">' + escH(BDC.label || 'Birthday') + '</span>' +
      '<span data-wup-bd-show="est" hidden>' + escH(BDC.estLabel || '') + '</span> <span class="wup-bd__req" data-wup-bd-req>*</span></p>' +
      '<p class="wup-bd__help" data-wup-bd-show="date">' + escH(BDC.help || '') + '</p>' +
      bdFieldHtml('wup-bd', true) +
      '<button type="button" class="wup-bd__link" data-wup-bd-mode="est" data-wup-bd-show="date">' + escH(BDC.toEst || '') + '</button>' +
      '<button type="button" class="wup-bd__link" data-wup-bd-mode="date" data-wup-bd-show="est" hidden>' + escH(BDC.toDate || '') + '</button>' +
      '<p class="wup-bd__err" data-wup-bd-err role="alert" hidden></p></div>';
  }
  /* the field changed: the form takes the birthday and the age it implies, so
     the calorie figure answers as they pick */
  function bdFromForm() {
    var box = bdFormBox();
    if (!box || !form) return;
    var r = bdRead(box);
    form.bday = r.bday;
    form.bdErr = r.err === 'need' ? '' : r.err;
    if (r.err === 'need') form.bdErr = (box.dataset.mode === 'est') ? '' : 'need';
    if (form.bday) { var tmp = { bday: form.bday, weight_lb: form.weight_lb }; applyBday(tmp); form.age = tmp.age; form.ageMonths = tmp.ageMonths; }
    else if (base) { form.age = base.age; form.ageMonths = base.ageMonths; }
  }

  /* UPDATE FROM YOUR CLINIC (2026-10-24). When a vet changes one of the dogs
     in the VET OS Client Hub, custom.vet_update holds one line:
     "<when>|<dog slot>|<what changed, in words>". It shows above the dogs
     until the customer presses Got it (remembered in this browser only) or
     it is 60 days old. Written by the wyn-vet Worker; this page only reads it. */
  function vetNote(wrap) {
    var old = root.querySelector('[data-wup-vu]');
    if (old) old.parentNode.removeChild(old);
    var raw = String(BOOT.vetUpdate || ''), parts = raw.split('|');
    if (parts.length < 3) return;
    var when = Date.parse(parts[0]), text = parts.slice(2).join('|').trim();
    if (!text || !(when > 0) || Date.now() - when > 60 * 86400000) return;
    var seen = '';
    try { seen = localStorage.getItem('wup_vu_seen') || ''; } catch (e) {}
    if (seen === parts[0]) return;
    var vc = BOOT.vc || {};
    var box = document.createElement('div');
    box.setAttribute('data-wup-vu', '');
    box.setAttribute('role', 'status');
    box.style.cssText = 'border:2px solid #1A1A1A;border-radius:8px;background:#FFF4C2;padding:14px;margin:0 0 14px;display:flex;flex-direction:column;gap:10px;box-shadow:4px 4px 0 #1A1A1A';
    var h = document.createElement('b');
    h.style.cssText = 'font-size:12px;letter-spacing:.08em;text-transform:uppercase';
    h.textContent = vc.vuH || 'Update from your clinic';
    var p = document.createElement('p');
    p.style.cssText = 'margin:0;font-size:16px;line-height:1.4';
    p.textContent = text;
    var ok = document.createElement('button');
    ok.type = 'button';
    ok.style.cssText = 'align-self:flex-start;min-height:44px;padding:0 18px;border:2px solid #1A1A1A;border-radius:6px;background:#FFD820;color:#1A1A1A;font:inherit;font-weight:700;cursor:pointer';
    ok.textContent = vc.vuOk || 'Got it';
    ok.addEventListener('click', function () {
      try { localStorage.setItem('wup_vu_seen', parts[0]); } catch (e) {}
      if (box.parentNode) box.parentNode.removeChild(box);
    });
    box.appendChild(h); box.appendChild(p); box.appendChild(ok);
    wrap.insertAdjacentElement('beforebegin', box);
  }

  function renderRoster() {
    var wrap = el('[data-wup-roster]');
    if (!wrap || !R) return;
    wrap.innerHTML = '';
    living().forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wup-dogtab' + (d.id === R.activeId ? ' is-on' : '');
      b.setAttribute('data-wup-pick', d.id);
      var chipIco = d.icon ? iconUrl(d.icon, d) : '';
      var chipPh = isRound(d.icon, d);
      b.classList.toggle('has-ico', !!chipIco);
      b.setAttribute('aria-pressed', d.id === R.activeId ? 'true' : 'false');
      if (d.colour) b.style.setProperty('--c', d.colour);
      b.innerHTML = '<span class="wup-av' + (chipIco ? (chipPh ? ' is-photo' : ' is-icon') : '') + '"' +
        (chipIco ? ' style="background-image:url(' + chipIco + ')"' : '') +
        '></span><span class="wup-dogtab__n"></span>' +
        (d.id === R.primaryId ? '<span class="wup-dogtab__p" aria-hidden="true">\u2605</span>' : '');
      b.querySelector('.wup-dogtab__n').textContent = d.name || C.unnamed;
      wrap.appendChild(b);
    });
    /* one dog or many - the tab should not say "Your dog" to someone with three */
    var dogTab = root.querySelector('[data-wup-tab="dog"]');
    if (dogTab && C.tabDog) {
      dogTab.textContent = living().length > 1 ? (C.tabDogs || C.tabDog) : C.tabDog;
    }

    /* AT THE CAP THE ADD BUTTON DISAPPEARS ENTIRELY (his call, 2026-08-15) - a
       sixth dog could never reach the account, so it must not exist on the page
       either. Memorial dogs do not count. */
    var oldFull = wrap.parentNode ? wrap.parentNode.querySelector('[data-wup-full]') : null;
    if (oldFull) oldFull.parentNode.removeChild(oldFull);
    if (living().length < maxDogs()) {
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'wup-dogtab wup-dogtab--add';
      add.setAttribute('data-wup-newdog', '');
      add.textContent = '+ ' + (C.addDog || '');
      wrap.appendChild(add);
    } else if (C.dogsFull) {
      var full = document.createElement('p');
      full.className = 'wup-note';
      full.setAttribute('data-wup-full', '');
      full.textContent = C.dogsFull;
      wrap.insertAdjacentElement('afterend', full);
    }
    paintInk(wrap);
    syncH1Order();
    vetNote(wrap);

    var mem = el('[data-wup-memorials]'), host = el('[data-wup-memorial-list]');
    var list = memorials();
    if (mem) mem.hidden = !list.length;
    if (host) {
      host.innerHTML = '';
      list.forEach(function (d) {
        var row = document.createElement('div');
        row.className = 'wup-mem';
        if (d.colour) row.style.setProperty('--c', d.colour);
        /* a remembered dog keeps their sticker, greyed by the CSS */
        var ico = d.icon ? iconUrl(d.icon, d) : '';
        row.innerHTML = '<span class="wup-av' + (ico ? (isRound(d.icon, d) ? ' is-photo' : ' is-icon') : '') + '"' +
          (ico ? ' style="background-image:url(' + ico + ')"' : '') +
          '></span><span class="wup-mem__t"><span class="wup-mem__n"></span>' +
          '<span class="wup-mem__y"></span></span>' +
          '<button class="wup-undo" type="button" data-wup-unmemorial="' + d.id + '"></button>';
        row.querySelector('.wup-mem__n').textContent = d.name || C.unnamed;
        row.querySelector('.wup-mem__y').textContent = d.since || '';
        row.querySelector('[data-wup-unmemorial]').textContent = C.memorialUndo || '';
        host.appendChild(row);
      });
      paintInk(host);
    }
  }

  function renderSwatches() {
    var wrap = el('[data-wup-colours]');
    if (!wrap || wrap.dataset.built) return;
    (BOOT.colours || []).forEach(function (hex) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wup-sw';
      b.setAttribute('data-wup-colour', hex);
      b.setAttribute('aria-label', hex);
      b.setAttribute('aria-pressed', 'false');
      b.style.setProperty('--c', hex);
      wrap.appendChild(b);
    });
    wrap.dataset.built = '1';
  }

  /* The product page's slider is non-linear: half the travel covers 3-40 lb and
     half covers 40-130, because most dogs sit in the lower band. Same mapping
     here, read off its wtMin/wtMid/wtMax/wtSnap dials, so dragging feels the
     same on both surfaces. */
  var WT_MIN = 2, WT_MID = 40, WT_MAX = 130, WT_SNAP = 500;
  function wtToSlide(lb) {
    /* 2026-10-31: no weight = thumb at the LEFT, not the middle. The middle
       read as "40 lb" beside an empty box, which is two controls disagreeing. */
    if (lb == null) return 0;
    if (lb <= WT_MID) return Math.round((lb - WT_MIN) / (WT_MID - WT_MIN) * WT_SNAP);
    var over = Math.min(lb, WT_MAX);
    return Math.round(WT_SNAP + (over - WT_MID) / (WT_MAX - WT_MID) * (1000 - WT_SNAP));
  }
  function slideToWt(v) {
    v = Math.max(0, Math.min(1000, parseFloat(v) || 0));
    if (v <= WT_SNAP) return Math.round(WT_MIN + (v / WT_SNAP) * (WT_MID - WT_MIN));
    return Math.round(WT_MID + ((v - WT_SNAP) / (1000 - WT_SNAP)) * (WT_MAX - WT_MID));
  }

  var PUP_FACTORS = [2, 1.5, 1.25];

  function markOpts(g, val) {
    var want = val == null ? null : String(val);
    Array.prototype.forEach.call(dogBox.querySelectorAll('[data-wup-opt="' + g + '"]'), function (b) {
      var a = num(b.dataset.val), z = num(want);
      var hit = want !== null && ((a !== null && z !== null) ? a === z : b.dataset.val === want);
      b.setAttribute('aria-pressed', hit ? 'true' : 'false');
    });
  }

  /* force=true overwrites the inputs even while focused. The focus guard exists
     so a re-render cannot clobber someone mid-typing, but ON A DOG SWITCH the
     field now belongs to a DIFFERENT dog and MUST be replaced. Without the
     force, switching while focused left the previous dog's name in the box and
     the next Save wrote it onto the newly selected dog. */
  function render(force) {
    if (!dogBox || !form || !R) return;
    renderRoster();
    renderSwatches();
    var wt = el('[data-wup-f="weight_lb"]');
    if (wt && (force || document.activeElement !== wt)) wt.value = form.weight_lb == null ? '' : form.weight_lb;
    var sl = el('[data-wup-slide]');
    if (sl && (force || document.activeElement !== sl)) sl.value = wtToSlide(form.weight_lb);
    if (sl) sl.classList.toggle('is-empty', form.weight_lb == null);
    var nm = el('[data-wup-f="name"]');
    if (nm && (force || document.activeElement !== nm)) nm.value = form.name;
    /* the roster tab follows the name as it is typed, so a new dog appears
       in the row while the person is still filling the form (2026-10-31) */
    var tn = dogBox.querySelector('.wup-dogtab.is-on .wup-dogtab__n');
    if (tn) tn.textContent = form.name.trim() || C.unnamed;
    renderIcons();
    bdMount();
    var bdb = bdFormBox();
    if (bdb) {
      if (force) bdFill(bdb, form.bday);
      var star = bdb.querySelector('[data-wup-bd-req]');
      if (star) star.hidden = !bdRequired();
      var be = bdb.querySelector('[data-wup-bd-err]');
      if (be) { var bt = form.bdErr && form.bdErr !== 'need' ? bdErrText(form.bdErr, form.name) : ''; be.textContent = bt; be.hidden = !bt; }
    }
    markOpts('age', form.age);
    markOpts('activity', form.activity);
    markOpts('neuter', form.neuter);

    /* Puppy is a parent of three month ranges, exactly as the buy box does it.
       The sub-row only exists when a puppy factor is selected. */
    var pupRow = el('[data-wup-pupchips]');
    var isPup = PUP_FACTORS.indexOf(form.age) > -1;
    if (pupRow) pupRow.hidden = !isPup;
    var pupBtn = el('[data-wup-pup]');
    if (pupBtn) pupBtn.setAttribute('aria-pressed', isPup ? 'true' : 'false');

    /* Open the disclosure only when there is something in it worth seeing, so
       the common adult/normal/neutered dog never has to touch it. */
    var fold = el('[data-wup-fold]');
    if (fold && !fold.dataset.touched) {
      /* a NEW dog has not answered yet, so the question is asked open (2026-10-31) */
      fold.open = isNewDog(active())
        || (!BD && (isPup || (form.age != null && form.age !== 1)))
        || (form.activity != null && form.activity !== 1.55)
        || form.neuter === 'intact';
    }
    /* STEP 22: a closed disclosure that shows its current answer gets opened; one
       that only asks a question gets skipped. These three inputs move the calorie
       figure more than anything else on the form, and nothing about the closed row
       said so. Labels come from labelFor, which reads the chips themselves, so the
       summary cannot drift from the words it is summarising and it costs no new
       copy string. CSS hides it while the fold is open. */
    if (fold) {
      var fsum = fold.querySelector('summary');
      if (fsum) {
        var bits = [], DOT = ' ' + String.fromCharCode(183) + ' ';
        (BD ? [['activity', form.activity], ['neuter', form.neuter]]
            : [['age', form.age], ['activity', form.activity], ['neuter', form.neuter]]).forEach(function (p) {
          var lb = labelFor(p[0], p[1]);
          if (lb) bits.push(lb);
        });
        /* NOT .wup-sum - that class is already the reorder card's cream footer
           band, negative margins and all. A new class name gets grepped against
           the stylesheet FIRST from now on. */
        var se = fsum.querySelector('.wup-fsum');
        if (!se) { se = document.createElement('span'); se.className = 'wup-fsum'; fsum.appendChild(se); }
        se.textContent = bits.join(DOT);
      }
    }
    Array.prototype.forEach.call(dogBox.querySelectorAll('[data-wup-colour]'), function (b) {
      b.setAttribute('aria-pressed', b.dataset.wupColour === form.colour ? 'true' : 'false');
    });

    var kcal = kcalFor(form);
    var stuck = !kcal && form.weight_lb != null;
    var say = el('[data-wup-say]');
    if (say) {
      /* a dog that has never been saved already says what is missing beside
         Save, so the band would only say it twice */
      say.hidden = isNewDog(active()) && !kcal;
      say.textContent = kcal
        ? (form.name.trim() || C.unnamed) + ' ' + C.dogOut + ' ' + kcal + ' ' + C.dogOutEnd
        : (stuck ? C.dogOutStuck : C.dogOutNone);
      say.classList.toggle('is-stuck', stuck);
    }
    var diag = el('[data-wup-diag]');
    if (diag) {
      diag.hidden = !(stuck && BOOT.diag);
      diag.textContent = stuck ? ('wynFeed: ' + kcalWhy) : '';
    }

    var isPrimary = !!(active() && active().id === R.primaryId);
    var fresh = isNewDog(active());
    var pb = el('[data-wup-primary]');
    if (pb) {
      pb.hidden = living().length < 2 || fresh;
      pb.disabled = isPrimary;
      pb.textContent = isPrimary ? C.isPrimary : C.makePrimary;
    }
    var rmv = el('[data-wup-remove]');
    if (rmv) rmv.hidden = living().length < 2 || fresh;
    var mb = el('[data-wup-memorial]');
    if (mb) mb.hidden = living().length < 2 || fresh;
    /* the primary-dog helper line and its row go together */
    var mg = dogBox.querySelector('.wup-manage');
    if (mg) { mg.hidden = fresh; var mgn = mg.nextElementSibling;
      if (mgn && mgn.classList.contains('wup-note')) mgn.hidden = fresh || living().length < 2; }

    /* The card is the resting state; the form is what Edit opens. Anything
       staged keeps the form open so a half-finished edit cannot be hidden. */
    var showForm = editing || dirtyDog();
    Array.prototype.forEach.call(dogBox.querySelectorAll('[data-wup-view]'), function (v) {
      v.hidden = (v.dataset.wupView === 'form') !== showForm;
    });
    paintCard();
    paintTaste();

    var d = dirtyDog();
    var sv = el('[data-wup-save]'), svT = el('[data-wup-save-t]');
    var un = el('[data-wup-undo]'), nt = el('[data-wup-note]');
    /* A DOG NEEDS A NAME AND A WEIGHT TO SAVE (2026-10-31). Everything on the
       page keys off the weight, so a weightless dog was a dog nothing could use.
       On a new dog the button is always on screen, disabled until both exist,
       and the note says what is still missing. */
    var missing = missingFor(form);
    if (sv) { sv.disabled = !d || !!missing; if (d) sv.classList.remove('is-done');
      sv.hidden = fresh ? false : (!d && !justSaved); }
    if (svT) svT.textContent = fresh ? (PHC.newSave || C.dogSave) : (d ? C.dogSave : (justSaved ? C.dogSaved : C.dogNochange));
    /* A WAY OUT (2026-10-31). Edit with nothing changed used to leave no
       button at all, so the only exits were switching dogs or reloading.
       Clean form = Done; a dog that has never been saved = Cancel, which
       removes it; staged changes = Undo, as before. */
    if (un) {
      un.hidden = !(d || editing);
      un.textContent = fresh ? (C.cancel || 'Cancel') : (d ? (C.dogUndo || 'Undo') : (C.dogDone || 'Done'));
      un.classList.toggle('is-done', !fresh && !d);
    }
    if (nt) nt.textContent = missing ? missing : (d ? C.dogUnsaved : (BOOT.ravenOn ? '' : C.dogLocal));
    /* the note sits between Save and Cancel on the same line */
    var acts = dogBox.querySelector('.wup-actions');
    if (nt && acts && nt.parentNode !== acts) acts.insertBefore(nt, un || null);
    /* The closed disclosure wears the dog's look BIG, with a few other
       stickers beside it so the row advertises what is behind the caret. */
    var pv = dogBox.querySelector('[data-wup-lookpv]');
    if (pv) {
      var mine = form.icon || 'og';
      var me = pv.querySelector('.wup-look__me');
      if (!me) {
        me = document.createElement('i');
        me.className = 'wup-look__me';
        pv.appendChild(me);
      }
      /* STEP 22: name it as well as show it. A face alone tells you a pick was
         made; the name tells you WHICH, which is the thing you came back to check. */
      var lt = pv.querySelector('.wup-look__t');
      if (!lt) { lt = document.createElement('span'); lt.className = 'wup-look__t'; pv.insertBefore(lt, pv.firstChild); }
      lt.textContent = iconName(mine);
      var mu = iconUrl(mine);
      me.classList.toggle('is-photo', isRound(mine));
      me.style.backgroundImage = mu ? 'url(' + mu + ')' : '';
      if (form.colour) me.style.setProperty('--c', form.colour);
      else me.style.removeProperty('--c');
      var others = [];
      for (var oi = 0; oi < ICONLIB.list.length && others.length < 5; oi++) {
        var en = ICONLIB.list[oi];
        if (en.g === 's' && en.slug !== mine) others.push(en.url);
      }
      var tiles = pv.querySelectorAll('.wup-look__o');
      for (var ti = 0; ti < others.length; ti++) {
        var tile = tiles[ti];
        if (!tile) {
          tile = document.createElement('i');
          tile.className = 'wup-look__o';
          pv.appendChild(tile);
        }
        tile.style.backgroundImage = 'url(' + others[ti] + ')';
      }
      for (var tj = others.length; tj < tiles.length; tj++) tiles[tj].remove();
    }
    paintInk(dogBox);
  }

  /* Reads the chip labels straight out of the form, so the card and the form
     can never disagree about what a factor is called. */
  function labelFor(group, val) {
    if (val == null || val === '') return null;
    var b = dogBox.querySelector('[data-wup-opt="' + group + '"][data-val="' + val + '"]');
    if (b) return b.textContent.trim();
    var all = dogBox.querySelectorAll('[data-wup-opt="' + group + '"]');
    for (var i = 0; i < all.length; i++) {
      if (num(all[i].dataset.val) !== null && num(all[i].dataset.val) === num(val)) {
        return all[i].textContent.trim();
      }
    }
    /* the age chips left the form 2026-11-01; their words travel in wup-bday */
    if (group === 'age' && BD && BD.stages) {
      var nv = num(val);
      for (var sk in BD.stages) { if (num(sk) === nv) return BD.stages[sk]; }
    }
    return null;
  }

  /* the account row for this dog: by claimed slot first, then by name */
  function authRowFor(dog) {
    var rows = BOOT.auth || [];
    if (!dog || !rows.length) return null;
    var i;
    if (dog.slot) {
      for (i = 0; i < rows.length; i++) if (Number(rows[i].n) === Number(dog.slot)) return rows[i];
    }
    var want = String(dog.name || '').trim().toLowerCase();
    if (want) {
      for (i = 0; i < rows.length; i++) {
        if (String(rows[i].name || '').trim().toLowerCase() === want) return rows[i];
      }
    }
    return null;
  }

  function fmtDate(v) {
    var d = new Date(String(v).replace(/-/g, '/'));
    if (isNaN(d)) return String(v);
    try {
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return String(v); }
  }

  /* The icon library ships in snippets/wup-icons.liquid as #wup-icons JSON
     ({c:{breeds,find}, list:[{s,n,u,g}]}, g "s"=sticker "b"=breed silhouette).
     Missing or unparseable = fall back to the 8 built-ins in BOOT.icons, so a
     renamed snippet costs the breed browser, never the page. */
  var ICONLIB = (function () {
    try {
      var el2 = document.getElementById('wup-icons');
      var j = el2 && JSON.parse(el2.textContent);
      if (j && j.list && j.list.length) {
        return { c: j.c || {}, list: j.list.map(function (e) {
          return { slug: e.s, name: e.n || e.s, url: e.u, g: e.g || 's' };
        }) };
      }
    } catch (e) {}
    return { c: {}, list: (BOOT.icons || []).map(function (e) {
      return { slug: e.slug, name: e.slug, url: e.url, g: 's' };
    }) };
  }());
  /* DOG PHOTOS (2026-10-29). snippets/wup-icons.liquid publishes #wup-photos
     for a signed-in customer: the wyn-customers address, a sign-in token made
     on Shopify's server, each dog's photo by account slot, and the words.
     A dog shows its photo when its look's icon is "photo" AND a photo exists
     for its slot; otherwise it falls back to The OG, never a broken picture.
     No #wup-photos (signed out, older snippet) = no Photo tab, nothing else
     changes. */
  var PH = (function () {
    try {
      var t = document.getElementById('wup-photos');
      var j = t && JSON.parse(t.textContent || '{}');
      return j && j.api && j.auth ? j : null;
    } catch (e) { return null; }
  }());
  var PHC = (PH && PH.c) || {};
  var PHOTOS = (PH && PH.p) || {};
  /* THE LIVE REPEAT-DELIVERY CARD (2026-10-31). The section can only guess
     "subscriber" from the last twenty orders. wyn-customers asks Awtomic for
     the truth (status, cadence, next date, what is in the box) using the same
     signed token the photos use. The answer REPLACES the guess: a real
     subscriber with no selling plan in recent orders gets the card drawn
     here; a guessed subscriber whose subscriptions are all gone gets the
     ordinary reorder box back. No answer (key not set, Awtomic down) = the
     page stays exactly as the section rendered it. */
  function subDate(s) {
    var d = new Date(String(s).slice(0, 10).replace(/-/g, '/'));
    if (isNaN(d)) return String(s);
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return String(s); }
  }
  /* the diet's colour, borrowed from its Add pill by title */
  function subColour(title) {
    var want = String(title || '').trim().toLowerCase();
    if (!want) return '';
    var pills = root.querySelectorAll('[data-wup-add]');
    for (var i = 0; i < pills.length; i++) {
      var t = String(pills[i].dataset.title || '').trim().toLowerCase();
      if (t && (t === want || want.indexOf(t) === 0 || t.indexOf(want) === 0)) {
        return (pills[i].style.getPropertyValue('--c') || '').trim();
      }
    }
    return '';
  }
  function drawSubs(subs) {
    var panel = root.querySelector('[data-wup-panel="order"]');
    if (!panel) return;
    var card = root.querySelector('.wup-card--sub');
    if (!card) {
      card = document.createElement('section');
      card.className = 'wup-card wup-card--sub';
      var h2 = document.createElement('h2'); h2.className = 'wup-h2'; h2.textContent = SUBW.cardH || '';
      var p = document.createElement('p'); p.className = 'wup-p'; p.textContent = SUBW.cardP || '';
      var a = document.createElement('a'); a.className = 'wup-btn wup-btn--ink'; a.href = SUBW.url || '/tools/bundle-subscriptions'; a.textContent = SUBW.go || '';
      card.appendChild(h2); card.appendChild(p); card.appendChild(a);
      var days = panel.querySelector('[data-wup-days]');
      if (days && days.parentNode === panel) panel.insertBefore(card, days.nextSibling); else panel.insertBefore(card, panel.firstChild);
      setupTopup();
    }
    var old = card.querySelector('[data-wup-subl]');
    if (old) old.remove();
    var list = document.createElement('div');
    list.className = 'wup-subl';
    list.setAttribute('data-wup-subl', '');
    subs.forEach(function (s) {
      var it = document.createElement('div');
      it.className = 'wup-subl__i' + (s.status === 'paused' ? ' is-paused' : '');
      var hd = document.createElement('div');
      hd.className = 'wup-subl__hd';
      var dot = document.createElement('span'); dot.className = 'wup-subl__dot'; dot.setAttribute('aria-hidden', 'true');
      hd.appendChild(dot);
      var bits = [];
      if (s.status === 'paused') bits.push(SUBW.paused || 'Paused');
      else {
        bits.push(SUBW.on || 'On');
        if (s.every) bits.push(s.every.charAt(0).toUpperCase() + s.every.slice(1));
        if (s.next) bits.push(String(SUBW.next || 'Next box {n}').replace('{n}', subDate(s.next)));
      }
      if (s.pickup) bits.push((SUBW.pickup || 'Local pickup') + (s.place ? ' (' + s.place + ')' : ''));
      var tx = document.createElement('b'); tx.textContent = bits.join(' \u00b7 ');
      hd.appendChild(tx);
      it.appendChild(hd);
      if (s.lines && s.lines.length) {
        var ul = document.createElement('ul');
        ul.className = 'wup-subl__l';
        s.lines.forEach(function (l) {
          var li = document.createElement('li');
          var c = subColour(l.title);
          if (c) li.style.setProperty('--c', c);
          var sw = document.createElement('i'); sw.setAttribute('aria-hidden', 'true');
          var nm = document.createElement('span'); nm.className = 'wup-subl__n';
          nm.textContent = l.title + (l.variant && !/^default title$/i.test(l.variant) ? ' \u00b7 ' + l.variant : '');
          var q = document.createElement('span'); q.className = 'wup-subl__q'; q.textContent = (SUBW.qty || 'Qty') + ' ' + l.qty;
          li.appendChild(sw); li.appendChild(nm); li.appendChild(q);
          ul.appendChild(li);
        });
        it.appendChild(ul);
      }
      list.appendChild(it);
    });
    var btn = card.querySelector('.wup-btn');
    if (btn) card.insertBefore(list, btn); else card.appendChild(list);
  }
  (function subsLive() {
    if (!PH || !root.querySelector('[data-wup-panel="order"]')) return;
    phPost('/subscriptions', { auth: PH.auth }).then(function (j) {
      if (!j || !j.ok || !Array.isArray(j.subs)) return;
      if (!j.subs.length) {
        /* the guess was wrong: no repeat delivery any more, back to the box */
        var card = root.querySelector('.wup-card--sub');
        if (card) { card.remove(); topupOpen(); }
        return;
      }
      drawSubs(j.subs);
    }).catch(function () {});
  }());
  function photoOf(dog) {
    var s = dog && dog.slot;
    var u = s ? String(PHOTOS[String(s)] || '') : '';
    return /^https:\/\/cdn\.shopify\.com\//.test(u) ? u : '';
  }
  function isPhoto(slug, dog) { return slug === 'photo' && !!photoOf(dog || active()); }
  /* A cut-out sticker dresses like the stickers (no frame of its own); only a
     round photo (the fallback, or one saved before stickers) wears the frame. */
  function isRound(slug, dog) { return isPhoto(slug, dog) && !isSticker(photoOf(dog || active())); }
  function photoSized(u, w) { return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function phWords(k, dog) {
    var nm = String((dog && dog.name) || '').trim() || C.unnamed || '';
    return String(PHC[k] || '').replace(/\{dog\}/g, nm);
  }

  function iconUrl(slug, dog) {
    if (slug === 'photo') {
      var pu = photoOf(dog || active());
      return pu ? photoSized(pu, 480) : iconUrl('og');
    }
    var list = ICONLIB.list;
    for (var i = 0; i < list.length; i++) if (list[i].slug === slug) return list[i].url;
    return '';
  }
  /* the artwork's own name, so the stage and the closed row can say WHICH dog
     is on the card without any new copy string to keep in sync */
  function iconName(slug, dog) {
    if (slug === 'photo') return isPhoto(slug, dog) ? phWords('name', dog || active()) : iconName('og');
    var list = ICONLIB.list;
    for (var i = 0; i < list.length; i++) if (list[i].slug === slug) return list[i].name;
    return '';
  }

  /* A sticker, or the flat colour. Uploaded photos were removed 2026-08-12:
     they only ever lived on one device, and the stickers do the same job while
     syncing to the account as a short string. */
  function paintAvatar(el2, dog) {
    if (!el2 || !dog) return;
    var ico = iconUrl(dog.icon || 'og', dog);
    var asPhoto = isRound(dog.icon, dog);
    el2.classList.toggle('has-art', !!ico);
    el2.classList.toggle('is-icon', !!ico && !asPhoto);
    el2.classList.toggle('is-photo', asPhoto);
    el2.style.backgroundImage = ico ? 'url(' + ico + ')' : '';
    if (dog.colour) el2.style.setProperty('--c', dog.colour); else el2.style.removeProperty('--c');
  }

  /* STEP 22: ONE picker, two tabs.
     A sticker and a silhouette write the SAME field, so two stacked pickers
     meant one of them always sat there looking like an unanswered question.
     The old "Pick a breed silhouette (50)" row wore the same small grey caps as
     the passive labels beside it, so the eye filed it as a caption and skipped
     it - fifty of the fifty nine icons lived behind that one word.
     The segment wears the SIZE TOGGLE's classes, so this is a control the page
     already teaches elsewhere, and the count sits INSIDE it so the size of the
     library advertises itself. Tabs filter with a class rather than a rebuild,
     so the pressed state, the scroll position and the images all survive a
     switch. */
  /* the stickers are 2,134 px masters; the picker's tiles are 96 px, so ask
     Shopify's CDN for a 192 px copy and the grid fills in at once instead of
     sitting empty for seconds (2026-10-31) */
  function small(u) {
    u = String(u || '');
    if (!/^https:\/\/cdn\.shopify\.com\//.test(u) || /[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=192';
  }
  function renderIcons() {
    var box = dogBox && dogBox.querySelector('[data-wup-icons]');
    if (!box) return;
    var list = ICONLIB.list;

    /* PHOTO FIRST (2026-10-31). The photo buttons are always on show; the
       stickers sit behind one link ("No photo handy? Pick a sticker for now").
       'p' = stickers folded, 's' = stickers open. Breeds are no longer drawn
       at all; a dog that picked one earlier keeps it on the card. */
    function setGrp(g) {
      var grid = box.querySelector('[data-wup-icogrid]');
      var open = g === 's' || !PH;
      if (grid) grid.hidden = !open;
      var lk = box.querySelector('[data-wup-stk]');
      if (lk) {
        lk.setAttribute('aria-expanded', open ? 'true' : 'false');
        lk.textContent = open ? (PHC.hideSticker || 'Hide the stickers') : (PHC.pickSticker || 'No photo handy? Pick a sticker for now');
        /* with the sheet carrying "Choose a sticker instead", the link only
           has a job while the stickers are open (one action row, 2026-10-31) */
        if (lk.parentNode) lk.parentNode.hidden = !open && !!PH;
      }
      box.dataset.grp = g;
    }
    box.setGrp = setGrp;

    if (box.dataset.built !== '1') {
      var tile = function (ic) {
        return '<button type="button" class="wup-ico" data-wup-icon="' + ic.slug +
               '" data-g="' + (ic.g === 'b' ? 'b' : 's') +
               '" data-n="' + ic.name.toLowerCase() + '" aria-pressed="false" title="' + ic.name + '">' +
               '<img src="' + small(ic.url) + '" alt="" loading="lazy" width="96" height="96">' +
               '<span class="wup-sr">' + ic.name + '</span></button>';
      };
      var sh = '';
      list.forEach(function (ic) { if (ic.g !== 'b') sh += tile(ic); });
      var seg = '';
      /* ONE ACTION ROW (2026-10-31, his pick). The look section is a single
         tappable row: the face the dog wears, what it is, and Add or Change.
         Tapping it opens the photo sheet, the same one the card's camera badge
         opens, which carries Take, Pick and "Choose a sticker instead". The
         sticker grid stays in the form, hidden until that link reveals it. */
      box.innerHTML = PH
        ? '<button type="button" class="wup-lookrow" data-wup-lookrow>' +
            '<span class="wup-stage__av wup-lookrow__av" data-wup-stage-av><span class="wup-stage__art" data-wup-stage-img aria-hidden="true"></span></span>' +
            '<span class="wup-lookrow__t"><b data-wup-lookrow-h></b><small data-wup-lookrow-s></small></span>' +
            '<span class="wup-lookrow__b" data-wup-lookrow-b></span>' +
          '</button>' +
          '<div class="wup-ph wup-ph--lead" data-wup-photo hidden></div>' +
          '<p class="wup-stk__row" hidden><button type="button" class="wup-undo wup-stk" data-wup-stk aria-expanded="false"></button></p>' +
          '<div class="wup-icogrid is-s" data-wup-icogrid hidden>' + sh + '</div>'
        : '<div class="wup-stage" data-wup-stage>' +
          '<span class="wup-stage__av" data-wup-stage-av>' +
            /* A SPAN WITH A BACKGROUND, NOT AN <img>. An img is a REPLACED element,
               so the theme's own base rules reach it - `img{max-width:100%}` clamped
               this art to the plate width and shoved it left, twice. A span is not
               replaced: nothing outside this stylesheet has an opinion about it, and
               it is the same mechanism .wup-look__me has always used here. */
            '<span class="wup-stage__art" data-wup-stage-img aria-hidden="true"></span>' +
          '</span>' +
          '<span class="wup-stage__n" data-wup-stage-n></span>' +
        '</div>' + seg +
        '<div class="wup-icogrid is-s" data-wup-icogrid>' + sh + '</div>';
      box.dataset.built = '1';
      if (PH) photoWire(box);
      var stk = box.querySelector('[data-wup-stk]');
      if (stk) stk.addEventListener('click', function () { setGrp(box.dataset.grp === 's' ? 'p' : 's'); });
      var lr = box.querySelector('[data-wup-lookrow]');
      if (lr) lr.addEventListener('click', function () { phOpen(); });
      /* the look fold is no longer a fold: always open, its summary hidden by CSS */
      var lookDet0 = box.closest('details');
      if (lookDet0 && PH) { lookDet0.open = true; lookDet0.classList.add('wup-fold--look'); }
      /* the dog finder loads once the look section is open, not on page load */
      var lookDet = box.closest('details');
      if (PH && lookDet) {
        var warm = function () { if (lookDet.open) finder().catch(function () {}); };
        lookDet.addEventListener('toggle', warm); warm();
      }
      /* "Pick a sticker" is the label the section prints above this box. With a
         segment naming both halves it is both redundant and now WRONG on the
         breeds side, so it comes out of the flow here rather than out of the
         section, which has no bytes left to give. */
      var lab = box.previousElementSibling;
      if (lab && lab.classList && lab.classList.contains('wup-lab')) lab.hidden = true;
      setGrp('s');
    }

    var cur = form.icon || 'og';
    Array.prototype.forEach.call(box.querySelectorAll('[data-wup-icon]'), function (b4) {
      b4.setAttribute('aria-pressed', b4.dataset.wupIcon === cur ? 'true' : 'false');
    });

    /* The tab follows the PICK, but only when the pick itself changed - which is
       first paint and a dog switch. A pick made by hand is always in the tab
       that is already open, so this never fights the customer, and a tab opened
       by hand is never yanked back. */
    var sel = box.querySelector('[data-wup-icon="' + cur + '"]');
    if (box.dataset.pick !== cur) {
      box.dataset.pick = cur;
      /* a sticker the customer chose opens the stickers; a photo, or the
         default face nobody chose, leads with the photo buttons */
      /* with the action row naming the sticker, the grid stays folded until asked */
      if (PH) setGrp('p'); else if (sel) setGrp('s'); else setGrp('p');
    }
    /* the row's words follow the face: a photo, a chosen sticker, or nothing yet */
    var rh = box.querySelector('[data-wup-lookrow-h]'), rs = box.querySelector('[data-wup-lookrow-s]'), rb = box.querySelector('[data-wup-lookrow-b]');
    if (rh) {
      var det0 = box.closest('details'); if (det0 && !det0.open) det0.open = true;
      var nm0 = String(form.name || '').trim();
      var dg0 = { name: nm0, slot: active() && active().slot };
      var hasPhoto = isPhoto(cur);
      rh.textContent = hasPhoto ? phWords('name', dg0)
        : (nm0 ? String(PHC.lookH || 'Add a photo of {dog}').replace(/\{dog\}/g, nm0) : (PHC.lookH0 || 'Add a photo of your dog'));
      if (rs) rs.textContent = hasPhoto ? (PHC.rowSubHave || '')
        : (form.icon && form.icon !== 'photo' ? String(PHC.rowSubSticker || 'Wearing the {sticker} sticker for now.').replace('{sticker}', iconName(cur)) : (PHC.rowSubAdd || ''));
      if (rb) rb.textContent = hasPhoto ? (PHC.rowChange || 'Change') : (PHC.rowAdd || 'Add');
    }

    /* The stage: the sticker on its colour, at size, updating as either one is
       tapped. Picking a colour used to be an act of faith - the plate it fills
       is on the CARD, which is the view you are not looking at while you edit. */
    var im = box.querySelector('[data-wup-stage-img]');
    var pl = box.querySelector('[data-wup-stage-av]');
    var nmS = box.querySelector('[data-wup-stage-n]');
    var u = iconUrl(cur);
    if (im) {
      im.style.backgroundImage = u ? 'url(' + u + ')' : '';
      im.classList.toggle('is-photo', isRound(cur));
      im.hidden = !u;
    }
    if (pl) { if (form.colour) pl.style.setProperty('--c', form.colour); else pl.style.removeProperty('--c'); }
    if (nmS) nmS.textContent = iconName(cur);
    if (PH) renderPhoto(box);
  }

  /* ---------- DOG PHOTOS (2026-10-29): the Photo tab ----------
     Pick a photo -> TAP THE DOG -> Use this photo. [stated] "this replaces the
     circle": the photo becomes a cut-out sticker of the dog with the yellow
     border every other sticker has, saved as a see-through PNG.
     The cut-out is Google's free tap-to-select model (MediaPipe, magic touch),
     run in the customer's own browser; nothing goes to another company. If it
     cannot load on an old phone, the round-photo fit below is the fallback,
     so nobody is ever stuck.
     Fallback: pick -> fit it in a square (drag, zoom, turn) -> Use this photo.
     The crop happens here, so what is sent is one 800 px JPEG and the
     original never leaves the phone. iPhone HEIC files that this browser
     cannot open are converted with heic2any, loaded only when needed (the
     same library the Sign Documents tool uses). wyn-customers checks the
     photo shows a dog before saving anything, then writes the photo and the
     dog's look itself, so a saved photo needs no Save button. */
  var PH_SIDE = 800, PH_MAX = 1024, PH_ST = 640;
  var MP_LIB = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.21';
  var MP_MODEL = 'https://storage.googleapis.com/mediapipe-models/interactive_segmenter/magic_touch/float32/1/magic_touch.tflite';
  var phs = { dogId: null, mode: 'idle', err: '', img: null, rot: 0, z: 1, ox: 0, oy: 0, busy: false, taps: [], masks: [], st: null };

  function phReset(keepErr) {
    phs.mode = 'idle'; phs.img = null; phs.rot = 0; phs.z = 1; phs.ox = 0; phs.oy = 0;
    phs.taps = []; phs.masks = []; phs.st = null;
    if (!keepErr) phs.err = '';
  }
  function phEsc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function phFileBtn(label, cls) {
    return '<label class="' + cls + '"><input type="file" accept="image/*,.heic,.heif" class="wup-sr" data-wup-ph-file>' + label + '</label>';
  }

  function phPanel() { return root.querySelector('[data-wup-photo]'); }
  function renderPhoto(box) {
    var panel = phPanel();
    var d = active();
    if (!panel || !d || !form) return;
    if (phs.dogId !== d.id) { phs.dogId = d.id; phReset(); }
    var url = photoOf(d);
    var key = [phs.mode, d.id, d.slot || '', url, form.icon, form.name, phs.err].join('|');
    if (panel.dataset.key === key) return;
    panel.dataset.key = key;
    var dg = { name: form.name, slot: d.slot };
    var h = '';
    /* the two ways in, as two big targets: the camera, and the photo library */
    var pickers = '<div class="wup-ph__ways">' +
      '<label class="wup-ph__way wup-ph__way--y"><input type="file" accept="image/*" capture="environment" class="wup-sr" data-wup-ph-file>' +
        '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.2"/></svg>' +
        '<span class="wup-ph__wayt"><b>' + phEsc(PHC.take || 'Take a photo') + '</b><i>' + phEsc(PHC.takeSub || 'Opens your camera') + '</i></span></label>' +
      '<label class="wup-ph__way"><input type="file" accept="image/*,.heic,.heif" class="wup-sr" data-wup-ph-file>' +
        '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 15l5-5 4 4 3-3 6 6"/><circle cx="16" cy="9" r="1.5"/></svg>' +
        '<span class="wup-ph__wayt"><b>' + phEsc(PHC.pick || 'Pick from your photos') + '</b><i>' + phEsc(PHC.pickSub || PHC.addSub || '') + '</i></span></label>' +
      '</div>';
    var stickers = phModal ? '<div class="wup-ph__row"><button type="button" class="wup-ph__btn wup-ph__btn--txt" data-wup-ph-act="stickers">' + phEsc(PHC.stickerInstead || 'Choose a sticker instead') + '</button></div>' : '';
    if (phs.mode === 'load') {
      h = '<p class="wup-ph__h wup-ph__wait" role="status">' + phEsc(PHC.loading || PHC.checking) + '</p>';
    } else if (phs.mode === 'tap') {
      h = '<p class="wup-ph__h">' + phEsc(phWords('tapH', dg)) + '</p>' +
        '<p class="wup-ph__sub wup-ph__tsub">' + phEsc(PHC.tapSub) + '</p>' +
        '<div class="wup-ph__cut"><div class="wup-ph__tap"><canvas data-wup-ph-tap aria-label="' + phEsc(phWords('tapH', dg)) + '"></canvas></div>' +
        '<div class="wup-ph__st"><canvas data-wup-ph-st width="320" height="320" role="img" aria-label="' + phEsc(phWords('name', dg)) + '"></canvas></div></div>' +
        '<div class="wup-ph__row wup-ph__row--act"><button type="button" class="wup-ph__btn wup-ph__btn--y" data-wup-ph-act="send" disabled>' + phEsc(PHC.use) + '</button>' +
        '<button type="button" class="wup-ph__btn" data-wup-ph-act="undo" disabled>' + phEsc(PHC.undo || 'Undo') + '</button>' +
        '<button type="button" class="wup-ph__btn wup-ph__btn--txt" data-wup-ph-act="cancel">' + phEsc(PHC.cancel) + '</button></div>';
    } else if (phs.mode === 'fit') {
      h = '<p class="wup-ph__h">' + phEsc(phWords('fitH', dg)) + '</p>' +
        '<div class="wup-ph__fit"><canvas data-wup-ph-cv aria-label="' + phEsc(phWords('fitH', dg)) + '"></canvas>' +
        '<span class="wup-ph__drag" aria-hidden="true">' + phEsc(PHC.drag) + '</span></div>' +
        '<div class="wup-ph__row wup-ph__row--z"><label class="wup-ph__zl" for="wup-ph-zoom">' + phEsc(PHC.zoom) + '</label>' +
        '<input id="wup-ph-zoom" type="range" min="100" max="300" step="1" value="' + Math.round(phs.z * 100) + '" data-wup-ph-zoom>' +
        '<button type="button" class="wup-ph__btn wup-ph__btn--ico" data-wup-ph-act="turn" aria-label="' + phEsc(PHC.turn) + '" title="' + phEsc(PHC.turn) + '">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12a8 8 0 1 1-3-6.2"/><path d="M20 4v5h-5"/></svg></button></div>' +
        '<div class="wup-ph__row wup-ph__row--act"><button type="button" class="wup-ph__btn wup-ph__btn--y" data-wup-ph-act="send">' + phEsc(PHC.use) + '</button>' +
        '<button type="button" class="wup-ph__btn" data-wup-ph-act="cancel">' + phEsc(PHC.cancel) + '</button></div>';
    } else if (phs.mode === 'check') {
      h = '<p class="wup-ph__h wup-ph__wait" role="status">' + phEsc(PHC.checking) + '</p>';
    } else if (phs.mode === 'nodog' || phs.mode === 'notok') {
      var no = phs.mode === 'nodog';
      h = '<div class="wup-ph__no" role="alert"><p class="wup-ph__h">' + phEsc(no ? PHC.noDogH : PHC.notOkH) + '</p>' +
        '<p class="wup-ph__p">' + phEsc(phWords(no ? 'noDog' : 'notOk', dg)) + '</p>' +
        '<div class="wup-ph__row">' + phFileBtn(phEsc(PHC.again), 'wup-ph__btn wup-ph__btn--y') + '</div></div>';
    } else if (!url) {
      /* an unsaved dog gets the pickers too (photo first, 2026-10-31): the dog
         is saved on Use, once it has a name and a weight */
      h = (phModal ? '' : '<p class="wup-ph__h">' + phEsc(phWords('add', dg)) + '</p>') + pickers + stickers;
    } else {
      h = '<div class="wup-ph__have"><span class="wup-ph__img' + (isSticker(url) ? ' is-st' : '') + '" style="background-image:url(' + phEsc(photoSized(url, 320)) + ')" role="img" aria-label="' + phEsc(phWords('name', dg)) + '"></span>' +
        '<div class="wup-ph__row">' +
        (form.icon !== 'photo' ? '<button type="button" class="wup-ph__btn wup-ph__btn--y" data-wup-ph-act="use">' + phEsc(PHC.use) + '</button>' : '') +
        '<button type="button" class="wup-ph__btn wup-ph__btn--txt" data-wup-ph-act="remove">' + phEsc(PHC.remove) + '</button></div></div>' +
        '<p class="wup-ph__sub">' + phEsc(PHC.replace) + '</p>' + pickers + stickers;
    }
    if (phs.err) h = '<p class="wup-ph__err" role="alert">' + phEsc(phs.err) + '</p>' + h;
    h += '<p class="wup-note wup-ph__note">' + phEsc(PHC.note) + '</p>';
    panel.innerHTML = h;
    if (phs.mode === 'fit') phDraw(panel);
    if (phs.mode === 'tap') phTapDraw(panel);
  }
  function phRepaint() {
    var box = dogBox && dogBox.querySelector('[data-wup-icons]');
    var panel = phPanel();
    if (panel) panel.dataset.key = '';
    if (box) renderPhoto(box);
  }

  /* ---------- THE PHOTO SHEET (2026-10-31, his pick A + D + E) ----------
     A camera badge on the resting card opens the photo step directly: no
     Edit, no "sticker and a color" fold, no Photo tab. The sheet BORROWS the
     picker's own photo panel (the node moves in, and moves back on close),
     so there is one photo flow, not two. Inside the sheet the action row is
     pinned to the bottom, so Use is never below the fold on a tall photo. */
  var phModal = false, phSheet = null, phHome = null;
  function phSheetEl() {
    if (phSheet) return phSheet;
    phSheet = document.createElement('div');
    phSheet.className = 'wup-phm';
    phSheet.setAttribute('data-wup-phm', '');
    phSheet.hidden = true;
    phSheet.innerHTML = '<div class="wup-phm__bg" data-wup-phm-close></div>' +
      '<div class="wup-phm__box" role="dialog" aria-modal="true" aria-labelledby="wup-phm-t">' +
        '<div class="wup-phm__hd"><b class="wup-phm__t" id="wup-phm-t" data-wup-phm-t></b>' +
          '<button type="button" class="wup-phm__x" data-wup-phm-close aria-label="' + phEsc(PHC.close || 'Close') + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<p class="wup-phm__p" data-wup-phm-sub></p>' +
        '<div class="wup-phm__body" data-wup-phm-body></div>' +
      '</div>';
    root.appendChild(phSheet);
    phSheet.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-wup-phm-close]')) phClose();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && phModal) phClose();
    });
    return phSheet;
  }
  function phOpen() {
    var d = active(), panel = phPanel(), sh = phSheetEl();
    if (!d || !panel || !PH) return;
    if (!phModal) { phHome = { parent: panel.parentNode, next: panel.nextSibling }; }
    phModal = true;
    var dg = { name: (form && form.name) || d.name, slot: d.slot };
    sh.querySelector('[data-wup-phm-t]').textContent = phWords('name', dg);
    sh.querySelector('[data-wup-phm-sub]').textContent = phWords('sheetSub', dg) || PHC.note || '';
    sh.querySelector('[data-wup-phm-body]').appendChild(panel);
    panel.hidden = false;
    sh.hidden = false;
    document.documentElement.classList.add('wup-phm-open');
    phReset();
    phRepaint();
    var x = sh.querySelector('[data-wup-phm-close][aria-label]');
    if (x) try { x.focus({ preventScroll: true }); } catch (e) {}
  }
  function phClose() {
    var panel = phPanel(), sh = phSheet;
    if (!phModal) return;
    phModal = false;
    if (phs.busy) { /* a save in flight finishes on its own */ }
    phReset();
    if (panel && phHome && phHome.parent) {
      phHome.parent.insertBefore(panel, phHome.next && phHome.next.parentNode === phHome.parent ? phHome.next : null);
      /* back in the form, out of sight: the action row is the way in (2026-10-31) */
      panel.hidden = true;
    }
    if (sh) sh.hidden = true;
    document.documentElement.classList.remove('wup-phm-open');
    phRepaint();
    var cam = dogBox && dogBox.querySelector('[data-wup-cam]');
    if (cam && !cam.hidden) try { cam.focus({ preventScroll: true }); } catch (e) {}
  }
  /* the badge on the resting card's avatar */
  function paintCam() {
    if (!dogBox) return;
    var av = dogBox.querySelector('[data-wup-card-av]');
    if (!av) return;
    var wrap = av.parentNode;
    if (!wrap.classList.contains('wup-pc__avw')) {
      wrap = document.createElement('span');
      wrap.className = 'wup-pc__avw';
      av.parentNode.insertBefore(wrap, av);
      wrap.appendChild(av);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wup-pc__cam';
      b.setAttribute('data-wup-cam', '');
      b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.2"/></svg>';
      wrap.appendChild(b);
    }
    var cam = wrap.querySelector('[data-wup-cam]');
    var d = active();
    var can = !!(PH && d && d.slot && d.status !== 'memorial');
    cam.hidden = !can;
    if (can) cam.setAttribute('aria-label', photoOf(d) ? phWords('name', d) : phWords('add', { name: form ? form.name : d.name }));
  }

  /* ---- reading the file ---- */
  var heicP = null;
  function heicLib() {
    if (window.heic2any) return Promise.resolve(window.heic2any);
    if (heicP) return heicP;
    heicP = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      s.async = true;
      s.onload = function () { if (window.heic2any) res(window.heic2any); else rej(new Error('heic')); };
      s.onerror = function () { heicP = null; rej(new Error('heic')); };
      document.head.appendChild(s);
    });
    return heicP;
  }
  function phDecode(blob) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(blob);
      var im = new Image();
      im.onload = function () { res(im); setTimeout(function () { URL.revokeObjectURL(u); }, 0); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      im.src = u;
    });
  }
  /* Down to a working size once, so dragging stays smooth on a phone. Browsers
     draw an <img> the right way up from its camera rotation tag. */
  function phShrink(im) {
    var w = im.naturalWidth || im.width, h = im.naturalHeight || im.height;
    if (!w || !h) throw new Error('empty');
    var k = Math.min(1, PH_MAX / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
    c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
    return c;
  }
  function phLoad(file) {
    var heic = /hei[cf]/i.test(file.type || '') || /\.hei[cf]$/i.test(file.name || '');
    return phDecode(file).catch(function (e) {
      if (!heic) throw e;
      return heicLib().then(function (h2a) { return h2a({ blob: file, toType: 'image/jpeg', quality: 0.9 }); })
        .then(function (out) { return phDecode(Array.isArray(out) ? out[0] : out); });
    }).then(phShrink);
  }
  function phFile(file) {
    if (!file) return;
    phs.err = '';
    phs.mode = 'load';
    phRepaint();
    phLoad(file).then(function (img) {
      return finder().then(function () { return 'tap'; }, function () { return 'fit'; }).then(function (mode) {
        phReset();
        phs.img = img; phs.mode = mode;
        phRepaint();
      });
    }).catch(function () {
      phReset(); phs.err = PHC.badFile || '';
      phRepaint();
    });
  }

  /* ---- the square ---- */
  function phGeo(V) {
    var im = phs.img, side = phs.rot % 180 !== 0;
    var ew = side ? im.height : im.width, eh = side ? im.width : im.height;
    var s = V / Math.min(ew, eh) * phs.z;
    return { ew: ew, eh: eh, s: s };
  }
  function phClamp(V) {
    var g = phGeo(V);
    var mx = Math.max(0, (g.ew * g.s - V) / 2), my = Math.max(0, (g.eh * g.s - V) / 2);
    phs.ox = Math.max(-mx, Math.min(mx, phs.ox));
    phs.oy = Math.max(-my, Math.min(my, phs.oy));
  }
  function phPaint(ctx, V) {
    var im = phs.img, g = phGeo(V);
    ctx.save();
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, V, V);
    ctx.translate(V / 2 + phs.ox, V / 2 + phs.oy);
    ctx.rotate(phs.rot * Math.PI / 180);
    ctx.drawImage(im, -im.width * g.s / 2, -im.height * g.s / 2, im.width * g.s, im.height * g.s);
    ctx.restore();
  }
  function phSide(cv) { return cv.clientWidth || 300; }
  function phDraw(panel) {
    var cv = panel && panel.querySelector('[data-wup-ph-cv]');
    if (!cv || !phs.img) return;
    var V = phSide(cv), dpr = Math.min(3, window.devicePixelRatio || 1);
    if (cv.width !== Math.round(V * dpr)) { cv.width = Math.round(V * dpr); cv.height = Math.round(V * dpr); }
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    phClamp(V);
    phPaint(ctx, V);
  }
  function phJpeg(panel) {
    var cv = panel.querySelector('[data-wup-ph-cv]');
    var V = phSide(cv);
    var c = document.createElement('canvas');
    c.width = c.height = PH_SIDE;
    var ctx = c.getContext('2d');
    ctx.scale(PH_SIDE / V, PH_SIDE / V);
    phClamp(V);
    phPaint(ctx, V);
    return c.toDataURL('image/jpeg', 0.86).split(',')[1] || '';
  }

  /* ---- talking to wyn-customers ---- */
  function phPost(path, body) {
    return fetch(PH.api + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { ok: false, code: 'trouble' }; }); })
      .catch(function () { return { ok: false, code: 'trouble' }; });
  }
  function phErrWords(code, dog) {
    var k = { auth: 'reload', many: 'many', busy: 'busy', later: 'later', bad: 'badFile', savefirst: 'saveFirst' }[code] || 'trouble';
    return phWords(k, dog);
  }
  function phSend(panel) {
    var d = active();
    if (!d || phs.busy || !phs.img) return;
    /* a dog that has never been saved is saved now, so the photo has a slot
       to go to; without a name and a weight it cannot be, and the photo waits */
    if (!d.slot) {
      var miss = missingFor(form);
      if (miss) { phs.err = miss + ' ' + (PHC.needSave || 'The photo saves with the dog.'); phRepaint(); return; }
      if (dirtyDog()) commit();
      d = active();
      if (!d || !d.slot) { phs.err = phWords('saveFirst', { name: form.name, slot: null }); phRepaint(); return; }
    }
    phs.err = '';
    var tapMode = phs.mode === 'tap';
    if (tapMode && !phs.st) return;
    var img = tapMode ? phPng() : phJpeg(panel);
    if (!img) { phReset(); phs.err = PHC.badFile || ''; phRepaint(); return; }
    phs.busy = true; phs.mode = 'check'; phRepaint();
    var slot = d.slot;
    phPost('/save', { auth: PH.auth, slot: slot, image: img, kind: tapMode ? 'png' : 'jpeg' }).then(function (j) {
      phs.busy = false;
      if (j && j.ok && j.url) {
        PHOTOS[String(slot)] = j.url;
        phReset();
        /* wyn-customers saved the look as "photo" too, so this is not a staged
           change. If it could not, the look waits for the usual Save. */
        if (j.lookSaved !== false) d.icon = 'photo';
        if (active() === d) {
          form.icon = 'photo';
          if (j.lookSaved !== false && base) base.icon = 'photo';
        }
        saveRoster(); render(); paint();
        phRepaint();
        if (phModal) phClose();
        return;
      }
      var code = j && j.code;
      phReset();
      if (code === 'nodog' || code === 'notok') phs.mode = code;
      else phs.err = phErrWords(code, { name: d.name });
      phRepaint();
    });
  }
  function phRemove() {
    var d = active();
    if (!d || !d.slot || phs.busy) return;
    phs.busy = true;
    var slot = d.slot;
    phPost('/remove', { auth: PH.auth, slot: slot }).then(function (j) {
      phs.busy = false;
      if (!(j && j.ok)) { phs.err = phErrWords(j && j.code, { name: d.name }); phRepaint(); return; }
      delete PHOTOS[String(slot)];
      var back = typeof j.icon === 'string' ? j.icon : null;
      if (d.icon === 'photo') d.icon = back || '';
      if (active() === d) {
        if (base && base.icon === 'photo') base.icon = back || '';
        if (form.icon === 'photo') form.icon = back || (base ? base.icon : '');
      }
      phReset();
      saveRoster(); render(); paint();
      phRepaint();
    });
  }

  function photoWire(box) {
    var panel = box.querySelector('[data-wup-photo]');
    if (!panel) return;
    panel.addEventListener('change', function (ev) {
      var inp = ev.target.closest('[data-wup-ph-file]');
      if (inp && inp.files && inp.files[0]) phFile(inp.files[0]);
    });
    panel.addEventListener('input', function (ev) {
      var z = ev.target.closest('[data-wup-ph-zoom]');
      if (!z) return;
      phs.z = Math.max(1, Math.min(3, (parseInt(z.value, 10) || 100) / 100));
      phDraw(panel);
    });
    panel.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-wup-ph-act]');
      if (!b) return;
      var a = b.dataset.wupPhAct;
      if (a === 'turn') { phs.rot = (phs.rot + 90) % 360; phDraw(panel); }
      else if (a === 'cancel') { phReset(); phRepaint(); }
      else if (a === 'send') phSend(panel);
      else if (a === 'remove') phRemove();
      else if (a === 'use') { form.icon = 'photo'; if (phModal) { commit(); phClose(); } else render(); }
      else if (a === 'stickers') {
        phClose();
        editing = true; render();
        var folds = dogBox.querySelectorAll('details.wup-fold');
        var lookFold = folds[folds.length - 1];
        if (lookFold) lookFold.open = true;
        var ib = dogBox.querySelector('[data-wup-icons]');
        if (ib && ib.setGrp) ib.setGrp('s');
        if (lookFold && lookFold.scrollIntoView) lookFold.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      else if (a === 'undo') { phs.masks.pop(); phs.taps.pop(); phs.st = phs.masks.length ? phSticker() : null; phTapDraw(panel); }
    });
    /* a tap on the dog = one more piece of dog */
    panel.addEventListener('click', function (ev) {
      var cv = ev.target.closest('[data-wup-ph-tap]');
      if (!cv || phs.mode !== 'tap' || !phs.img || !mpSeg) return;
      var r = cv.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
      if (!(x >= 0 && x <= 1 && y >= 0 && y <= 1)) return;
      try {
        var W = phs.img.width, H = phs.img.height;
        var px = Math.min(W - 1, Math.floor(x * W)) + Math.min(H - 1, Math.floor(y * H)) * W;
        mpSeg.segment(phs.img, { keypoint: { x: x, y: y } }, function (res) {
          var best = null, bv = -1;
          (res.confidenceMasks || []).forEach(function (m) { var a2 = m.getAsFloat32Array(); if (a2[px] > bv) { bv = a2[px]; best = new Float32Array(a2); } });
          if (best) { phs.masks.push(best); phs.taps.push({ x: x, y: y }); }
        });
        phs.st = phs.masks.length ? phSticker() : null;
      } catch (e) {
        /* the model gave up on this phone: the round photo is the fallback */
        try { console.warn('[wup] dog finder', e); } catch (e2) {}
        phs.mode = 'fit'; phs.taps = []; phs.masks = []; phs.st = null; phRepaint(); return;
      }
      phTapDraw(panel);
    });
    /* dragging the photo inside the square */
    var drag = null;
    panel.addEventListener('pointerdown', function (ev) {
      var cv = ev.target.closest('[data-wup-ph-cv]');
      if (!cv || !phs.img) return;
      drag = { x: ev.clientX, y: ev.clientY, ox: phs.ox, oy: phs.oy };
      try { cv.setPointerCapture(ev.pointerId); } catch (e) {}
      ev.preventDefault();
    });
    panel.addEventListener('pointermove', function (ev) {
      if (!drag) return;
      phs.ox = drag.ox + (ev.clientX - drag.x);
      phs.oy = drag.oy + (ev.clientY - drag.y);
      phDraw(panel);
    });
    var stop = function () { drag = null; };
    panel.addEventListener('pointerup', stop);
    panel.addEventListener('pointercancel', stop);
    /* a photo dropped on the panel, on a laptop */
    panel.addEventListener('dragover', function (ev) { if (phs.mode !== 'check') ev.preventDefault(); });
    panel.addEventListener('drop', function (ev) {
      var f = ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0];
      if (!f || phs.mode === 'check') return;
      ev.preventDefault();
      phFile(f);
    });
  }

  /* ---- the dog finder (Google's tap-to-select model, in this browser) ----
     Loaded once, when the Photo tab first shows the add button, so it is
     usually ready by the time a photo is picked. A failure is remembered and
     the round photo takes over for the rest of the visit. */
  var mpSeg = null, mpP = null;
  function finder() {
    if (mpSeg) return Promise.resolve(mpSeg);
    if (mpP) return mpP;
    mpP = mpImport(MP_LIB + '/vision_bundle.mjs').then(function (mp) {
      return mp.FilesetResolver.forVisionTasks(MP_LIB + '/wasm').then(function (files) {
        var make = function (dlg) {
          return mp.InteractiveSegmenter.createFromOptions(files, {
            baseOptions: { modelAssetPath: MP_MODEL, delegate: dlg },
            outputCategoryMask: false, outputConfidenceMasks: true });
        };
        return make('GPU').catch(function () { return make('CPU'); });
      });
    }).then(function (seg) { mpSeg = seg; return seg; });
    mpP.catch(function (e) { try { console.warn('[wup] dog finder did not load', e); } catch (e2) {} });
    return mpP;
  }
  /* SHOPIFY REWRITES import() WHEN IT SHRINKS THIS FILE (found live
     2026-10-29: the published wup.js said require(...), which does not exist
     in a browser, so every customer got the round fallback). So the import
     runs from a tiny script element whose text is a plain string the
     shrinker leaves alone. */
  function mpImport(url) {
    return new Promise(function (res, rej) {
      var key = '__wupMp' + Date.now() + Math.floor(Math.random() * 1e6);
      var t = setTimeout(function () { done(); rej(new Error('timed out')); }, 45000);
      var s = document.createElement('script');
      function done() { clearTimeout(t); try { delete window[key]; } catch (e) { window[key] = undefined; } if (s.parentNode) s.parentNode.removeChild(s); }
      window[key] = { ok: function (m) { done(); res(m); }, no: function (e) { done(); rej(e); } };
      s.textContent = 'im' + 'port(' + JSON.stringify(url) + ').then(window.' + key + '.ok, window.' + key + '.no);';
      document.head.appendChild(s);
    });
  }
  /* A saved sticker is a see-through PNG; a photo saved before the sticker
     existed (or by the round fallback) is a JPEG. The address says which. */
  function isSticker(u) { return /\.png(\?|$)/i.test(String(u || '')); }

  /* ---- the cut-out, done like a real die-cut sticker ----
     1. keep only the patch that was tapped (stray specks would grow their own
        faint rings) and fill holes inside the dog
     2. grow the yellow border out from that shape, then round off the small
        notches so the outline is smooth instead of following every tuft
     3. pull the photo's own edge in a little, so a fringe of background colour
        in the fur lands on the yellow, not on top of it
     Tuned on his own test page (dog-sticker-TEST2): border 5% of the dog's
     size, rounding 1.8 x border, edge pulled in 2 px. */
  function phChamfer(inside, w, h) {
    var d = new Float32Array(w * h), R = 1.4142, x, y, i, v;
    for (i = 0; i < d.length; i++) d[i] = inside[i] ? 0 : 1e9;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; v = d[i]; if (!v) continue;
      if (x > 0) v = Math.min(v, d[i - 1] + 1);
      if (y > 0) { v = Math.min(v, d[i - w] + 1); if (x > 0) v = Math.min(v, d[i - w - 1] + R); if (x < w - 1) v = Math.min(v, d[i - w + 1] + R); }
      d[i] = v;
    }
    for (y = h - 1; y >= 0; y--) for (x = w - 1; x >= 0; x--) {
      i = y * w + x; v = d[i]; if (!v) continue;
      if (x < w - 1) v = Math.min(v, d[i + 1] + 1);
      if (y < h - 1) { v = Math.min(v, d[i + w] + 1); if (x < w - 1) v = Math.min(v, d[i + w + 1] + R); if (x > 0) v = Math.min(v, d[i + w - 1] + R); }
      d[i] = v;
    }
    return d;
  }
  function c01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function phSticker() {
    var img = phs.img, W = img.width, H = img.height, n = W * H, i, x, y;
    var raw = new Float32Array(n);
    phs.masks.forEach(function (m) { for (var k = 0; k < n; k++) if (m[k] > raw[k]) raw[k] = m[k]; });
    var bin = new Uint8Array(n), lab = new Int32Array(n), q = new Int32Array(n), sizes = [0];
    for (i = 0; i < n; i++) bin[i] = raw[i] > 0.5 ? 1 : 0;
    for (var s0 = 0; s0 < n; s0++) {
      if (!bin[s0] || lab[s0]) continue;
      var id = sizes.length, qh = 0, qt = 0, cnt = 0;
      q[qt++] = s0; lab[s0] = id;
      while (qh < qt) {
        i = q[qh++]; cnt++; x = i % W; y = (i / W) | 0;
        if (x > 0 && bin[i - 1] && !lab[i - 1]) { lab[i - 1] = id; q[qt++] = i - 1; }
        if (x < W - 1 && bin[i + 1] && !lab[i + 1]) { lab[i + 1] = id; q[qt++] = i + 1; }
        if (y > 0 && bin[i - W] && !lab[i - W]) { lab[i - W] = id; q[qt++] = i - W; }
        if (y < H - 1 && bin[i + W] && !lab[i + W]) { lab[i + W] = id; q[qt++] = i + W; }
      }
      sizes.push(cnt);
    }
    var keep = {}, any = false;
    phs.taps.forEach(function (t) {
      var l = lab[Math.min(H - 1, Math.floor(t.y * H)) * W + Math.min(W - 1, Math.floor(t.x * W))];
      if (l) { keep[l] = 1; any = true; }
    });
    if (!any) { var big = 0; for (var l2 = 1; l2 < sizes.length; l2++) if (sizes[l2] > (sizes[big] || 0)) big = l2; if (big) keep[big] = 1; }
    var x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (i = 0; i < n; i++) {
      bin[i] = keep[lab[i]] ? 1 : 0;
      if (bin[i]) { x = i % W; y = (i / W) | 0; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1, side = Math.max(bw, bh);
    var Y = Math.max(4, side * 0.05), I = Math.max(2, side * 0.012), S = Math.max(2, side * 0.022), C = Math.max(4, Y * 1.8), E = 2;
    var P = Math.ceil(Y + C + I + S + 6), cw = bw + 2 * P, ch = bh + 2 * P, cn = cw * ch;
    var dog = new Uint8Array(cn), a = new Float32Array(cn);
    for (y = 0; y < bh; y++) for (x = 0; x < bw; x++) {
      var si = (y + y0) * W + x + x0, di = (y + P) * cw + x + P;
      dog[di] = bin[si]; a[di] = bin[si] ? c01((raw[si] - 0.3) / 0.3) : 0;
    }
    /* holes: anything not dog that the outside cannot reach */
    var outside = new Uint8Array(cn), qq = new Int32Array(cn), h0 = 0, t0 = 0;
    var push = function (k) { if (!dog[k] && !outside[k]) { outside[k] = 1; qq[t0++] = k; } };
    for (x = 0; x < cw; x++) { push(x); push((ch - 1) * cw + x); }
    for (y = 0; y < ch; y++) { push(y * cw); push(y * cw + cw - 1); }
    while (h0 < t0) { i = qq[h0++]; x = i % cw; if (x > 0) push(i - 1); if (x < cw - 1) push(i + 1); if (i >= cw) push(i - cw); if (i < cw * (ch - 1)) push(i + cw); }
    for (i = 0; i < cn; i++) if (!dog[i] && !outside[i]) { dog[i] = 1; a[i] = 1; }
    var dOut = phChamfer(dog, cw, ch), notGrown = new Uint8Array(cn);
    for (i = 0; i < cn; i++) notGrown[i] = dOut[i] <= Y + C ? 0 : 1;
    var dIn = phChamfer(notGrown, cw, ch), yA = new Float32Array(cn), yBin = new Uint8Array(cn);
    for (i = 0; i < cn; i++) { yA[i] = c01(dIn[i] - C + 0.5); yBin[i] = yA[i] >= 0.5 ? 1 : 0; }
    var dY = phChamfer(yBin, cw, ch), inkA = new Float32Array(cn);
    for (i = 0; i < cn; i++) inkA[i] = c01(I + 0.5 - dY[i]);
    var notDog = new Uint8Array(cn);
    for (i = 0; i < cn; i++) notDog[i] = dog[i] ? 0 : 1;
    var dDog = phChamfer(notDog, cw, ch);
    var src = img.getContext('2d').getImageData(0, 0, W, H).data;
    var layer = function (fill) {
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var g = c.getContext('2d'), dd = g.createImageData(cw, ch); fill(dd.data); g.putImageData(dd, 0, 0); return c;
    };
    var solid = function (al, r, gg, b) {
      return layer(function (o) { for (var k = 0; k < cn; k++) { o[k * 4] = r; o[k * 4 + 1] = gg; o[k * 4 + 2] = b; o[k * 4 + 3] = Math.round(al[k] * 255); } });
    };
    var ink = solid(inkA, 46, 46, 46), yel = solid(yA, 255, 216, 32);
    var pup = layer(function (o) {
      for (var yy = 0; yy < ch; yy++) for (var xx = 0; xx < cw; xx++) {
        var k = yy * cw + xx, sx = xx - P + x0, sy = yy - P + y0;
        if (!dog[k] || sx < 0 || sy < 0 || sx >= W || sy >= H) continue;
        var p4 = (sy * W + sx) * 4;
        o[k * 4] = src[p4]; o[k * 4 + 1] = src[p4 + 1]; o[k * 4 + 2] = src[p4 + 2];
        o[k * 4 + 3] = Math.round(Math.min(a[k], c01(dDog[k] - E + 0.5)) * 255);
      }
    });
    var N = Math.max(cw, ch) + Math.ceil(S);
    var fin = document.createElement('canvas'); fin.width = N; fin.height = N;
    var o2 = fin.getContext('2d'), ox = (N - S - cw) / 2, oy = (N - S - ch) / 2;
    o2.drawImage(ink, ox + S, oy + S); o2.drawImage(ink, ox, oy); o2.drawImage(yel, ox, oy); o2.drawImage(pup, ox, oy);
    return phTrim(fin);
  }
  /* TRIM TO THE STICKER (2026-10-29, "the picture feels a bit small"). The
     working canvas carries a wide see-through margin the border needed room
     to grow into; left in, the sticker filled only about half its square
     next to the other stickers, which fill theirs. Crop to what is actually
     drawn, then square it up around the middle. */
  function phTrim(c) {
    var w = c.width, h = c.height, d = c.getContext('2d').getImageData(0, 0, w, h).data;
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      if (d[(y * w + x) * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return c;
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1, side = Math.max(bw, bh) + 2;
    var out = document.createElement('canvas'); out.width = side; out.height = side;
    out.getContext('2d').drawImage(c, x0, y0, bw, bh, Math.round((side - bw) / 2), Math.round((side - bh) / 2), bw, bh);
    return out;
  }
  function phFitTo(canvas, src, pad) {
    var c = canvas.getContext('2d');
    c.clearRect(0, 0, canvas.width, canvas.height);
    if (!src) return;
    var room = canvas.width * (1 - 2 * (pad || 0));
    var k = Math.min(room / src.width, room / src.height);
    c.drawImage(src, (canvas.width - src.width * k) / 2, (canvas.height - src.height * k) / 2, src.width * k, src.height * k);
  }
  /* the photo with the found dog lit and the rest dimmed, and the sticker */
  function phTapDraw(panel) {
    var cv = panel && panel.querySelector('[data-wup-ph-tap]');
    if (!cv || !phs.img) return;
    var img = phs.img, W = img.width, H = img.height;
    cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    c.drawImage(img, 0, 0);
    if (phs.masks.length) {
      var d = c.getImageData(0, 0, W, H), p = d.data, n = W * H, i, m, j, v;
      for (i = 0; i < n; i++) {
        v = 0;
        for (j = 0; j < phs.masks.length; j++) { m = phs.masks[j][i]; if (m > v) v = m; }
        var k = 0.35 + 0.65 * c01((v - 0.3) / 0.4);
        p[i * 4] *= k; p[i * 4 + 1] *= k; p[i * 4 + 2] *= k;
      }
      c.putImageData(d, 0, 0);
      c.fillStyle = '#FFD820'; c.strokeStyle = '#2E2E2E'; c.lineWidth = Math.max(2, W / 300);
      phs.taps.forEach(function (t) { c.beginPath(); c.arc(t.x * W, t.y * H, Math.max(6, W / 80), 0, 7); c.fill(); c.stroke(); });
    }
    var st = panel.querySelector('[data-wup-ph-st]');
    if (st) { phFitTo(st, phs.st, 0.03); st.parentNode.classList.toggle('is-on', !!phs.st); }
    var go = panel.querySelector('[data-wup-ph-act="send"]'), un = panel.querySelector('[data-wup-ph-act="undo"]');
    if (go) go.disabled = !phs.st;
    if (un) un.disabled = !phs.masks.length;
  }
  /* the sticker as a square see-through PNG, smaller if it would be heavy */
  function phPng() {
    if (!phs.st) return '';
    var sizes = [PH_ST, 512, 400];
    for (var i = 0; i < sizes.length; i++) {
      var c = document.createElement('canvas'); c.width = c.height = sizes[i];
      phFitTo(c, phs.st, 0.01);
      var b64 = c.toDataURL('image/png').split(',')[1] || '';
      if (b64.length < 1100 * 1024 * 1.33) return b64;
    }
    return '';
  }

  function paintCard() {
    if (!dogBox || !form) return;
    paintAvatar(dogBox.querySelector('[data-wup-card-av]'),
                { id: active() ? active().id : '', icon: form.icon, colour: form.colour,
                  slot: active() ? active().slot : null, name: form.name });
    paintCam();
    var nm = dogBox.querySelector('[data-wup-card-name]');
    if (nm) nm.textContent = form.name.trim() || C.unnamed;

    var kcal = kcalFor(form);
    var stuck2 = !kcal && form.weight_lb != null;
    var fig = dogBox.querySelector('[data-wup-card-fig]');
    var kc = dogBox.querySelector('[data-wup-card-kcal]');
    var none = dogBox.querySelector('[data-wup-card-none]');
    if (fig) fig.hidden = !kcal;
    if (none) {
      none.hidden = !!kcal;
      none.textContent = stuck2 ? C.dogOutStuck : C.dogOutNone;
    }
    if (kc && kcal) kc.textContent = kcal;

    /* The dog's colour becomes the card's header, which is the point of picking
       one. pillInk is lifted from #wof and decides the type colour against it -
       the same three-way test the diet pills use, so a pale mint and a deep
       cardiac red both stay readable. */
    var top = dogBox.querySelector('[data-wup-pc-top]');
    if (top) {
      if (form.colour) {
        top.style.setProperty('--c', form.colour);
        top.style.setProperty('--pi', pillInk(form.colour));
        top.classList.add('has-c');
      } else {
        top.style.removeProperty('--c');
        top.style.removeProperty('--pi');
        top.classList.remove('has-c');
      }
    }

    /* Authorization is per dog and lives on the ACCOUNT, so it is matched by the
       slot this dog owns - the same claim Raven writes to. Shown only when Fresh
       Rx is actually in play, so a complete-and-balanced customer never sees it. */
    var rxEl = dogBox.querySelector('[data-wup-card-rx]');
    if (rxEl) {
      /* boot.auth only contains dogs that are authorized or pending, so the
         presence of a row IS the gate. A dog with no prescription diet and no
         date never sees an Rx line at all. */
      var row = authRowFor(active());
      var show = !!row;
      rxEl.hidden = !show;
      rxEl.classList.toggle('is-no', show && !row.rx);
      if (show) {
        rxEl.textContent = row.rx
          ? (C.cardRxYes + ' ' + fmtDate(row.rx))
          : C.cardRxNo;
      }
    }

    var facts = {
      weight: form.weight_lb == null ? null : form.weight_lb + ' lb',
      age: form.bday ? bdAgeText(form.bday) : labelFor('age', form.age),
      activity: labelFor('activity', form.activity),
      neuter: labelFor('neuter', form.neuter)
    };
    /* a puppy reads as "Puppy, 3 to 6 mo" rather than a bare month range */
    if (facts.age && !form.bday && PUP_FACTORS.indexOf(form.age) > -1) {
      var pb = dogBox.querySelector('[data-wup-pup]');
      if (pb) facts.age = pb.textContent.trim() + ', ' + facts.age;
    }
    Array.prototype.forEach.call(dogBox.querySelectorAll('[data-wup-fact]'), function (el2) {
      var v = facts[el2.dataset.wupFact];
      el2.textContent = v || C.unset;
      el2.classList.toggle('is-unset', !v);
    });
    paintBdBadge();
    paintBdAsk();
    paintPn(kcal);
  }

  /* ---- the next-birthday badge: REMOVED 2026-11-01 (Michael: "Turns 12"
     beside "11 years old" confused more than it helped). bdBadge() stays for
     a later birthday feature; nothing paints it. ---- */
  function paintBdBadge() {
    var b = dogBox.querySelector('[data-wup-bd-badge]');
    if (b) b.parentNode.removeChild(b);
  }

  /* ---- PORTION NOTE (2026-11-01, his pick "B") ----
     A small "Down from 390" tag beside the calories when the dog's daily
     amount changed ON ITS OWN because of its age, with a short why that opens
     on tap. Two kinds of change:
       'sw'      THE SWITCH TO BIRTHDAYS. Only a birthday WE estimated (one ~):
                 the amount before is what this page showed from the old age
                 answer (quiz age_in_months, still on the account, read with the
                 old at-or-under rule). Shown for 30 days from 2026-11-01.
       'x<max>'  A BIRTHDAY INTO A NEW STAGE (3, 6, 12 months, 7 years): shown
                 for 30 days from the day the dog crossed it, any birthday kind,
                 only for crossings after the switch.
     Never when: the home has no order in 120 days, a memorial dog, the figure
     did not actually move, a birthday question is on the card, or the owner
     has saved a change to the dog since (remembered in this browser). The
     numbers always use the dog's CURRENT weight and answers with only the age
     factor swapped, so the tag stays true after a weight change. */
  var PN_SWITCH = new Date(2026, 10, 1).getTime();
  var PN_DAYS = 30 * 86400000;
  var LS_PN = 'wup_pn';
  var pnOpen = '';
  function pnOldFactor(m) {
    var CFG = window.wynFeed && window.wynFeed.CFG;
    m = num(m);
    if (m == null || !(m > 0) || !CFG || !CFG.AGE_BUCKETS) return null;
    for (var i = 0; i < CFG.AGE_BUCKETS.length; i++) {
      var b = CFG.AGE_BUCKETS[i];
      if (b.max == null || m <= b.max) return b.factor;
    }
    return null;
  }
  function pnState() { try { return JSON.parse(lsGet(LS_PN) || '{}') || {}; } catch (e) { return {}; } }
  function pnChange(d, now) {
    if (!BD || !d || !d.bday || d.status === 'memorial' || !d.slot) return null;
    var CFG = window.wynFeed && window.wynFeed.CFG;
    if (!CFG || !CFG.AGE_BUCKETS) return null;
    var at = num(BOOT.orderAt);
    now = now || Date.now();
    if (!at || (now - at) > 120 * 86400000) return null;
    var p = bdParts(d.bday);
    if (!p) return null;
    var fNow = ageFromMonths(bdMonths(d.bday, new Date(now)), d.weight_lb);
    if (fNow == null) return null;
    var ch = null;
    if (p.est && !p.own && now >= PN_SWITCH && now - PN_SWITCH < PN_DAYS) {
      var rec = slotRec(d.slot), f0 = rec ? pnOldFactor(rec.am) : null;
      if (f0 != null && f0 !== fNow) ch = { id: 'sw', from: f0, to: fNow };
    }
    if (!ch) {
      var born = new Date(p.y, p.m - 1, p.d || (p.est ? 1 : 15)).getTime();
      var bounds = typeof window.wynFeed.stageBounds === 'function' ? window.wynFeed.stageBounds(d.weight_lb)
        : CFG.AGE_BUCKETS.filter(function (b) { return b.max != null && isFinite(b.max); }).map(function (b) { return { at: b.max, from: b.factor }; });
      for (var i = 0; i < bounds.length; i++) {
        var t = born + bounds[i].at * MO_MS;
        if (t <= now && now - t < PN_DAYS && t >= PN_SWITCH && bounds[i].from !== fNow) { ch = { id: 'x' + bounds[i].at, from: bounds[i].from, to: fNow }; break; }
      }
    }
    if (!ch) return null;
    if (pnState()[bdAskKey(d) + ':' + ch.id]) return null;
    return ch;
  }
  /* the owner saved the dog themselves: they know why the number moved */
  function pnDismiss(d) {
    var ch = pnChange(d);
    if (!ch) return;
    var all = pnState();
    all[bdAskKey(d) + ':' + ch.id] = Date.now();
    lsSet(LS_PN, JSON.stringify(all));
  }
  function pnLine(ch, d, oldK, newK) {
    var key = oldK < newK ? 'pnMore' : (ch.to === 0.9 ? 'pnSenior' : (ch.to === 1 ? 'pnAdult' : 'pnPuppy'));
    var nm = String(d.name || '').trim() || C.unnamed;
    return bdSay(BDC[key], { name: nm, age: String(bdAgeText(d.bday) || '').toLowerCase(), old: oldK, 'new': newK });
  }
  function paintPn(kcal) {
    var fig = dogBox.querySelector('[data-wup-card-fig]');
    var t = dogBox.querySelector('.wup-pc__t');
    if (!fig || !t) return;
    var tag = fig.querySelector('[data-wup-pn]'), pop = t.querySelector('[data-wup-pn-pop]');
    var d = active();
    var ask = dogBox.querySelector('[data-wup-bask]');
    var asking = !!(ask && !ask.hidden);
    var ch = (kcal && d && !asking) ? pnChange(d) : null;
    var oldK = ch ? kcalFor(Object.assign({}, form, { age: ch.from, bday: '' })) : null;
    if (!ch || !oldK || oldK === kcal) {
      if (tag) tag.hidden = true;
      if (pop) pop.hidden = true;
      return;
    }
    if (!tag) {
      tag = document.createElement('button');
      tag.type = 'button';
      tag.className = 'wup-pn';
      tag.setAttribute('data-wup-pn', '');
      fig.appendChild(tag);
    }
    if (!pop) {
      pop = document.createElement('div');
      pop.className = 'wup-pn__pop';
      pop.setAttribute('data-wup-pn-pop', '');
      pop.id = 'wup-pn-pop';
      t.appendChild(pop);
    }
    tag.innerHTML = escH(bdSay(oldK > kcal ? BDC.pnDown : BDC.pnUp, { n: oldK })) + ' <i aria-hidden="true">?</i>';
    tag.setAttribute('aria-controls', 'wup-pn-pop');
    var open = pnOpen === d.id;
    tag.setAttribute('aria-expanded', open ? 'true' : 'false');
    tag.hidden = false;
    pop.innerHTML = '<b>' + escH(bdSay(BDC.pnHead, { 'new': kcal })) + '</b><span>' + escH(pnLine(ch, d, oldK, kcal)) + '</span>';
    pop.hidden = !open;
  }

  /* ---- "When is their birthday?" on an existing dog's card ----
     NOT ANNOYING, his words in capitals: one dog at a time, on the dog's own
     card only (never Reorder, never near checkout), only for a home that has
     ordered in the last 120 days, never for a memorial dog. "Not now" hides it
     for 30 days; after the second "Not now" it never asks for that dog again. */
  /* ESTIMATED BIRTHDAYS (2026-11-01): "Do you know [name]'s real birthday?"
     on a dog whose birthday WE estimated (one ~). His rule: the logic has to
     be perfect, no unnecessary pings. It shows only when ALL of these hold:
       - BDC.estOn is true (the switch in wup-bday.liquid; off until the
         owner estimates saved before this update are marked ~~)
       - the birthday has exactly one ~ (never a date, never ~~)
       - living dog with a slot and a name, this page can sign the birthday
       - the home ordered in the last 120 days
       - this device has not seen an answer for this dog, and has not shown the
         box on another visit in the last 30 days, and has shown it on fewer
         than 3 visits (so ignoring it is also an answer)
       - it is the ONE dog picked for a box this visit (below)
     Save writes the real date; Keep the estimate writes ~~ and the same month.
     Either answer is on the account, so it ends on every device.
     ONE BOX PER VISIT, for both kinds: the first time a box could show in a
     visit (this tab), one dog is picked - a dog with no birthday before an
     estimated one, then the main dog, then roster order - and only that dog
     can show a box until the tab is closed. */
  var LS_BDASK = 'wup_bd_ask';
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  var BD_VISIT = ssGet('wup_bd_visit') || '';
  if (!BD_VISIT) { BD_VISIT = String(Date.now()); ssSet('wup_bd_visit', BD_VISIT); }
  function bdAskKey(d) { return d ? (d.slot ? 's' + d.slot : d.id) + ':' + nameKey(d.name) : ''; }
  function bdAskState() { try { return JSON.parse(lsGet(LS_BDASK) || '{}') || {}; } catch (e) { return {}; } }
  function bdAskPut(k, v) { var all = bdAskState(); all[k] = v; lsSet(LS_BDASK, JSON.stringify(all)); }
  /* '' (no box), 'wt' (no weight), 'none' (no birthday) or 'est' (a
     birthday we estimated). WEIGHT (2026-11-02): asked first, because
     without it the card has no calorie figure at all; same rules as the
     birthday question ("Not now" = 30 days, never after the second). */
  function bdAskKind(d) {
    if (!BD || !d || d.status === 'memorial' || !d.slot || !String(d.name || '').trim()) return '';
    var at = num(BOOT.orderAt);
    if (!at || (Date.now() - at) > 120 * 86400000) return '';
    if (!BOOT.ravenOn) return '';
    var all = bdAskState(), k = bdAskKey(d);
    if (d.weight_lb == null && ravenDef('dog_' + d.slot + '_weight') && BDC.wtHead) {
      var ws = all['w:' + k];
      if (!(ws && (ws.n >= 2 || Date.now() < (ws.until || 0)))) return 'wt';
    }
    if (!ravenDef('dog_' + d.slot + '_birthday')) return '';
    if (!d.bday) {
      var st = all[k];
      if (st && (st.n >= 2 || Date.now() < (st.until || 0))) return '';
      return 'none';
    }
    if (BDC.estOn !== true) return '';
    var p = bdParts(d.bday);
    if (!p || !p.est || p.own) return '';
    var e = all['e:' + k];
    if (e && (e.done || (e.v !== BD_VISIT && ((e.n || 0) >= 3 || Date.now() < (e.until || 0))))) return '';
    return 'est';
  }
  function bdAskWanted(d) { return !!bdAskKind(d); }
  /* the one dog that may show a box this visit ('-' = none) */
  function bdAskPick() {
    var k = ssGet('wup_bd_pick');
    if (k) return k;
    var best = null, bs = 9;
    (R && R.list || []).forEach(function (d) {
      var kd = bdAskKind(d);
      if (!kd) return;
      var sc = ({ wt: 0, none: 2, est: 4 })[kd] + (d.id === R.primaryId ? 0 : 1);
      if (sc < bs) { bs = sc; best = d; }
    });
    k = best ? bdAskKey(best) : '-';
    ssSet('wup_bd_pick', k);
    return k;
  }
  var bdAskDone = '';
  function paintBdAsk() {
    var card = dogBox.querySelector('[data-wup-view="card"]');
    var top = dogBox.querySelector('[data-wup-pc-top]');
    if (!card || !top) return;
    var box = card.querySelector('[data-wup-bask]');
    var d = active();
    var thanks = !!d && bdAskDone === d.id;
    var kind = d && !thanks && ssGet('wup_bd_spent') !== '1' && bdAskPick() === bdAskKey(d) ? bdAskKind(d) : '';
    if (!kind && !thanks) { if (box) box.hidden = true; return; }
    var nm = String(d.name || '').trim();
    if (!box || box.dataset.dog !== d.id || (kind && box.dataset.kind !== kind)) {
      if (box) box.parentNode.removeChild(box);
      box = document.createElement('div');
      box.className = 'wup-bask';
      box.setAttribute('data-wup-bask', '');
      box.dataset.dog = d.id;
      box.dataset.kind = kind;
      var acts = kind === 'wt'
        ? '<button type="button" class="wup-btn wup-bask__go" data-wup-bask-save>' + escH(BDC.askSave || 'Save') + '</button>' +
          '<button type="button" class="wup-bd__link" data-wup-bask-later>' + escH(BDC.askLater || '') + '</button>'
        : kind === 'est'
        ? '<button type="button" class="wup-btn wup-bask__go" data-wup-bask-save>' + escH(BDC.askSave || 'Save') + '</button>' +
          '<button type="button" class="wup-bd__link" data-wup-bask-keep>' + escH(BDC.estKeep || '') + '</button>'
        : '<button type="button" class="wup-btn wup-bask__go" data-wup-bask-save>' + escH(BDC.askSave || 'Save') + '</button>' +
          '<button type="button" class="wup-bd__link" data-wup-bask-later>' + escH(BDC.askLater || '') + '</button>' +
          '<button type="button" class="wup-bd__link" data-wup-bd-mode="est" data-wup-bd-show="date">' + escH(BDC.askEst || '') + '</button>' +
          '<button type="button" class="wup-bd__link" data-wup-bd-mode="date" data-wup-bd-show="est" hidden>' + escH(BDC.toDate || '') + '</button>';
      if (kind === 'wt') box.innerHTML = '<div class="wup-bd" data-wup-bd data-mode="wt">' +
        '<h3 class="wup-bask__h">' + escH(bdSay(BDC.wtHead, { name: nm })) + '</h3>' +
        '<p class="wup-bask__p">' + escH(bdSay(BDC.wtLine, { name: nm })) + '</p>' +
        '<div class="wup-bd__row"><label class="wup-bd__num"><input type="number" id="wup-bask-w" min="2" max="250" step="0.1" inputmode="decimal" placeholder="' + escH(BDC.wtPh || '') + '" data-wup-bask-w aria-label="' + escH(bdSay(BDC.wtHead, { name: nm })) + '"><span>' + escH(BDC.wtUnit || 'lb') + '</span></label></div>' +
        '<p class="wup-bd__err" data-wup-bd-err role="alert" hidden></p>' +
        '<div class="wup-bask__acts">' + acts + '</div></div>' +
        '<p class="wup-bask__ok" data-wup-bask-ok hidden>' + escH(BDC.askSaved || '') + '</p>';
      else box.innerHTML = '<div class="wup-bd" data-wup-bd data-mode="date">' +
        '<h3 class="wup-bask__h">' + escH(bdSay(kind === 'est' ? BDC.estHead : BDC.askHead, { name: nm })) + '</h3>' +
        '<p class="wup-bask__p">' + escH(bdSay(kind === 'est' ? BDC.estLine : BDC.askLine, { name: nm })) + '</p>' +
        (kind === 'est' ? '' : '<p class="wup-lab" data-wup-bd-show="est" hidden>' + escH(BDC.estLabel || '') + '</p>') +
        bdFieldHtml('wup-bask', false) +
        '<p class="wup-bd__err" data-wup-bd-err role="alert" hidden></p>' +
        '<div class="wup-bask__acts">' + acts + '</div></div>' +
        '<p class="wup-bask__ok" data-wup-bask-ok hidden>' + escH(BDC.askSaved || '') + '</p>';
      top.parentNode.insertBefore(box, top.nextSibling);
    }
    /* count this visit for an estimated dog the first time the box is on screen */
    if (kind === 'est') {
      var ek = 'e:' + bdAskKey(d), e = bdAskState()[ek];
      if (!e || e.v !== BD_VISIT) bdAskPut(ek, { n: ((e && e.n) || 0) + 1, v: BD_VISIT, until: Date.now() + 30 * 86400000 });
    }
    box.hidden = false;
    var inner = box.querySelector('[data-wup-bd]'), ok = box.querySelector('[data-wup-bask-ok]');
    if (inner) inner.hidden = !!thanks;
    if (ok) ok.hidden = !thanks;
  }
  function bdAskLater(d, kind) {
    ssSet('wup_bd_spent', '1');
    var all = bdAskState(), k = (kind === 'wt' ? 'w:' : '') + bdAskKey(d), st = all[k] || { n: 0 };
    st.n = (st.n || 0) + 1;
    st.until = Date.now() + 30 * 86400000;
    all[k] = st;
    lsSet(LS_BDASK, JSON.stringify(all));
    paintBdAsk();
  }
  /* an answer for an estimated dog: never ask again on this device, even
     while the account is still catching up with the save */
  function bdAskAnswered(d) {
    var ek = 'e:' + bdAskKey(d), e = bdAskState()[ek] || {};
    e.done = Date.now();
    bdAskPut(ek, e);
  }
  function bdAskSave(d, box) {
    var outer = box.closest('[data-wup-bask]');
    if (outer && outer.dataset.kind === 'wt') {
      var wi = box.querySelector('[data-wup-bask-w]'), wbe = box.querySelector('[data-wup-bd-err]');
      var wv = parseFloat(String(wi ? wi.value : '').replace(',', '.'));
      if (!(wv >= 2 && wv <= 250)) { if (wbe) { wbe.textContent = BDC.wtErr || ''; wbe.hidden = false; } return; }
      if (wbe) wbe.hidden = true;
      ssSet('wup_bd_spent', '1');
      d.weight_lb = Math.round(wv * 10) / 10;
      applyBday(d);
      saveRoster();
      mirror(true);
      bdAskDone = d.id;
      loadForm();
      paint();
      if (BOOT.ravenOn && window.FieldsRaven) ravenSaveDog(d).then(function (res) { lastRaven = res; });
      return;
    }
    var r = bdRead(box);
    var err = r.err || (r.bday ? '' : 'need');
    var be = box.querySelector('[data-wup-bd-err]');
    if (err) { if (be) { be.textContent = bdErrText(err, d.name); be.hidden = false; } return; }
    if (be) be.hidden = true;
    ssSet('wup_bd_spent', '1');
    if (d.bday) bdAskAnswered(d);
    d.bday = r.bday;
    applyBday(d);
    saveRoster();
    mirror(true);
    bdAskDone = d.id;
    loadForm();
    paint();
    if (BOOT.ravenOn && window.FieldsRaven) ravenSaveDog(d).then(function (res) { lastRaven = res; });
  }
  /* "Keep the estimate": the same month, now the owner's (~~) */
  function bdAskKeep(d) {
    var p = d && bdParts(d.bday);
    if (!p || !p.est || p.own) return;
    ssSet('wup_bd_spent', '1');
    bdAskAnswered(d);
    d.bday = bdClean('~' + d.bday);
    applyBday(d);
    saveRoster();
    mirror(true);
    loadForm();
    paint();
    if (BOOT.ravenOn && window.FieldsRaven) ravenSaveDog(d).then(function (res) { lastRaven = res; });
  }

  function loadForm() { form = snapOf(active()); base = snapOf(active()); render(true); }
  /* a dog that exists only because "+ Add a dog" was tapped: no account slot,
     nothing saved on it yet */
  function isNewDog(d) {
    return !!d && !d.slot && d.status !== 'memorial'
      && !String(d.name || '').trim() && d.weight_lb == null && !d.icon && !d.colour;
  }
  /* backing out of a dog that was never saved removes it, or a blank
     "Your dog" stays on the roster AND becomes the active dog site-wide
     (found live 2026-10-31) */
  function dropNewDog(d) {
    R.list = R.list.filter(function (x) { return x.id !== d.id; });
    R.activeId = '';
    editing = false;
    saveRoster(); mirror(true); loadForm(); paint();
  }

  function commit() {
    var d = active();
    if (!d || !dirtyDog() || missingFor(form)) return;
    pnDismiss(d);
    d.name = form.name.trim();
    d.weight_lb = form.weight_lb;
    d.age = form.age;
    /* an emptied field never erases a saved birthday: clearing one by accident
       would put the dog back on a stale age */
    if (form.bday) { d.bday = form.bday; applyBday(d); }
    d.activity = form.activity;
    d.neuter = form.neuter;
    d.colour = form.colour;
    d.icon = form.icon;
    saveRoster();
    mirror(true);
    base = snapOf(d); form = snapOf(d);
    editing = false;
    justSaved = true;
    clearTimeout(justSavedT);
    justSavedT = setTimeout(function () { justSaved = false; render(); }, 2600);
    render(); paint();
    var sv = el('[data-wup-save]'), svT = el('[data-wup-save-t]'), nt = el('[data-wup-note]');
    if (sv) { sv.disabled = true; sv.classList.add('is-done'); }
    if (svT) svT.textContent = C.dogSaved;
    if (nt) nt.textContent = BOOT.ravenOn ? '' : C.dogLocal;

    /* The local save has already happened and is what the page shows. The
       account write is additive and never blocks it: if Raven fails the
       customer keeps their change and the note says where it got to. */
    if (BOOT.ravenOn && window.FieldsRaven) {
      if (nt) nt.textContent = C.ravenSaving || C.dogLocal;
      ravenSaveDog(d).then(function (r) {
        lastRaven = r;
        if (nt) nt.textContent = r.ok ? (C.ravenOk || '') : (C.ravenFail || '');
      });
    }
  }

  function pick(id) {
    if (!R) return;
    var d = byId(R, id);
    if (!d || d.status === 'memorial') return;
    editing = false;
    R.activeId = id;
    saveRoster(); mirror(true); loadForm(); paint();
  }
  function toggle(sel) { var p = el(sel); if (p) p.hidden = !p.hidden; }
  function close(sel) { var p = el(sel); if (p) p.hidden = true; }

  if (dogBox) {
    dogBox.addEventListener('click', function (ev) {
      var t = ev.target;
      var p = t.closest('[data-wup-pick]');
      if (p) { pick(p.dataset.wupPick); return; }
      if (t.closest('[data-wup-newdog]')) {
        if (living().length >= maxDogs()) { renderRoster(); return; }
        var nd = blankDog('');
        R.list.push(nd); R.activeId = nd.id;
        editing = true;
        /* a new dog is a dog SWITCH: clear, or the bus keeps the old dog's
           weight and every product page sizes for the wrong animal */
        saveRoster(); mirror(true); loadForm();
        var f = el('[data-wup-f="name"]'); if (f) f.focus();
        return;
      }
      var opt = t.closest('[data-wup-opt]');
      if (opt) { var g = opt.dataset.wupOpt;
        form[g] = (g === 'neuter') ? opt.dataset.val : num(opt.dataset.val);
        var fo2 = el('[data-wup-fold]');
        if (fo2) fo2.dataset.touched = '1';
        render(); return; }
      var sw = t.closest('[data-wup-colour]');
      if (sw) { form.colour = (form.colour === sw.dataset.wupColour) ? '' : sw.dataset.wupColour;
        render(); return; }
      if (t.closest('[data-wup-pup]')) {
        /* Picking Puppy defaults to the middle band, the same default the buy
           box uses, rather than leaving the group with nothing selected. */
        if (PUP_FACTORS.indexOf(form.age) === -1) form.age = 1.5;
        var fo = el('[data-wup-fold]');
        if (fo) { fo.open = true; fo.dataset.touched = '1'; }
        render();
        return;
      }
      var w = t.closest('[data-wup-wt]');
      if (w) { var cur = form.weight_lb == null ? 0 : form.weight_lb;
        form.weight_lb = Math.min(250, Math.max(2, cur + parseInt(w.dataset.wupWt, 10)));
        render(); return; }
      var ico = t.closest('[data-wup-icon]');
      if (ico) {
        /* clicking the chosen one clears it, same as the colour swatches */
        form.icon = (form.icon === ico.dataset.wupIcon) ? '' : ico.dataset.wupIcon;
        render();
        return;
      }
      if (t.closest('[data-wup-cam]')) { phOpen(); return; }
      if (t.closest('[data-wup-edit]')) { editing = true; render(); return; }
      if (t.closest('[data-wup-undo]')) {
        var cur2 = active();
        if (isNewDog(cur2) && living().length > 1) { dropNewDog(cur2); return; }
        editing = false; loadForm(); return;
      }
      if (t.closest('[data-wup-save]')) { commit(); return; }
      var bm = t.closest('[data-wup-bd-mode]');
      if (bm) {
        var bbox = bm.closest('[data-wup-bd]');
        if (bbox) {
          bdSetMode(bbox, bm.dataset.wupBdMode === 'est');
          var ein = bbox.querySelector(bbox.dataset.mode === 'est' ? '[data-wup-bd-in="ey"]' : '[data-wup-bd-in="m"]');
          if (ein && ein.focus) ein.focus();
          if (!bbox.closest('[data-wup-bask]')) { bdFromForm(); render(); }
        }
        return;
      }
      if (t.closest('[data-wup-pn]')) {
        var pd = active();
        pnOpen = (pd && pnOpen !== pd.id) ? pd.id : '';
        paintCard();
        return;
      }
      if (t.closest('[data-wup-bask-later]')) { var lb0 = t.closest('[data-wup-bask]'); bdAskLater(active(), lb0 && lb0.dataset.kind); return; }
      if (t.closest('[data-wup-bask-keep]')) { if (active()) bdAskKeep(active()); return; }
      if (t.closest('[data-wup-bask-save]')) {
        var abox = t.closest('[data-wup-bask]');
        var ain = abox && abox.querySelector('[data-wup-bd]');
        if (ain && active()) bdAskSave(active(), ain);
        return;
      }
      if (t.closest('[data-wup-primary]')) {
        if (active()) { R.primaryId = active().id; saveRoster(); render(); }
        return;
      }
      /* The standing "Mark as passed" button was removed 2026-08-13; the
         question is asked inside the Remove confirm instead, below. */
      var um = t.closest('[data-wup-unmemorial]');
      if (um) {
        var back = byId(R, um.dataset.wupUnmemorial);
        if (back) {
          back.status = 'active'; saveRoster(); pick(back.id);
          if (BOOT.ravenOn && window.FieldsRaven && back.slot) ravenSaveDog(back);
        }
        return;
      }
      if (t.closest('[data-wup-remove]')) {
        var cur3 = active();
        if (isNewDog(cur3) && living().length > 1) { dropNewDog(cur3); return; }
        toggle('[data-wup-remove-confirm]'); return;
      }
      if (t.closest('[data-wup-remove-no]')) { close('[data-wup-remove-confirm]'); return; }
      /* "They passed away" - the dog STAYS in the roster as a memorial, is
         suppressed everywhere active, and the team is told, so nobody markets
         food at a dog who has died. Never a delete. */
      if (t.closest('[data-wup-remove-passed]')) {
        var gone2 = active();
        if (gone2) {
          gone2.status = 'memorial';
          if (!gone2.since) gone2.since = String(new Date().getFullYear());
          R.activeId = '';
          saveRoster(); mirror(true); loadForm(); paint();
          close('[data-wup-remove-confirm]');
          var nt2 = el('[data-wup-note]');
          if (nt2) nt2.textContent = C.passedOk || '';
          if (BOOT.ravenOn && ravenDef('customer_dog_passed')) {
            ravenPut('customer_dog_passed',
                     (gone2.name || 'Dog ' + (gone2.slot || '')) + ' | ' +
                     new Date().toISOString().slice(0, 10));
          }
          /* the memorial itself goes on the dog's own record, so every
             device shows it - the doorbell above is only the team's alert */
          if (BOOT.ravenOn && window.FieldsRaven && gone2.slot) ravenSaveDog(gone2);
        }
        return;
      }
      if (t.closest('[data-wup-remove-yes]')) {
        var gone = active();
        if (gone && living().length > 1) {
          R.list = R.list.filter(function (x) { return x.id !== gone.id; });
          if (gone.slot) {
            var acctName = (slotRec(gone.slot) || {}).name;
            if (String(acctName || '').trim()) {
              var gRec = { slot: gone.slot, name: String(acctName).trim() };
              R.gone = (R.gone || []).concat([gRec]);
              ravenRemove(gRec);
            }
          }
          R.activeId = '';
          saveRoster(); mirror(true); loadForm(); paint();
          close('[data-wup-remove-confirm]');
        }
        return;
      }
    });

    /* the birthday field: the form copy re-reads it; the ask box only clears
       its error, since it saves on its own button */
    function bdInput(ev) {
      var bin = ev.target.closest('[data-wup-bd-in]');
      if (!bin) return false;
      if (bin.closest('[data-wup-bask]')) {
        var ae = bin.closest('[data-wup-bd]').querySelector('[data-wup-bd-err]');
        if (ae) ae.hidden = true;
      } else { bdFromForm(); render(); }
      return true;
    }
    dogBox.addEventListener('input', function (ev) {
      if (bdInput(ev)) return;
      var sl2 = ev.target.closest('[data-wup-slide]');
      if (sl2) { form.weight_lb = slideToWt(sl2.value); render(); return; }
      var f = ev.target.closest('[data-wup-f]');
      if (!f) return;
      if (f.dataset.wupF === 'name') { form.name = f.value; render(); return; }
      var v = num(f.value);
      if (v !== null) form.weight_lb = Math.min(250, Math.max(2, v));
      render();
    });

    dogBox.addEventListener('change', function (ev) {
      if (bdInput(ev)) return;
      var f = ev.target.closest('[data-wup-f]');
      if (f) {
        if (f.dataset.wupF === 'name') { form.name = f.value.trim(); render(); return; }
        var v = num(f.value);
        if (v === null) { render(); return; }
        form.weight_lb = Math.min(250, Math.max(2, v));
        render(); return;
      }
    });
  }

  document.addEventListener('wyn:dog', function () {
    if (mirroring || !form) return;
    /* Another surface wrote to the shared bus after us - the footer dog-seed
       block is the usual one, since it runs later and fills blank fields from
       the account. Adopt anything this dog does not know, then redraw. Without
       this the page figure and the bus figure drift apart silently. */
    var was = active() ? JSON.stringify(active()) : '';
    reconcile();
    if (active() && JSON.stringify(active()) !== was && !dirtyDog()) loadForm();
    paint();
  });

  /* The vet panel lives in its own snippet and publishes its own config, so the
     section stays under its cap. Absent snippet = absent block = the dog card
     simply shows no Rx line, which is the correct degraded state. */
  (function () {
    var el2 = document.getElementById('wup-vet-boot');
    if (!el2) return;
    try {
      var v = JSON.parse(el2.textContent);
      BOOT.auth = v.auth || [];
      BOOT.rxRelevant = !!v.rxRelevant;
      BOOT.hasVet = !!v.hasVet;
      BOOT.vc = v.c || {};
      BOOT.vetUpdate = String(v.vetUpdate || '');
    } catch (e) {}
  }());

  /* ============================================================ RAVEN
     The only way this page can write a customer metafield. Contract confirmed
     from the FieldsRaven docs and his own raven-mac-gen snippet:

       PUT /apps/raven/create_metafield
       { raven: { raven_id, resource_id, raven_mac, value } }

     raven_mac is hmac_sha256(raven_id + resource_id) signed SERVER SIDE, so the
     definition object is opaque and is passed through untouched. A wrong value
     type comes back 422 and writes nothing, which is why a failed attempt is
     safe and a wrong SLOT would not be. */
  /* ---- SLOT SAFETY (2026-11-01), from #wup-slot-boot in wup-vet.liquid ----
     A slot holding a Fresh Rx authorization date is never given to a new dog:
     the customer cannot clear that date (no rid, by design), so the new dog
     would arrive already authorized and its Fresh Rx order could skip the
     vet hold. And an EMPTY slot can still hold an earlier dog's answers
     (its Fresh Rx diet request, sex, breed...), which a new dog must not
     inherit, so those are cleared with "None" when a new dog moves in.
     No block on the page (old snippet): no lock, no clearing, as before. */
  var SAFE = {};
  (function () {
    var el3 = document.getElementById('wup-slot-boot');
    if (!el3) return;
    try {
      (JSON.parse(el3.textContent || '[]') || []).forEach(function (r) {
        var n = Number(r && r.n);
        if (!n) return;
        SAFE[n] = { rxd: r.rxd === true, left: (r.left || []).filter(function (f) { return /^[a-z_]+$/.test(String(f || '')); }) };
      });
    } catch (e) { SAFE = {}; }
  }());
  function rxLocked(n) { return !!(SAFE[n] && SAFE[n].rxd); }
  function slotEmpty(n) { var r = slotRec(n); return !r || !String(r.name || '').trim(); }

  function ravenDef(name) {
    var F = window.FieldsRaven;
    if (!F || !F.definitions) return null;
    return F.definitions[name] || null;
  }

  var ravenWarned = false;
  function ravenPut(name, value) {
    var def = ravenDef(name);
    if (!def) return Promise.resolve({ ok: false, name: name, error: 'no definition for ' + name });
    /* CONFIRMED AGAINST THE LIVE APP 2026-08-12: the customer is identified by
       `customer_email` INSIDE the raven object. Without it the app returns
       422 "Invalid customer email".
       The email cannot be smuggled in via resource_id: that field is part of
       the HMAC, and changing it returns valid_params:true, valid_auth_code:false.
       Sending it at the top level alongside `raven` is also rejected. */
    /* TWO REGIMES, and the definition itself tells us which:
       - resource_id EMPTY (his older dog rids, rendered with resource_id: nil):
         the app cannot tell who this is, so `customer_email` must be supplied.
       - resource_id PRESENT (a raven set up with resource_id: customer.id):
         the customer is already identified and the email is not needed.
       The MAC is signed over raven_id + resource_id, so the definition's own
       resource_id is passed through untouched either way. */
    var payload = { raven_id: def.raven_id, resource_id: def.resource_id,
                    raven_mac: def.raven_mac, value: String(value) };
    if (!String(def.resource_id || '').trim()) {
      if (!BOOT.customerEmail) {
        return Promise.resolve({ ok: false, name: name, error: 'no customer email on the page' });
      }
      payload.customer_email = BOOT.customerEmail;
    }
    var body = { raven: payload };
    return fetch((window.FieldsRaven.endpoints || {}).create_single || '/apps/raven/create_metafield', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().catch(function () { return null; })
        .then(function (j) {
          /* valid_auth_code:false means the SIGNATURE was refused - the shop
             metafield fields_raven.api_secret no longer matches the secret the
             Fields Raven app checks against. No change to this file fixes that. */
          if (!ravenWarned && j && j.message && j.message.valid_auth_code === false) {
            ravenWarned = true;
            try { console.warn('[wup] Fields Raven refused the signature (valid_auth_code:false). ' +
              'The shop metafield fields_raven.api_secret does not match the app. Nothing is reaching the account.'); } catch (e) {}
          }
          return { ok: r.ok && r.status < 300, name: name, status: r.status, json: j,
                   message: j && j.message }; }); })
      .catch(function (e) { return { ok: false, name: name, error: e.message }; });
  }

  /* ---- which account slot does this roster dog belong to? ----
     MATCH BY NAME FIRST. Writing roster position 2 into account slot 2 would
     overwrite a DIFFERENT dog that the browser roster has never heard of, and
     that is unrecoverable. An unmatched dog takes the first EMPTY slot, and if
     there is none it is not written at all. */
  /* Slots claimed by OTHER dogs in the roster, so two dogs can never land on
     the same account record. */
  function claimedSlots(exceptId) {
    var out = {};
    if (!R) return out;
    R.list.forEach(function (d) {
      if (d.id !== exceptId && d.slot) out[d.slot] = true;
    });
    return out;
  }

  /* ---- which account slot does this dog own? ----
     1. A slot it has ALREADY CLAIMED wins outright. This is what makes a RENAME
        follow the dog: without it, renaming Ripley made her match nothing and
        take a fresh slot, leaving TWO records for one dog on the account.
     2. Otherwise match by name - right on a fresh device, where the roster has
        just been seeded and has claimed nothing.
     3. Otherwise the first EMPTY slot not claimed by another roster dog.
     4. Otherwise nothing, and nothing is written. */
  function slotFor(dog) {
    if (!dog) return null;
    var slots = BOOT.slots || [];
    var taken = claimedSlots(dog.id);
    var i;

    if (dog.slot && !taken[dog.slot] && !(rxLocked(dog.slot) && slotEmpty(dog.slot))) return dog.slot;

    var want = String(dog.name || '').trim().toLowerCase();
    if (want) {
      for (i = 0; i < slots.length; i++) {
        if (taken[slots[i].n]) continue;
        if (String(slots[i].name || '').trim().toLowerCase() === want) return slots[i].n;
      }
    }
    for (i = 0; i < slots.length; i++) {
      if (taken[slots[i].n]) continue;
      if (rxLocked(slots[i].n)) continue;
      if (!String(slots[i].name || '').trim()) return slots[i].n;
    }
    return null;
  }

  /* Stake every unclaimed dog's slot AT BOOT, by name, before the customer can
     touch anything. Claiming only at save time is too late: a rename typed
     BEFORE the first save leaves the dog matching nothing, so it takes a fresh
     slot and the account ends up with two records for one animal. That is
     exactly the sequence that produced the duplicate. */
  function claimAll() {
    if (!R) return;
    var slots = BOOT.slots || [];
    var moved = false;
    R.list.forEach(function (d) {
      if (d.slot || d.status === 'memorial') return;
      var want = String(d.name || '').trim().toLowerCase();
      if (!want) return;
      var taken = claimedSlots(d.id);
      for (var i = 0; i < slots.length; i++) {
        if (taken[slots[i].n]) continue;
        if (String(slots[i].name || '').trim().toLowerCase() === want) {
          d.slot = slots[i].n;
          moved = true;
          return;
        }
      }
    });
    if (moved) saveRoster();
  }

  /* Recording the claim is what makes it durable. Done BEFORE the write, so a
     failed request cannot leave the dog unclaimed and free to grab another slot
     on the next attempt. */
  function claimSlot(dog, slot) {
    if (!dog || !slot || dog.slot === slot) return;
    dog.slot = slot;
    saveRoster();
  }

  function activityWord(f) {
    var CFG = window.wynFeed && window.wynFeed.CFG;
    if (!CFG || !CFG.ACTIVITY || f == null) return null;
    var k;
    for (k in CFG.ACTIVITY) {
      if (CFG.ACTIVITY[k] === f) return k.charAt(0).toUpperCase() + k.slice(1);
    }
    return null;
  }

  /* Builds the write list for one dog. Fields we cannot express LOSSLESSLY are
     left out rather than guessed: age is stored here as a FACTOR and the
     metafield wants MONTHS, and 1 covers everything from 12 to 84 months, so
     writing a representative number would invent precision the customer never
     gave. */
  /* AGE IS NOW WRITTEN (2026-10-22). The form holds a band, the field wants
     months. Nothing is written while the months already on file sit inside
     the chosen band, so a real birthday-derived figure is never overwritten;
     only a CHANGED band writes, using a representative month for it. Without
     this an age set on one device never reached any other. */
  var AGE_REP = { '2': 2, '1.5': 5, '1.25': 9, '1': 48, '0.9': 108 };
  function ageWrite(dog, fresh) {
    if (!dog || dog.age == null) return null;
    /* a dog with a birthday never touches the old months field: it stays as the
       record of what this dog was before the switch (2026-11-01) */
    if (dog.bday) return null;
    if (!fresh && dog.ageMonths != null && ageFromMonths(dog.ageMonths) === dog.age) return null;
    if (fresh && dog.ageMonths != null && ageFromMonths(dog.ageMonths) === dog.age) return dog.ageMonths;
    var rep = AGE_REP[String(dog.age)];
    return rep == null ? null : rep;
  }

  /* `fresh` = the slot held no dog when this page loaded (or held one that was
     removed). Leftovers from that earlier occupant are cleared with the quiz
     app's own empty marker, "None", which every reader already washes out -
     otherwise a new dog would inherit the old one's sticker or hearts. */
  function ravenFieldsFor(dog, slot, fresh) {
    var out = [];
    if (!dog || !slot) return out;
    var p = 'dog_' + slot + '_';
    var rec = slotRec(slot) || {};
    if (dog.name) out.push([p + 'name', dog.name]);
    if (dog.weight_lb != null) out.push([p + 'weight', dog.weight_lb]);
    var aw = activityWord(dog.activity);
    if (aw) out.push([p + 'activity_level', aw]);
    else if (fresh && String(rec.act || '').trim()) out.push([p + 'activity_level', 'None']);
    if (dog.neuter) out.push([p + 'neutered', dog.neuter === 'neutered' ? 'Yes' : 'No']);
    else if (fresh && String(rec.neu || '').trim()) out.push([p + 'neutered', 'None']);
    var am = ageWrite(dog, fresh);
    if (am != null) out.push([p + 'age_in_months', am]);
    else if (fresh && dog.bday && num(rec.am) > 0) out.push([p + 'age_in_months', 'None']);
    /* BIRTHDAY: only when this page can sign it, so a missing raven never
       blocks the rest of the save (every field must land for a save to count) */
    var bdRec = bdClean(rec.bd);
    if (ravenDef(p + 'birthday')) {
      if (dog.bday) { if (dog.bday !== bdRec) out.push([p + 'birthday', dog.bday]); }
      else if (fresh && String(rec.bd || '').trim()) out.push([p + 'birthday', 'None']);
    }
    /* Colour, icon and (since 2026-10-22) the memorial mark travel as one
       string, so the account needs ONE extra field per dog. */
    if (dog.colour || dog.icon || dog.status === 'memorial') out.push([p + 'look', lookWrite(dog)]);
    else if (String(rec.look || '').trim()) out.push([p + 'look', 'None']);
    var tw = tasteWrite(likes(dog));
    if (tw) { if (tw !== String(rec.taste || '').trim()) out.push([p + 'taste', tw]); }
    else if (String(rec.taste || '').trim()) out.push([p + 'taste', 'None']);
    /* an earlier dog's answers still in this empty slot */
    if (fresh && SAFE[slot]) {
      SAFE[slot].left.forEach(function (f) { if (ravenDef(p + f)) out.push([p + f, 'None']); });
    }
    return out;
  }

  var saving = {};
  function ravenSaveDog(dog) {
    if (!dog || !String(dog.name || '').trim()) return Promise.resolve({ ok: false, error: 'name the dog first' });
    var slot = slotFor(dog);
    if (!slot) return Promise.resolve({ ok: false, error: 'no free account slot' });
    var rec = slotRec(slot);
    var fresh = !rec || !String(rec.name || '').trim() ||
      (R.gone || []).some(function (g) { return g.slot === slot; });
    claimSlot(dog, slot);
    var fields = ravenFieldsFor(dog, slot, fresh);
    if (!fields.length) return Promise.resolve({ ok: false, error: 'nothing to write' });
    /* recorded BEFORE the request: if the tab closes or the write fails, the
       next visit on any page load sees 'pending' and sends it again */
    dog.sync = 'pending';
    saveRoster();
    var token = (saving[dog.id] || 0) + 1;
    saving[dog.id] = token;
    return Promise.all(fields.map(function (f) { return ravenPut(f[0], f[1]); }))
      .then(function (rs) {
        var ok = rs.every(function (r) { return r.ok; });
        /* a newer save started meanwhile owns the flag */
        if (ok && saving[dog.id] === token) {
          dog.sync = '';
          var am = ageWrite(dog, fresh);
          if (am != null) dog.ageMonths = am;
          /* this page now knows what the account holds */
          if (rec) {
            rec.name = dog.name; rec.w = dog.weight_lb == null ? rec.w : String(dog.weight_lb);
            rec.look = (dog.colour || dog.icon || dog.status === 'memorial') ? lookWrite(dog) : '';
            rec.taste = tasteWrite(likes(dog));
            if (dog.ageMonths != null && !dog.bday) rec.am = String(dog.ageMonths);
            if (dog.bday && ravenDef('dog_' + slot + '_birthday')) rec.bd = dog.bday;
          }
          R.gone = (R.gone || []).filter(function (g) { return g.slot !== slot; });
          if (fresh && SAFE[slot]) SAFE[slot].left = [];
          saveRoster();
        }
        return { ok: ok, slot: slot, results: rs };
      });
  }

  /* REMOVE writes too (2026-10-22). It used to change only this browser, so
     the dog came straight back on the next visit - the account still had it
     and the merge put it back. Clearing the NAME is enough: a slot with no
     name is an empty slot to every reader (the "None" wash). */
  function ravenRemove(g) {
    if (!BOOT.ravenOn || !window.FieldsRaven || !g || !g.slot) return Promise.resolve({ ok: false });
    var rec0 = slotRec(g.slot);
    if (rec0 && bdClean(rec0.bd) && ravenDef('dog_' + g.slot + '_birthday')) {
      ravenPut('dog_' + g.slot + '_birthday', 'None').then(function (rb) { if (rb.ok && rec0) rec0.bd = ''; });
    }
    return ravenPut('dog_' + g.slot + '_name', 'None').then(function (r) {
      if (r.ok) {
        var rec = slotRec(g.slot);
        if (rec) { rec.name = ''; }
      }
      return r;
    });
  }

  /* Anything still waiting from an earlier visit goes now. */
  function flushPending() {
    if (!BOOT.ravenOn || !window.FieldsRaven || !R) return;
    (R.gone || []).forEach(function (g) { ravenRemove(g); });
    R.list.forEach(function (d) {
      if (d.sync !== 'pending') return;
      if (!String(d.name || '').trim()) return;
      /* a memorial the account never held has nothing to record */
      if (d.status === 'memorial' && !d.slot) { d.sync = ''; return; }
      ravenSaveDog(d).then(function (r) { lastRaven = r; });
    });
  }

  /* ---- THE CLINIC CHANGE REQUEST ----
     Deliberately NOT an edit. A customer must never be able to invalidate their
     own Fresh Rx authorization: they cannot restore it, and a stray tap would
     put their next order on hold. This writes the new clinic's details to the
     unlisted-vet fields, which is exactly what those fields mean - a clinic we
     do not yet have on file - and tells the customer plainly that nothing has
     changed until the team confirms. rxdate is untouched, and there is no rid
     for it, so it cannot be touched from here. */
  /* 2026-10-22: the roster dog a Vet-tab row belongs to - claimed slot first,
     then name, the same order authRowFor() uses. */
  function dogForRow(li) {
    if (!li || !R) return null;
    var n = Number(li.getAttribute('data-wup-dogrx'));
    var nm = String(li.getAttribute('data-wup-dogrx-name') || '').trim().toLowerCase();
    var i, d;
    for (i = 0; i < R.list.length; i++) { d = R.list[i]; if (n && Number(d.slot) === n) return d; }
    for (i = 0; i < R.list.length; i++) {
      d = R.list[i];
      if (nm && String(d.name || '').trim().toLowerCase() === nm) return d;
    }
    return null;
  }

  /* A dog marked as passed lives on in the roster as a memorial, and that status
     is only known here, not to the Liquid. Its row must never offer Fresh Rx. */
  function paintDogRows() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-wup-dogrx]'), function (li) {
      var d = dogForRow(li);
      li.hidden = !!(d && d.status === 'memorial');
    });
  }
  root.addEventListener('wup:roster', paintDogRows);

  /* ---- THE VET'S NAME ----
     custom.veterinarian, the individual vet. Editable because it carries no
     authority: the clinic and the authorization date are never touched. The
     cart prefills its "Your vet" field from this same metafield. */
  function wireVetName() {
    var row = root.querySelector('[data-wup-vn]');
    var box = root.querySelector('[data-wup-vn-box]');
    if (!row || !box) return;
    var openB = row.querySelector('[data-wup-vn-open]');
    var val = row.querySelector('[data-wup-vn-val]');
    var inp = box.querySelector('[data-wup-vn-in]');
    var save = box.querySelector('[data-wup-vn-save]');
    var cancel = box.querySelector('[data-wup-vn-cancel]');
    var msg = box.querySelector('[data-wup-vn-msg]');
    var C2 = BOOT.vc || {};
    if (!ravenDef('customer_veterinarian')) { if (openB) openB.hidden = true; return; }
    function sync() { if (save && inp) save.disabled = !String(inp.value || '').trim(); }
    if (openB) openB.addEventListener('click', function () {
      box.hidden = false; openB.hidden = true;
      if (msg) msg.textContent = '';
      sync();
      if (inp) { inp.focus(); try { inp.select(); } catch (e) {} }
    });
    if (inp) inp.addEventListener('input', sync);
    if (cancel) cancel.addEventListener('click', function () {
      box.hidden = true; if (openB) openB.hidden = false;
      if (msg) msg.textContent = '';
    });
    if (save) save.addEventListener('click', function () {
      var v = inp ? String(inp.value || '').trim() : '';
      if (!v) return;
      save.disabled = true;
      ravenPut('customer_veterinarian', v).then(function (r) {
        lastVetName = r;
        if (r && r.ok) {
          if (val) { val.textContent = v; val.classList.remove('is-empty'); }
          box.hidden = true; if (openB) openB.hidden = false;
          if (msg) msg.textContent = '';
          syncCartVetName(v);
        } else {
          if (msg) msg.textContent = C2.vnFail || '';
        }
        save.disabled = false;
      });
    });
  }
  var lastVetName = null;

  /* 2026-10-22: KEEP THE CART IN STEP. The cart carries the vet's name as the
     "Veterinarian Name" attribute, and after checkout a Flow copies that onto
     the record. A name left in the cart from before this edit would ride to
     the next order and quietly put the old name back. So the cart drawer's
     field (if it is on the page) and the cart attribute both take the new
     name. The input event lets the drawer's own sync and the vet-name bridge
     pick it up as the latest value. */
  function syncCartVetName(v) {
    try {
      Array.prototype.forEach.call(document.querySelectorAll('[data-wvp-vetname]'), function (inp) {
        if (inp.value === v) return;
        inp.value = v;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } catch (e) {}
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Veterinarian Name': v } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---- CLINIC SEARCH (inside the change card) ---- */
  function clinicNorm(s) { return String(s || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  /* The clinic list stores phones five ways ((305) 555-0100, 13055550100,
     +1 305-555-0100 ...) and at least one record holds a website. Ten US
     digits (eleven with a leading 1) print as (305) 555-0100; anything with
     letters is dropped; anything else prints as stored. */
  function clinicPhone(p) {
    var s = String(p || '').trim();
    if (!s || /[a-z]/i.test(s)) return '';
    var d = s.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length === 10) return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
    return s;
  }
  function clinicMeta(c) {
    var ct = c.city ? (c.city + (c.state ? ', ' + c.state : '')) : '';
    var ph = clinicPhone(c.phone);
    return ct + (ct && ph ? ' \u00b7 ' : '') + ph;
  }
  function clinicFind(name) {
    var l = (window.wynVet && window.wynVet.list) || [], k = clinicNorm(name);
    for (var i = 0; i < l.length; i++) if (clinicNorm(l[i].name) === k) return l[i];
    return null;
  }
  /* The city and phone line: Liquid can only read the first 250 clinics, so
     a clinic past that is filled in here from the full list. */
  function fillClinicMeta() {
    var m = root.querySelector('[data-wup-cl-meta]');
    var n = root.querySelector('[data-wup-cl-name]');
    if (!m || !n || !BOOT.hasVet) return;
    /* only for a clinic on file from the list, never an unlisted one */
    var k = root.querySelector('[data-wup-cl-key]');
    if (k && (BOOT.vc || {}).vetOn && String(k.textContent).trim() !== BOOT.vc.vetOn) return;
    var c = clinicFind(n.textContent);
    if (!c) return;
    var s = clinicMeta(c);
    if (s) { m.textContent = s; m.hidden = false; }
  }
  var lastPick = null;

  function wirePick(pickW, closeBox, goUnl) {
    var q = pickW.querySelector('[data-wup-cpick-q]');
    var list = pickW.querySelector('[data-wup-cpick-list]');
    var none = pickW.querySelector('[data-wup-cpick-none]');
    var save = pickW.querySelector('[data-wup-cpick-save]');
    var cancel = pickW.querySelector('[data-wup-cpick-cancel]');
    var unl = pickW.querySelector('[data-wup-cpick-unl]');
    var msg = pickW.querySelector('[data-wup-cpick-msg]');
    var C2 = BOOT.vc || {};
    var chosen = null, shown = [];
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function paint() {
      var term = clinicNorm(q && q.value);
      var all = (window.wynVet && window.wynVet.list) || [];
      shown = [];
      if (term) {
        /* Rank EVERY match before cutting to eight, so a clinic named what
           they typed is never pushed out by city matches: name starts with
           it, then a word in the name starts with it, then the name contains
           it, then the city. Within each, Florida first, then A to Z - the
           cart's rule. Sorting, never filtering. */
        var hits = [];
        for (var i = 0; i < all.length; i++) {
          var c = all[i], nm = clinicNorm(c.name), r = -1;
          if (nm.indexOf(term) === 0) r = 0;
          else if (nm.indexOf(' ' + term) > -1) r = 1;
          else if (nm.indexOf(term) > -1) r = 2;
          else if (clinicNorm(c.city).indexOf(term) > -1) r = 3;
          if (r > -1) hits.push({ c: c, r: r });
        }
        hits.sort(function (a, b) {
          var fa = a.c.state === 'FL' ? 0 : 1, fb = b.c.state === 'FL' ? 0 : 1;
          return a.r - b.r || fa - fb || String(a.c.name).localeCompare(String(b.c.name));
        });
        shown = hits.slice(0, 8).map(function (h) { return h.c; });
      }
      var html = '';
      shown.forEach(function (c, i) {
        var sel = chosen && chosen.name === c.name;
        html += '<li><button class="wup-pick__o" type="button" role="option" aria-selected="' + (sel ? 'true' : 'false') +
                '" data-wup-cpick-i="' + i + '"><b>' + esc(c.name) + '</b>' +
                (clinicMeta(c) ? '<span>' + esc(clinicMeta(c)) + '</span>' : '') + '</button></li>';
      });
      if (list) list.innerHTML = html;
      if (none) none.hidden = !(term && !shown.length);
      if (save) save.disabled = !chosen;
    }
    if (q) q.addEventListener('input', function () { chosen = null; if (msg) msg.textContent = ''; paint(); });
    if (list) list.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-wup-cpick-i]');
      if (!b) return;
      chosen = shown[Number(b.getAttribute('data-wup-cpick-i'))] || null;
      paint();
    });
    function reset() { chosen = null; if (q) q.value = ''; if (msg) msg.textContent = ''; paint(); }
    if (cancel) cancel.addEventListener('click', function () { reset(); closeBox(); });
    if (unl) unl.addEventListener('click', function () { reset(); goUnl(); });
    if (save) save.addEventListener('click', function () {
      if (!chosen) return;
      var c = chosen;
      var nameEl2 = root.querySelector('[data-wup-cl-name]');
      var current = nameEl2 ? clinicNorm(nameEl2.textContent) : '';
      if (BOOT.hasVet && clinicNorm(c.name) === current) { reset(); closeBox(); return; }
      /* The clinic the customer picked is the record now. If any dog holds an
         authorization date, that date came from the old clinic, so the team
         gets the heads-up through the rx_request email (his option A). */
      var authd = (BOOT.auth || []).some(function (r) { return !!r.rx; });
      var jobs = [ravenPut('customer_veterinarian_rec', c.name)];
      if (authd && ravenDef('customer_rx_request')) {
        jobs.push(ravenPut('customer_rx_request',
          'Clinic change | ' + c.name + ' (from the clinic list) | ' + new Date().toISOString().slice(0, 10)));
      }
      save.disabled = true;
      Promise.all(jobs).then(function (rs) {
        var ok2 = rs.every(function (r) { return r.ok; });
        lastPick = { clinic: c.name, authd: authd, results: rs };
        if (!ok2) { if (msg) msg.textContent = C2.vnFail || ''; save.disabled = false; return; }
        if (nameEl2) nameEl2.textContent = c.name;
        var key = root.querySelector('[data-wup-cl-key]');
        if (key) key.textContent = C2.vetOn || '';
        var m = root.querySelector('[data-wup-cl-meta]');
        if (m) { var s = clinicMeta(c); m.textContent = s; m.hidden = !s; }
        BOOT.hasVet = true;
        try { if (window.wynwood && window.wynwood.customer) window.wynwood.customer.veterinarian_rec = c.name; } catch (e) {}
        reset(); closeBox();
        var clMsg = root.querySelector('[data-wup-cl-msg]');
        if (clMsg) clMsg.textContent = C2.pickOk || '';
      });
    });
  }

  function wireChange() {
    var open = root.querySelector('[data-wup-chg-open]');
    var box = root.querySelector('[data-wup-chg]');
    if (!open || !box) return;
    var nameEl = box.querySelector('[data-wup-chg-name]');
    var phoneEl = box.querySelector('[data-wup-chg-phone]');
    var msg = box.querySelector('[data-wup-chg-msg]');
    var C2 = BOOT.vc || {};

    /* 2026-10-22, his option A: SEARCH FIRST. The full clinic list the cart
       uses (window.wynVet, all ~500 clinics) is searched here; picking one and
       pressing Save writes the clinic straight to the record. The typed-in
       form below is now the "My clinic isn't listed" path only. With no list
       (blank token, fetch failed) the typed form opens directly, as before. */
    var pickW = box.querySelector('[data-wup-cpick]');
    var unlW = box.querySelector('[data-wup-unl]');
    function hasList() { return !!(window.wynVet && window.wynVet.list && window.wynVet.list.length); }
    function showStep(step) {
      if (pickW) pickW.hidden = step !== 'pick';
      if (unlW) unlW.hidden = step !== 'unl';
    }
    function closeBox() {
      box.hidden = true; open.hidden = false;
      if (msg) msg.textContent = '';
      showStep(hasList() ? 'pick' : 'unl');
    }
    open.addEventListener('click', function () {
      box.hidden = false;
      open.hidden = true;
      var clMsg = root.querySelector('[data-wup-cl-msg]');
      if (clMsg) clMsg.textContent = '';
      if (pickW && hasList()) {
        showStep('pick');
        var q0 = pickW.querySelector('[data-wup-cpick-q]');
        if (q0) q0.focus();
      } else {
        showStep('unl');
        if (nameEl) nameEl.focus();
      }
    });
    var cancel = box.querySelector('[data-wup-chg-cancel]');
    if (cancel) cancel.addEventListener('click', closeBox);
    if (pickW) wirePick(pickW, closeBox, function () {
      showStep('unl'); if (nameEl) nameEl.focus();
    });

    var send = box.querySelector('[data-wup-chg-send]');
    if (send) send.addEventListener('click', function () {
      var nm = nameEl ? String(nameEl.value || '').trim() : '';
      var ph = phoneEl ? String(phoneEl.value || '').trim() : '';
      if (!nm) { if (msg) msg.textContent = C2.chgNeed || ''; if (nameEl) nameEl.focus(); return; }
      send.disabled = true;
      if (msg) msg.textContent = '';
      /* 2026-10-22: the change also rings the team's existing doorbell. The two
         unlisted-vet fields alone alerted nobody, and the cart now sends
         authorized customers here to change clinic. custom.rx_request already
         has a segment and an email; the value reads
         "Clinic change | <clinic> <phone> | <date>" so it is clear in that email. */
      var jobsC = [
        ravenPut('unlisted_vet_hospital_name', nm),
        ph ? ravenPut('unlisted_vet_contact_details', ph) : Promise.resolve({ ok: true })
      ];
      if (ravenDef('customer_rx_request')) {
        jobsC.push(ravenPut('customer_rx_request',
          'Clinic change | ' + nm + (ph ? ' ' + ph : '') + ' | ' + new Date().toISOString().slice(0, 10)));
      }
      Promise.all(jobsC).then(function (rs) {
        var ok2 = rs.every(function (r) { return r.ok; });
        lastChange = rs;
        if (msg) msg.textContent = ok2 ? (C2.chgOk || '') : (C2.chgFail || '');
        if (ok2) {
          box.classList.add('is-done');
          Array.prototype.forEach.call(box.querySelectorAll('input,button'), function (x) {
            if (!x.hasAttribute('data-wup-chg-cancel')) x.disabled = true;
          });
        } else { send.disabled = false; }
      });
    });
  }
  var lastChange = null, lastRequest = null;

  /* ---- THE Fresh Rx REQUEST ----
     "Please contact my clinic about this dog and this diet." It writes the one
     durable fact it is entitled to write - dog_N_prescription_diet - and, if we
     have no clinic on file, the clinic's details. It CANNOT grant anything:
     rxdate has no rid and never will.

     A request must attach to an ACCOUNT SLOT, because that is what the team
     reads. A dog that exists only in this browser has no slot yet, so the form
     says so rather than writing into someone else's record. */
  function wireRequest() {
    var open = root.querySelector('[data-wup-req-open]');
    var box = root.querySelector('[data-wup-req]');
    if (!open || !box) return;
    var dogsBox = box.querySelector('[data-wup-req-dogs]');
    var msg = box.querySelector('[data-wup-req-msg]');
    var vetRow = box.querySelector('[data-wup-req-vetrow]');
    var C2 = BOOT.vc || {};
    var pickedDog = '', pickedDiet = null;

    function paintDogs() {
      if (!dogsBox || !R) return;
      var html = '';
      living().forEach(function (d) {
        html += '<button class="wup-chip" type="button" data-wup-req-dog="' + d.id + '"' +
                ' aria-pressed="' + (d.id === pickedDog ? 'true' : 'false') + '">' +
                (d.name ? d.name.replace(/[<>&]/g, '') : (C.unnamed || 'Your dog')) + '</button>';
      });
      dogsBox.innerHTML = html;
    }
    function paintDiets() {
      Array.prototype.forEach.call(box.querySelectorAll('[data-wup-req-diet]'), function (b) {
        b.setAttribute('aria-pressed', b.dataset.wupReqDiet === pickedDiet ? 'true' : 'false');
      });
    }

    /* the chips used to be drawn once, when the panel opened, so a dog added,
       renamed or removed on the dog tab stayed wrong here until a reload */
    root.addEventListener('wup:roster', function () {
      paintFirst();
      if (box.hidden) return;
      var still = pickedDog && byId(R, pickedDog);
      if (!still || still.status === 'memorial') pickedDog = active() ? active().id : '';
      paintDogs();
    });

    open.addEventListener('click', function () {
      pickedDog = active() ? active().id : '';
      paintDogs(); paintDiets();
      if (vetRow) vetRow.hidden = !!BOOT.hasVet;
      box.hidden = false; open.hidden = true;
    });

    /* 2026-10-22: PER-DOG ROWS. With the Vet tab's dog rows showing, the card
       carries data-wup-req-rows, its intro is hidden, and each dog's own
       "Set up Fresh Rx" button opens this form with that dog already picked.
       The account slot is the match (data-wup-req-for = N), then the name. */
    var reqCard = box.closest('.wup-req');
    var rowsMode = !!(reqCard && reqCard.hasAttribute('data-wup-req-rows'));
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-wup-req-for]');
      if (!b || !R) return;
      var dog = dogForRow(b.closest('[data-wup-dogrx]'));
      pickedDog = dog ? dog.id : (active() ? active().id : '');
      paintDogs(); paintDiets();
      if (vetRow) vetRow.hidden = !!BOOT.hasVet;
      if (reqCard) reqCard.classList.add('is-open');
      box.hidden = false; open.hidden = true;
      try { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    });

    var cancel = box.querySelector('[data-wup-req-cancel]');
    if (cancel) cancel.addEventListener('click', function () {
      box.hidden = true;
      if (rowsMode) { if (reqCard) reqCard.classList.remove('is-open'); }
      else open.hidden = false;
      if (msg) msg.textContent = '';
    });

    box.addEventListener('click', function (ev) {
      var t = ev.target;
      var dg = t.closest && t.closest('[data-wup-req-dog]');
      if (dg) { pickedDog = dg.dataset.wupReqDog; paintDogs(); return; }
      var dt = t.closest && t.closest('[data-wup-req-diet]');
      if (dt) { pickedDiet = dt.dataset.wupReqDiet; paintDiets(); return; }
    });

    var send = box.querySelector('[data-wup-req-send]');
    if (send) send.addEventListener('click', function () {
      if (msg) msg.textContent = '';
      var dog = pickedDog ? byId(R, pickedDog) : null;
      if (!dog) { if (msg) msg.textContent = C2.reqNeedDog || ''; return; }
      if (pickedDiet === null) { if (msg) msg.textContent = C2.reqNeedDiet || ''; return; }
      var slot = dog.slot || slotFor(dog);
      if (!slot) {
        if (msg) msg.textContent = ((BOOT.slots || []).length ? C2.reqFull : C2.reqNeedSlot) || '';
        return;
      }
      claimSlot(dog, slot);

      /* TWO WRITES, TWO JOBS.
         dog_N_prescription_diet is the DURABLE PER-DOG FACT and is what the vet
         panel reads to show "pending".
         rx_request is the NOTIFICATION HOOK. Shopify Flow has no
         customer-metafield-updated trigger, but it does have "Customer joined
         segment", and a segment on one customer-level field is trivial where a
         segment across ten dog slots is not. The team clears this field when
         they have actioned it, which also removes them from the segment.
         If the rid does not exist yet, ravenPut reports and the request still
         succeeds on the per-dog write. */
      var stamp = new Date().toISOString().slice(0, 10);
      var note = (dog.name || 'Dog ' + slot) + ' | ' +
                 (pickedDiet || 'Not sure yet') + ' | ' + stamp;
      var jobs = [ravenPut('dog_' + slot + '_prescription_diet', pickedDiet || 'Not sure yet')];
      if (ravenDef('customer_rx_request')) jobs.push(ravenPut('customer_rx_request', note));
      var vn = box.querySelector('[data-wup-req-vetname]');
      var vp = box.querySelector('[data-wup-req-vetphone]');
      if (vetRow && !vetRow.hidden) {
        if (vn && String(vn.value || '').trim()) jobs.push(ravenPut('unlisted_vet_hospital_name', String(vn.value).trim()));
        if (vp && String(vp.value || '').trim()) jobs.push(ravenPut('unlisted_vet_contact_details', String(vp.value).trim()));
      }
      send.disabled = true;
      Promise.all(jobs).then(function (rs) {
        var ok2 = rs.every(function (r) { return r.ok; });
        lastRequest = { slot: slot, dog: dog.name, diet: pickedDiet, results: rs };
        if (msg) msg.textContent = ok2 ? (C2.reqOk || '') : (C2.reqFail || '');
        if (ok2) {
          box.classList.add('is-done');
          Array.prototype.forEach.call(box.querySelectorAll('input,button'), function (x) {
            if (!x.hasAttribute('data-wup-req-cancel')) x.disabled = true;
          });
        } else { send.disabled = false; }
      });
    });
  }

  /* ---- WON'T EAT ----
     The one fact about a diet that ONLY the customer knows and that no amount of
     order data can infer. Stored per dog as product SLUGS, so a product rename
     cannot orphan the record, in `no:a,b` form with room for `yes:` later.
     It is written IMMEDIATELY rather than staged, because it sits outside the
     dog form and a toggle that needs a distant Save button will not get used. */
  function tasteParse(raw) {
    var out = [];
    String(raw || '').split(';').forEach(function (part) {
      var bits = part.split(':');
      if (bits.length < 2 || bits[0].trim().toLowerCase() !== 'yes') return;
      bits[1].split(',').forEach(function (h) {
        h = h.trim().toLowerCase();
        if (h && out.indexOf(h) === -1) out.push(h);
      });
    });
    return out;
  }
  function tasteWrite(list) { return list.length ? ('yes:' + list.join(',')) : ''; }

  function likes(d) { return (d && d.likes) || []; }
  function loves(d, handle) {
    return likes(d).indexOf(String(handle || '').toLowerCase()) > -1;
  }

  function toggleLove(handle) {
    var d = active();
    if (!d || !handle) return;
    handle = String(handle).toLowerCase();
    var list = likes(d).slice();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    d.likes = list;
    saveRoster();
    paintTaste();
    if (BOOT.ravenOn && d.slot) {
      ravenPut('dog_' + d.slot + '_taste', tasteWrite(list) || 'None').then(function (r) {
        var rec = slotRec(d.slot);
        if (r.ok) { if (rec) rec.taste = tasteWrite(list); }
        else { d.sync = 'pending'; saveRoster(); }
      });
    }
  }

  function paintTaste() {
    var d = active();
    var C2 = C || {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-wup-love]'), function (b) {
      var on = loves(d, b.dataset.wupLove);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      
      b.closest('.wup-hist__i') && b.closest('.wup-hist__i').classList.toggle('is-no', on);
    });
    /* a diet they refuse should stop being offered as a one-tap add */
    Array.prototype.forEach.call(root.querySelectorAll('[data-wup-add]'), function (b) {
      var on = loves(d, b.dataset.handle);
      b.classList.toggle('is-loved', on);
      if (on) b.title = (d && d.name ? d.name + ' ' : '') + (C2.love || '');
      else b.removeAttribute('title');
    });
    /* and the profile card names it, so it is visible without hunting */
    var row = root.querySelector('[data-wup-lovefact]');
    var out = root.querySelector('[data-wup-lovelist]');
    if (row && out) {
      var names = likes(d).map(function (h) {
        var b = root.querySelector('[data-wup-love="' + h + '"]');
        var n = b && b.closest('.wup-hist__i');
        n = n && n.querySelector('.wup-hist__n');
        if (n) return n.textContent.trim();
        /* a love older than 60 days has no history row any more; the add
           pill still knows the real title, and a prettified slug is the
           last resort rather than raw "beef-potato" on the profile card */
        var a = root.querySelector('[data-wup-add][data-handle="' + h + '"]');
        if (a && a.dataset.title) return a.dataset.title;
        return h.replace(/-/g, ' ').replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
      });
      row.hidden = !names.length;
      out.textContent = names.join(', ');
    }
  }

  /* ---- THE PACKET SIZE TOGGLE ----
     ONE control for the whole add card rather than a size picker on every pill,
     which is what would actually clutter it. It defaults to the size they last
     bought, so the common case needs no interaction at all, and a product that
     only comes in one size quietly ignores it. */
  var pickedSize = '';

  function sizeOf(v) { return String(v && v.title || v || '').trim().toLowerCase(); }

  /* the size most present in the last order, so the default is THEIR default */
  function defaultSize() {
    var counts = {}, best = '', n = 0;
    Array.prototype.forEach.call(root.querySelectorAll('[data-wup-line]'), function (li) {
      var t = String(li.dataset.vtitle || '').trim();
      if (!t) return;
      counts[t] = (counts[t] || 0) + 1;
      if (counts[t] > n) { n = counts[t]; best = t; }
    });
    return best;
  }

  function variantFor(btn) {
    var raw = btn.dataset.vars;
    if (!raw) return { id: btn.dataset.vid, price: btn.dataset.price };
    var list;
    try { list = JSON.parse(raw); } catch (e) { list = null; }
    if (!list || !list.length) return { id: btn.dataset.vid, price: btn.dataset.price };
    if (pickedSize) {
      /* CONTAINS, NOT EQUALS. The variant title on this store is "Small - 16 oz"
         and the token is "16 oz"; an exact comparison never matched, so every
         add fell back to the first variant and the large size was unreachable. */
      var tok = sizeOf(pickedSize);
      for (var i = 0; i < list.length; i++) {
        if (tok && sizeOf(list[i].t).indexOf(tok) > -1) return { id: list[i].id, price: list[i].p, t: list[i].t, multi: list.length > 1 };
      }
    }
    /* no match is the ordinary case for a one-size product, not a failure */
    return { id: list[0].id, price: list[0].p, t: list[0].t, multi: list.length > 1 };
  }

  function paintSizes() {
    var box = root.querySelector('[data-wup-sizes]');
    if (!box) return;
    var any = false;
    Array.prototype.forEach.call(box.querySelectorAll('[data-wup-size]'), function (b) {
      var on = sizeOf(b.dataset.wupSize) === sizeOf(pickedSize);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) any = true;
    });
    /* only offer the toggle if some product actually has more than one size */
    var multi = false;
    Array.prototype.forEach.call(root.querySelectorAll('[data-wup-add]'), function (b) {
      if (multi || !b.dataset.vars) return;
      try { if (JSON.parse(b.dataset.vars).length > 1) multi = true; } catch (e) {}
    });
    box.hidden = !multi;
    if (!any && multi) {
      var first = box.querySelector('[data-wup-size]');
      if (first) { pickedSize = first.dataset.wupSize; paintSizes(); }
    }
  }

  /* A tall fold closed from far down the page used to leave its own header
     above the top of the screen, so the row seemed to vanish. On close, if
     the header is off the top (or under the sticky site header), bring it
     back into view. */
  function wireFolds() {
    if (!dogBox) return;
    Array.prototype.forEach.call(dogBox.querySelectorAll('details.wup-fold'), function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) return;
        var sm = d.querySelector('summary');
        if (!sm || typeof sm.getBoundingClientRect !== 'function') return;
        var top = sm.getBoundingClientRect().top;
        var hd = document.querySelector('.wofn, header');
        var off = 0;
        try { off = hd && getComputedStyle(hd).position.match(/sticky|fixed/) ? hd.getBoundingClientRect().height : 0; } catch (e) {}
        if (top < off + 8) {
          try { window.scrollBy({ top: top - off - 24, behavior: 'auto' }); } catch (e) { window.scrollBy(0, top - off - 24); }
        }
      });
    });
  }

  /* ============================================================ BOOT */
  loadDiets().then(function () {
    if (form) { render(); }
    paint();
  });

  /* ---- WHOSE DOGS THESE ARE (2026-10-25) ----
     This browser's saved dogs belong to whoever signed in here LAST. On a
     shared computer (a family laptop, a clinic, a store iPad) the next person
     to sign in inherited that list, and a dog with a change waiting was SENT
     INTO THEIR ACCOUNT: found live, a test owner's dog 1 became the previous
     person's dog. The list now carries the account it belongs to. Another
     account's list is never read, shown or sent; this account starts from
     what Shopify holds. A list saved before this rule carries no owner, so it
     is kept only when every dog it has placed in a slot is the dog that slot
     holds on THIS account. */
  var ME = String(BOOT.customerEmail || '').trim().toLowerCase();
  function rosterIsMine(r) {
    if (!ME || !r) return true;
    if (r.owner) return r.owner === ME;
    var slots = (BOOT.slots || []).filter(function (s) { return String(s.name || '').trim(); });
    var slotted = r.list.filter(function (d) { return d.slot; });
    for (var i = 0; i < slotted.length; i++) {
      var s0 = slotRec(slotted[i].slot);
      if (!s0 || nameKey(s0.name) !== nameKey(slotted[i].name)) return false;
    }
    if (!slotted.length && slots.length) {
      var names = slots.map(function (s) { return nameKey(s.name); });
      var known = r.list.some(function (d) { return names.indexOf(nameKey(d.name)) > -1; });
      if (!known) return false;
    }
    return true;
  }
  R = loadRoster();
  var newOwner = false;
  if (R && !rosterIsMine(R)) {
    R = null; newOwner = true;
    try { localStorage.removeItem('wup_vu_seen'); } catch (e) {}
  }
  if (!R) { R = seedRoster(newOwner); }
  if (ME) R.owner = ME;
  saveRoster();
  purgePics();
  /* claim first: adoptLook and adoptAccount both key off dog.slot, so claiming
     after them meant a fresh device never picked up its colour or sticker */
  claimAll();
  adoptAccount();
  pruneGhosts();
  var strayWasActive = pruneStrays();
  /* a new owner's dogs must not soak up the last person's weight or name from
     the shared bus; instead the bus is overwritten with THIS account's dog.
     The same when the dog the site was showing turned out to be a stray. */
  if (newOwner || strayWasActive) mirror(true);
  else { reconcile(); mirror(); }
  loadForm();
  pickedSize = defaultSize();
  paintSizes();
  paint();
  /* what is already in the cart counts toward free shipping. A failure here is
     not worth surfacing - the bar simply reads the page's own lines, which is
     what it did before, and the customer sees a slightly conservative figure
     rather than a wrong one. */
  syncCart();
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) syncCart(); });
  wireChange();
  wireRequest();
  wireVetName();
  paintDogRows();
  if (window.wynVet && window.wynVet.ready && window.wynVet.ready.then) {
    window.wynVet.ready.then(fillClinicMeta, function () {});
  }
  document.documentElement.addEventListener('wyn:vetlist', fillClinicMeta);
  fillClinicMeta();
  flushPending();
  wireFolds();
  paintInk(root);

  /* 2026-10-28: AN OWNER A VET INVITED, WITH NO DOG ON FILE YET. The vet's
     email asks them to tell us about their dog, so the page opens on Your
     dog with the form already open, under the card wup-wvp.liquid prints
     (#wup-invite-boot). Once any dog is named or saved to the account the
     snippet stops printing the card and this never runs again. */
  try {
    var ib = document.getElementById('wup-invite-boot');
    var inv = ib ? JSON.parse(ib.textContent || '{}') : null;
    var anyDog = living().some(function (d) { return d.slot || String(d.name || '').trim(); });
    if (inv && inv.on && !anyDog && dogBox) {
      show('dog', false);
      try { history.replaceState(null, '', '#dog'); } catch (e) {}
      editing = true;
      render(true);
      var nf = el('[data-wup-f="name"]');
      if (nf) setTimeout(function () { try { nf.focus({ preventScroll: true }); } catch (e) { nf.focus(); } }, 0);
    }
  } catch (e) { /* the page works as before */ }

  setTimeout(function () {
    var probe = root.querySelector('.wup-h1') || root;
    if (getComputedStyle(probe).textTransform === 'uppercase') return;
    var b = document.createElement('div');
    b.setAttribute('style', 'margin:0 0 16px;padding:12px 14px;border:3px solid #2E2E2E;' +
      'border-radius:6px;background:#FFD820;color:#2E2E2E;font:700 14px/1.4 sans-serif');
    b.textContent = C.cssMissing || 'wup.css is not loading.';
    root.insertBefore(b, root.firstChild);
  }, 1200);

  /* ============================================================ SELF TEST
     Load /pages/userprofile?wuptest=1 on ANY theme to check the install from
     inside the real browser: assets present, modules loaded, roster invariants
     intact, the reorder maths, and that no flow-added item can be re-ordered.
     It NEVER writes: it snapshots localStorage first and restores it after. */
  function selfTest() {
    var T = [], snap = {};
    function t(name, fn) {
      var okv = false, note = '';
      try { var r = fn(); okv = r === true; if (r && r !== true) note = String(r); }
      catch (e) { note = e.message; }
      T.push({ name: name, ok: okv, note: note });
    }
    try { snap[LS_ROSTER] = lsGet(LS_ROSTER); } catch (e) {}

    t('wup.css loaded', function () {
      var p = root.querySelector('.wup-h1') || root;
      return getComputedStyle(p).textTransform === 'uppercase';
    });
    t('wup.js loaded', function () { return true; });
    t('wup-boot JSON parsed', function () { return !!(BOOT && BOOT.c && BOOT.c.reorderGo); });
    t('birthday snippet installed (wup-bday.liquid)', function () { return !!(BD && BDC.label) || 'no #wup-bday-boot on the page'; });
    t('birthday ravens signed for all five dogs', function () {
      for (var i = 1; i <= 5; i++) if (!ravenDef('dog_' + i + '_birthday')) return 'dog_' + i + '_birthday missing from raven-js-variables';
      return true;
    });
    t('birthday reads back: 2020-03 is about 6 years', function () {
      var p = bdParts('2020-03'); return (!!p && bdClean('2020-3') === '' && bdClean('~2020-03-04') === '') || 'parser';
    });
    t('wynprofile.js loaded', function () { return !!(window.wynProfile && window.wynProfile.set); });
    t('wynfeed.js loaded', function () { return !!(window.wynFeed && window.wynFeed.plan); });
    t('customer is signed in (Liquid saw them)', function () {
      return !!root.querySelector('[data-wup-panel]');
    });
    t('roster exists and is non-empty', function () { return !!(R && R.list.length); });
    t('there is always an active dog', function () { return !!active(); });
    t('active dog is never a memorial', function () { return active().status !== 'memorial'; });
    t('primary dog is never a memorial', function () {
      var p = byId(R, R.primaryId); return !!p && p.status !== 'memorial';
    });
    t('roster survives a save/load round trip', function () {
      var before = JSON.stringify(R.list.map(function (d) { return d.id + d.name + d.status; }));
      saveRoster();
      var back = loadRoster();
      return !!back && JSON.stringify(back.list.map(function (d) { return d.id + d.name + d.status; })) === before;
    });
    t('a corrupt roster is repaired, not fatal', function () {
      var keep = lsGet(LS_ROSTER);
      lsSet(LS_ROSTER, '{ this is not json');
      var r = loadRoster();
      if (keep === null) lsDel(LS_ROSTER); else lsSet(LS_ROSTER, keep);
      return r === null;
    });
    t('bus mirror matches the active dog', function () {
      if (!window.wynProfile) return 'no module';
      var d = active(), p = window.wynProfile.get();
      if (d.weight_lb === null) return true;
      return p.weight_lb === d.weight_lb;
    });
    t('activity factors match wynFeed.CFG.ACTIVITY', function () {
      if (!window.wynFeed || !window.wynFeed.CFG || !window.wynFeed.CFG.ACTIVITY) return 'no CFG';
      var have = [], k;
      for (k in window.wynFeed.CFG.ACTIVITY) have.push(window.wynFeed.CFG.ACTIVITY[k]);
      var bad = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-wup-opt="activity"]'), function (b) {
        var v = parseFloat(b.dataset.val);
        if (have.indexOf(v) === -1) bad.push(b.textContent.trim() + '=' + v);
      });
      return bad.length ? 'not in CFG: ' + bad.join(', ') : true;
    });
    t('age factors match wynFeed.CFG.AGE_BUCKETS', function () {
      if (!window.wynFeed || !window.wynFeed.CFG || !window.wynFeed.CFG.AGE_BUCKETS) return 'no CFG';
      var have = window.wynFeed.CFG.AGE_BUCKETS.map(function (x) { return x.factor; });
      var bad = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-wup-opt="age"]'), function (b) {
        var v = parseFloat(b.dataset.val);
        if (have.indexOf(v) === -1) bad.push(b.textContent.trim() + '=' + v);
      });
      return bad.length ? 'not in CFG: ' + bad.join(', ') : true;
    });
    t('neuter values match wynFeed.CFG.NEUTER', function () {
      if (!window.wynFeed || !window.wynFeed.CFG || !window.wynFeed.CFG.NEUTER) return 'no CFG';
      var bad = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-wup-opt="neuter"]'), function (b) {
        if (!(b.dataset.val in window.wynFeed.CFG.NEUTER)) bad.push(b.dataset.val);
      });
      return bad.length ? 'not in CFG: ' + bad.join(', ') : true;
    });
    t('no two dogs share an account slot', function () {
      if (!R) return 'no roster';
      var seen = {}, bad = [];
      R.list.forEach(function (d) {
        if (!d.slot) return;
        if (seen[d.slot]) bad.push('slot ' + d.slot + ': ' + seen[d.slot] + ' and ' + d.name);
        seen[d.slot] = d.name;
      });
      return bad.length ? bad.join('; ') : true;
    });
    t('diets file loaded', function () {
      if (dietsPending) return 'still loading';
      if (!DIETS) return (dietsWhy || 'not loaded') + '  tried: ' + dietsTried.join(' | ');
      return true;
    });
    t('the diet from the last order was matched', function () {
      if (!BOOT.dietHandle && !BOOT.dietTitle) return 'no order to take a diet from';
      return DIET ? true : (dietsWhy || 'no match');
    });
    t('a 40lb adult on daily walks is still 811 kcal (fresh factor 0.85 since 2026-10-11)', function () {
      if (!window.wynFeed || typeof window.wynFeed.maintenanceKcal !== 'function') return 'no library';
      var k = window.wynFeed.maintenanceKcal(libProfile(
        { weight_lb: 40, age: 1, activity: 1.55, neuter: 'neutered' }));
      return Math.round(k) === 811 ? true : 'got ' + Math.round(k) + ', expected 811';
    });
    t('wynFeed.plan(profile, diet) returns a figure for a known 40lb adult', function () {
      if (!window.wynFeed || typeof window.wynFeed.plan !== 'function') return 'wynFeed missing';
      if (!DIET) return 'no diet matched, so nothing to price the calories against';
      var p;
      try { p = window.wynFeed.plan(libProfile(
        { weight_lb: 40, age: 1, activity: 1.55, neuter: 'neutered' }), DIET, {}); }
      catch (e) { return 'threw: ' + e.message; }
      if (!p) return 'returned null';
      if (!(p.oz > 0)) return 'returned ' + JSON.stringify(p);
      return true;
    });
    t('the active dog has a usable figure', function () {
      var d = active();
      if (!d || d.weight_lb == null) return 'no weight on the active dog';
      var p = planFor(d);
      return p ? true : planWhy;
    });
    t('the age factor actually reaches the library', function () {
      if (!window.wynFeed || typeof window.wynFeed.maintenanceKcal !== 'function') return 'no library';
      var base = { weight_lb: 40, activity: 1.55, neuter: 'neutered' };
      var adult = window.wynFeed.maintenanceKcal(libProfile(
        { weight_lb: 40, activity: 1.55, neuter: 'neutered', age: 1 }));
      var senior = window.wynFeed.maintenanceKcal(libProfile(
        { weight_lb: 40, activity: 1.55, neuter: 'neutered', age: 0.9 }));
      if (!(adult > 0) || !(senior > 0)) return 'no figure';
      if (adult === senior) return 'age is being IGNORED - adult and senior both ' + adult;
      return Math.abs(senior / adult - 0.9) < 0.0001 ? true
        : 'senior/adult = ' + (senior / adult).toFixed(4) + ', expected 0.9';
    });
    t('the page figure matches what the bus would produce', function () {
      var d = active();
      if (!d || !d.weight_lb || !window.wynFeed || !window.wynProfile) return true;
      var a = planFor(d);
      if (!a) return planWhy;
      var bus = window.wynProfile.toPlan();
      var b2 = window.wynFeed.plan(bus, DIET, {});
      if (!b2) return 'bus profile produced nothing';
      if (a.oz === b2.oz) return true;
      var diff = [];
      ['weight_lb', 'age', 'activity', 'neuter'].forEach(function (k) {
        var x = d[k];
        /* the bus reports the age factor under ageFactor, not age */
        var y = (k === 'age') ? (bus.ageFactor != null ? bus.ageFactor : bus.age) : bus[k];
        if (String(x == null ? '' : x) !== String(y == null ? '' : y)) {
          diff.push(k + ': roster ' + JSON.stringify(x) + ' vs bus ' + JSON.stringify(y));
        }
      });
      return a.oz + ' vs ' + b2.oz + (diff.length ? '  [' + diff.join('; ') + ']' : '');
    });
    t('no flow-added item is offered for reorder', function () {
      var bad = ['dry ice', 'fresh start guide', 'feeding scale'];
      return lines().every(function (li) {
        var n = (li.querySelector('.wup-line__n') || {}).textContent || '';
        return bad.indexOf(n.toLowerCase().trim()) === -1;
      });
    });
    t('every reorder line has a real variant id', function () {
      return lines().every(function (li) { return /^\d+$/.test(li.dataset.vid || ''); });
    });
    t('every diet colour got a contrast-picked ink', function () {
      var els = root.querySelectorAll('.wup-pill[style*="--c"],.wup-dogtab[style*="--c"]');
      if (!els.length) return true;
      return Array.prototype.every.call(els, function (e) {
        var pi = e.style.getPropertyValue('--pi');
        return pi === '#2E2E2E' || pi === '#1A1A1A' || pi === '#FDFAE4';
      });
    });
    t('every tab has a panel', function () {
      return tabs.every(function (x) {
        return !!root.querySelector('[data-wup-panel="' + x.dataset.wupTab + '"]');
      });
    });
    t('exactly one tab is selected', function () {
      return tabs.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; }).length === 1;
    });
    t('localStorage is writable', function () {
      var k = 'wup_probe_' + Date.now();
      if (!lsSet(k, '1')) return false;
      lsDel(k);
      return true;
    });

    /* restore anything the probes touched */
    try { if (snap[LS_ROSTER] === null) lsDel(LS_ROSTER); else lsSet(LS_ROSTER, snap[LS_ROSTER]); } catch (e) {}

    var bad = T.filter(function (x) { return !x.ok; });
    var box = document.createElement('div');
    box.setAttribute('style', 'position:fixed;left:0;right:0;bottom:0;z-index:99999;max-height:60vh;' +
      'overflow:auto;padding:14px 16px;background:#2E2E2E;color:#FDFAE4;' +
      'font:600 12px/1.5 ui-monospace,Menlo,Consolas,monospace');
    var head = document.createElement('div');
    head.setAttribute('style', 'font-size:14px;margin-bottom:8px;color:' + (bad.length ? '#F15F59' : '#54BE90'));
    head.textContent = 'wup self test  ' + (T.length - bad.length) + '/' + T.length +
      (bad.length ? '  ' + bad.length + ' FAILED' : '  all clear');
    box.appendChild(head);
    T.forEach(function (x) {
      var r = document.createElement('div');
      r.style.color = x.ok ? 'rgba(253,250,228,.75)' : '#FFD820';
      r.textContent = (x.ok ? 'ok    ' : 'FAIL  ') + x.name + (x.note ? '   ' + x.note : '');
      box.appendChild(r);
    });
    document.body.appendChild(box);
    return T;
  }
  if (/[?&]wuptest=1/.test(location.search)) {
    if (document.readyState === 'complete') setTimeout(selfTest, 400);
    else window.addEventListener('load', function () { setTimeout(selfTest, 400); });
  }

  var lastRaven = null;

  window.wupDebug = {
    ravenLast: function () { return lastRaven; },
    changeLast: function () { return lastChange; },
    vetNameLast: function () { return lastVetName; },
    pickLast: function () { return lastPick; },
    requestLast: function () { return lastRequest; },
    ravenEmail: function () { return BOOT.customerEmail || '(none)'; },
    ravenSlot: function () {
      return { slots: BOOT.slots, active: active(), claimed: active() && active().slot,
               slot: slotFor(active()), allClaims: (R ? R.list.map(function (d) {
                 return { name: d.name, slot: d.slot }; }) : []) };
    },
    /* point the active dog at a specific account slot, to repair a mis-assignment */
    ravenSetSlot: function (n) {
      var d = active();
      if (!d) return 'no active dog';
      n = parseInt(n, 10);
      if (!(n >= 1 && n <= maxDogs())) return 'slot must be 1-' + maxDogs();
      var taken = claimedSlots(d.id);
      if (taken[n]) return 'slot ' + n + ' is already claimed by another dog';
      d.slot = n;
      saveRoster();
      return d.name + ' now writes to slot ' + n;
    },
    ravenFields: function () { return ravenFieldsFor(active(), slotFor(active())); },
    /* one real write of ONE field, for testing the wiring before turning it on */
    ravenTry: function (name, value) { return ravenPut(name, value); },
    test: selfTest,
    why: function () { planFor(active()); return planWhy || ('ok via ' + (planShape || 'dog-only')); },
    diets: function () {
      return { urls: String(BOOT.dietsUrls || '').split(',').filter(Boolean),
               tried: dietsTried, loadedFrom: dietsFrom, why: dietsWhy, matched: DIET,
               labels: dietLabels, looseMatch: dietFuzzy, wanted2: BOOT.dietTitle,
               raw: DIETS,
               wanted: BOOT.dietHandle || BOOT.dietTitle,
               sample: DIETS && (Object.prototype.toString.call(DIETS) === '[object Array]'
                        ? DIETS.slice(0, 2) : Object.keys(DIETS).slice(0, 12)) };
    },
    reload: loadDiets,
    /* Raven is what lets the storefront write customer metafields. The tokens
       are signed server-side by raven-mac-gen, so this reports the SHAPE of one
       definition rather than guessing at the request body. */
    raven: function () {
      if (!window.FieldsRaven) return 'FieldsRaven missing - is raven-js-variables rendered on this page?';
      var d = window.FieldsRaven.definitions || {};
      var keys = Object.keys(d);
      var sampleKey = d.dog_1_name !== undefined ? 'dog_1_name' : keys[0];
      return {
        endpoints: window.FieldsRaven.endpoints,
        definitionCount: keys.length,
        dogSlots: keys.filter(function (k) { return /^dog_\d+_name$/.test(k); }).length,
        sampleKey: sampleKey,
        sample: sampleKey ? d[sampleKey] : null,
        sampleType: sampleKey ? typeof d[sampleKey] : null,
        hasRxdate: keys.some(function (k) { return /rxdate/i.test(k); })
      };
    },
    shape: function () {
      if (!window.wynFeed) return 'wynFeed missing';
      var out = { keys: Object.keys(window.wynFeed) };
      try { out.planSource = String(window.wynFeed.plan); } catch (e) {}
      try { out.dietFactorSource = String(window.wynFeed.dietFactor); } catch (e) {}
      try { if (window.wynFeed.CFG) out.CFG = window.wynFeed.CFG; } catch (e) {}
      try { if (window.wynFeed.DIETS) out.DIETS = Object.keys(window.wynFeed.DIETS); } catch (e) {}
      return out;
    },
    tryPlan: function (o) {
      if (!window.wynFeed) return 'wynFeed missing';
      try { return window.wynFeed.plan(o || { weight_lb: 40, age: 1, activity: 1.2, neuter: 'neutered' }); }
      catch (e) { return 'threw: ' + e.message; }
    },
    roster: function () { return R ? JSON.parse(JSON.stringify(R)) : null; },
    active: active, living: living, memorials: memorials, plan: planFor,
    pick: pick, pillInk: pillInk, boot: BOOT,
    reset: function () { lsDel(LS_ROSTER); location.reload(); }
  };
})();